/* custom-bureau-v2.js — gedrag van de bureau-v2-koopblok (Task 4, functioneel-eerst, R-19).
 * Module-patroon, geen jQuery. Leunt op window.BureauV2Varianten (Task 3).
 *
 * Kern is de brief-code (Task 4-brief Step 4) 1-op-1 overgenomen: render(), kies(),
 * kiesOptie(), voegToe(), het selectors-contract (window.BureauV2). Toegevoegd:
 *   - de galerij (Step 5): alt-sleutel-filter, zelfde sitebrede conventie als de bestaande
 *     configuratorpagina (LEERLOG h89/h120: media.alt is een filtersleutel
 *     "<maat> + <blad> + <frame>", lowercase, "eerste match in POSITIEVOLGORDE wint" —
 *     hier vanilla JS i.p.v. de jQuery-versie in stane-product-inline.js);
 *   - de cart-drawer-aanroep, overgenomen van custom-stoel-v2-basis.js (ladeOpenen):
 *     wacht op 'on:cart:after-merge' op de cart-form in .js-cart-drawer, met een
 *     vangnet van 1200 ms, en negeert een al openstaande lade;
 *   - een eigen toast (koopblok heeft geen gedeeld .stoel-pdp-toast-element).
 */
/* interfaces.md decision #11 (Task 3): maten tonen als "120×60 cm" i.p.v. de kale Shopify-
 * waarde "120 x 60 cm" — geldt voor élke zichtbare tekst die een optiewaarde toont, ook na een
 * client-side re-render (render()/sync() hieronder overschrijven anders de SSR-tekst met de
 * kale waarde). Blad/frame-waarden bevatten geen " x " en blijven dus ongewijzigd. Losstaande
 * functie (i.p.v. binnen één IIFE) — de sticky-IIFE verderop in dit bestand heeft 'm ook nodig. */
function bv2WeergaveMaat(w) { return w ? String(w).replace(' x ', '×') : w; }

/* ---------- EENMALIGE UITVOERING (Task 10-herstelgolf) ----------
 * Stand sinds fase 6 S1 (J66): `custom-bureau-v2-band-kop.liquid` zet dit script alleen in de
 * eerste sectie van het template (section.index 1) en altijd in het koopblok (`altijd: true`,
 * eindfix 2), plus in elke los gerenderde sectie (theme-editor / Section Rendering API: index
 * leeg). Op de normale PDP staat het dus 1x in de DOM; na een editorwijziging van de volgorde
 * of in de editor kan het 2x of vaker staan, en een browser VOERT elk <script>-element uit.
 * Vóór S1 stond het in ÉLKE bandsectie (14x). Gevolg toen, gemeten op de dev-theme tijdens de
 * Task 10-herstelgolf:
 *   - één klik op "In winkelwagen" stuurde 14 POSTs naar /cart/add (14x in de winkelwagen);
 *   - élke toggle-knop klapte 14x om = netto niets: de setup-hotspots gingen niet open en de
 *     nieuwe "Lees meer"-knop deed niets.
 * De poorten zagen dit niet: de koopblok-poort toetste alleen de LAATSTE /cart/add-post (dat
 * telt zij nu wél, zie bv2_koopblok_poort.mjs), en de a11y-pas opende de hotspot met een
 * `.catch(() => {})`.
 * Vandaar deze guard: de body draait precies één keer per pagina — ook in de theme-editor, want
 * daar is 14x uitvoeren net zo fout (14 POSTs bij een testklik, toggles die niets doen).
 * BEWUSTE BEPERKING: rendert Shopify in de editor één sectie opnieuw, dan wordt die opnieuw
 * ingevoegde markup pas na een refresh bediend — er is geen `shopify:section:load`-hook (die
 * zou de hele init herbruikbaar moeten maken; buiten de scope van deze golf). */
if (!window.__bureauV2Geladen) {
  window.__bureauV2Geladen = true;

/* ---------- mobiel (spec §3.0): één paneel-helper voor elk "paneel van onderen" ----------
 * Gebruikt de native <dialog>.showModal() (focus-trap, Escape, inert). Voegt toe: pagina-vergrendeling
 * (html.bv2-paneel-open), terug-gebaar = sluiten (eigen history-state), backdrop-tik sluit, resize over
 * 990 sluit, focus terug naar de opener zonder scroll. Geen animatie (SB:474). Task 2 en Task 7 roepen
 * alleen window.bv2Paneel(dlg, opener) aan; de rest van deze IIFE is intern.
 * Eindfix 2: staat direct na de guard, dus vóór de sticky- en set-IIFE's die hem gebruiken (was een latere IIFE,
 * waardoor die hem pas bij de klik mochten opzoeken). Geen gedragswijziging. */
(function () {
  'use strict';
  var groot = window.matchMedia('(min-width: 990px)');
  var huidig = null;
  function sluitHuidig(viaHistory) {
    if (!huidig) return;
    var h = huidig; huidig = null;
    document.documentElement.classList.remove('bv2-paneel-open');
    if (h.dlg.open) h.dlg.close();
    if (!viaHistory && history.state && history.state.bv2Paneel) history.back();
    if (h.opener && document.contains(h.opener)) h.opener.focus({ preventScroll: true });
  }
  window.addEventListener('popstate', function () { if (huidig) sluitHuidig(true); });
  /* mobiel T12 (Review Focus 5): herlaadt de theme-editor een sectie terwijl haar paneel open staat, dan
   * verdwijnt de dialog uit de DOM en bleven html.bv2-paneel-open (overflow: hidden) en de history-staat
   * hangen. Bij unload van die sectie, of bij een load waarna de dialog losgekoppeld is: netjes sluiten. */
  function sectieWeg(e) {
    if (!huidig) return;
    var t = e && e.target;
    if (!document.contains(huidig.dlg) || (t && t.contains && t.contains(huidig.dlg))) sluitHuidig(false);
  }
  document.addEventListener('shopify:section:unload', sectieWeg);
  document.addEventListener('shopify:section:load', sectieWeg);
  var opGroot = function () { if (groot.matches && huidig) sluitHuidig(false); };
  if (groot.addEventListener) groot.addEventListener('change', opGroot); else if (groot.addListener) groot.addListener(opGroot);
  window.bv2Paneel = function (dlg, opener) {
    if (!dlg || typeof dlg.showModal !== 'function') return { sluit: function () {} };
    if (huidig && huidig.dlg !== dlg) sluitHuidig(false);
    huidig = { dlg: dlg, opener: opener || null };
    if (!dlg.__bv2Paneel) {
      dlg.__bv2Paneel = true;
      dlg.addEventListener('click', function (e) { if (e.target === dlg && huidig && huidig.dlg === dlg) sluitHuidig(false); });
      dlg.addEventListener('close', function () { if (huidig && huidig.dlg === dlg) sluitHuidig(false); });
      var s = dlg.querySelector('[data-bv2-paneel-sluit]');
      if (s) s.addEventListener('click', function () { sluitHuidig(false); });
    }
    document.documentElement.classList.add('bv2-paneel-open');
    history.pushState({ bv2Paneel: true }, '');
    if (!dlg.open) dlg.showModal();
    return { sluit: function () { if (huidig && huidig.dlg === dlg) sluitHuidig(false); } };
  };
  window.bv2IsMobiel = function () { return !groot.matches; };
})();

/* ---------- fase 5 J42: beeldwissel + keuze op een addon-kaart (globaal, binnen de guard) ----------
 * `bv2WisselBeeld(vak, src, src2x)`: generiek voor elk vak met één <img> (Task 5 gebruikt het ook
 * voor de set-kaart). Het nieuwe beeld komt als tweede <img> in hetzelfde vaste vak (CSS: beide
 * absoluut, geen layoutsprong), wordt pas ingevoegd ná decode() (geen flits), en krijgt een
 * crossfade van 150 ms op opacity; het oude verdwijnt daarna uit de DOM. Reduced motion: de CSS
 * zet de transitie uit, de wissel is dan direct. Snel na elkaar klikken: alleen de laatste
 * aanvraag wint (teller op het vak), dus er blijven nooit twee beelden staan. `src === ''` = geen
 * beeld (leeg wit vak); `src == null` = niets doen. Mislukt decode(), dan blijft het oude beeld.
 * `bv2KiesAddonKeuze(kaart, chip)`: één keuze (variant óf ander product) zet aria-pressed,
 * data-keuze, de plusknop-variant + aria-label, prijs, compare en het beeld. Een aria-disabled
 * keuze (uitverkocht) doet niets. Bedragen via V.formatEuro (centen uit Liquid, één bron). */
window.bv2WisselBeeld = function (vak, src, src2x) {
  if (!vak || src == null) return;
  src = String(src);
  var huidig = vak.__bv2Doel;
  if (huidig === undefined) { var eerste = vak.querySelector('img'); huidig = eerste ? (eerste.getAttribute('data-src') || null) : ''; }
  if (huidig === src) return;
  vak.__bv2Doel = src;
  var tok = vak.__bv2Tok = (vak.__bv2Tok || 0) + 1;
  var weg = function (lijst) {
    lijst.forEach(function (o) {
      o.classList.add('is-weg');
      setTimeout(function () { if (o.parentNode) o.parentNode.removeChild(o); }, 200);
    });
  };
  /* fix-ronde 1 (5): geen beeld (product zonder foto, bv. de luxe lamp vlak na activatie) = leeg wit vak */
  if (src === '') { weg([].slice.call(vak.querySelectorAll('img'))); return; }
  /* fix-ronde 1 (1): kloon het bestaande img, zodat haken (data-*, klassen, alt, maten) meegaan;
     alleen de bron- en toestandsattributen worden vervangen. Lazy-loading eraf: een losgekoppeld
     lazy-img laadt niet, en decode() zou dan blijven hangen. */
  var basis = vak.querySelector('img:not(.is-weg)') || vak.querySelector('img');
  var nieuw;
  if (basis) {
    nieuw = basis.cloneNode(false);
    ['srcset', 'sizes', 'loading', 'fetchpriority', 'id'].forEach(function (a) { nieuw.removeAttribute(a); });
    nieuw.classList.remove('is-weg');
  } else {
    nieuw = document.createElement('img');
    nieuw.alt = ''; nieuw.draggable = false;
  }
  nieuw.decoding = 'async';
  nieuw.setAttribute('data-src', src);
  if (src2x) nieuw.srcset = src + ' 1x, ' + src2x + ' 2x';
  nieuw.src = src;
  nieuw.classList.add('is-nieuw');
  var klaar = function () {
    if (vak.__bv2Tok !== tok) return; /* een latere keuze heeft het overgenomen */
    var oude = [].slice.call(vak.querySelectorAll('img'));
    vak.appendChild(nieuw);
    /* fase 6 S3 (J66): loading='lazy' pas ná de append zetten, niet vooraf — decode() draait op een
       losgekoppeld element (zie hierboven) en zou met loading='lazy' al aan blijven hangen. Op dit
       punt is de decode al geslaagd, dus dit ijkt alleen het attribuut op de al-geladen afbeelding
       (geen hertransport, geen gedragsverandering); een toets op de DOM-staat na de wissel ziet zo
       terecht 'lazy' i.p.v. een leeg attribuut. */
    nieuw.setAttribute('loading', 'lazy');
    void nieuw.offsetWidth; /* stijl vastleggen op opacity 0, anders geen transitie */
    nieuw.classList.remove('is-nieuw');
    weg(oude);
  };
  /* fix-ronde 1 (6): decode mislukt (kapot/onbereikbaar beeld) = het oude beeld blijft staan; het doel
     wordt teruggezet, zodat een volgende klik op dezelfde keuze het opnieuw probeert. */
  var mislukt = function () { if (vak.__bv2Tok === tok) vak.__bv2Doel = undefined; };
  if (nieuw.decode) nieuw.decode().then(klaar, mislukt);
  else { nieuw.onload = klaar; nieuw.onerror = mislukt; }
};
window.bv2KiesAddonKeuze = function (kaart, chip) {
  if (!kaart || !chip || chip.getAttribute('aria-disabled') === 'true') return;
  var V = window.BureauV2Varianten;
  [].forEach.call(kaart.querySelectorAll('[data-bv2-addon-keuze]'), function (c) { c.setAttribute('aria-pressed', String(c === chip)); });
  kaart.setAttribute('data-keuze', chip.getAttribute('data-keuze'));
  var add = kaart.querySelector('button[data-bv2-add]');
  if (add) {
    add.setAttribute('data-bv2-add', chip.getAttribute('data-id'));
    add.setAttribute('aria-label', (chip.getAttribute('data-naam') || '') + ' toevoegen aan winkelwagen');
    add.removeAttribute('aria-disabled');
  }
  var prijs = Number(chip.getAttribute('data-prijs')), cmp = Number(chip.getAttribute('data-compare') || 0);
  var nu = kaart.querySelector('[data-bv2-addon-nu]'); if (nu && V) nu.textContent = V.formatEuro(prijs);
  var c = kaart.querySelector('[data-bv2-addon-compare]');
  if (c) { c.hidden = !(cmp > prijs); c.textContent = (cmp > prijs && V) ? V.formatEuro(cmp) : ''; }
  window.bv2WisselBeeld(kaart.querySelector('.bv2-addon__beeld'), chip.getAttribute('data-beeld'), chip.getAttribute('data-beeld-2x'));
};

/* ---------- fase 5 J49: beweging zonder zichtbare knop, wél WCAG 2.2.2 (spec §2, §3.8) ----------
 * `bv2Beweging(band, { rail, opWissel })` → `{ stil() }`. Vier mechanismen:
 * (1) prefers-reduced-motion = stil, ook bij wisselen tijdens het bezoek (matchMedia-change);
 * (2) hover op de rail (per band uit te zetten met `hover: false`, UGC sinds iteratie 30-09; alleen bij een écht pointer-delta, MOTION-GIDS 3b: de eerste pointermove na
 *     binnenkomst legt alleen de positie vast, zodat een stilstaande muis onder een voorbij-scrollende
 *     band niet pauzeert) en toetsenbordfocus ergens in de BAND (fix-ronde 1, ruling: spec §2 "focus
 *     in de band"; de stopknop zelf telt niet, die heeft zijn eigen toestand). Pointerfocus telt niet:
 *     een muisklik op de (tabindex=0) rail zou de band anders blijven vasthouden en de tweede klik
 *     (= hervat) zou niets doen; de muis heeft hover al;
 * (3) klik/tik op de rail zet blijvend stil, nog eens = verder (tikdrempel 12 px / 500 ms, zodat
 *     vegen niet telt; niet op links/knoppen in de kaart);
 * (4) verborgen stopknop (`[data-bv2-beweging-stop]`, snippet custom-bureau-v2-beweging-stop) als
 *     eerste element van de band, zichtbaar bij :focus-visible; het label wisselt (stoppen/hervatten)
 *     en de status gaat naar `[data-bv2-beweging-status][aria-live=polite]`. Geen aria-pressed
 *     (eindfix 2): label-wissel + pressed gaf "Beweging hervatten, toggle, pressed" — dubbelop.
 * `opWissel(stil)` krijgt élke toestandswissel; de band beslist zelf wat stil/verder betekent.
 * Eén aanroep per band: de knop krijgt hier zijn enige click-handler.
 * Verbeter 29-09 D6 (fixronde 1): optioneel `opts.tijdelijk`, een getal (ms) of een functie die het op het moment
 * zelf geeft (0 = uit; UGC: 4000 < 990, 0 ≥ 990). Dan zet een horizontale VEEG (iteratie 30-09: niet meer elke touch-/pen-
 * `pointerdown`) een tijdelijke stilstand (`st.aanraking`) die pas `tijdelijk` ms na het laatste scroll-event vervalt en alleen
 * als er geen vinger meer op de rail ligt. Een tik is geen veeg: die heft de tijdelijke stilstand meteen op en doet wat mechanisme 3 zegt
 * (rail = blijvend stil/verder, ook op touch). Zonder de optie is het gedrag exact gelijk. `stop()` (retour) zet
 * dezelfde blijvende stilstand als de stopknop. */
/* WCAG 2.4.11 (focus niet bedekt): de browser scrolt een gefocust element dat al "in beeld" staat
 * niet, ook niet als de sticky siteheader (70 px) of de vaste bestelbalk erover ligt. Gemeten: de
 * stopknop viel na Shift+Tab onder de header bij een band bovenaan het scherm. Hier: ligt er een
 * vaste/sticky laag over de boven- of onderrand, dan precies zoveel scrollen dat hij vrij ligt
 * (+16 px lucht). Direct (instant), zodat de theme-smooth-scroll niet na-ijlt (h185). */
var bv2NietBedekt = function (el) {
  try { if (!el.matches(':focus-visible')) return; } catch (x) {}
  var r = el.getBoundingClientRect();
  function laag(x, y) {
    if (y < 0 || y >= window.innerHeight) return null;
    var o = document.elementFromPoint(x, y);
    while (o && o !== document.body && o !== el && !el.contains(o)) {
      var p = getComputedStyle(o).position;
      if (p === 'fixed' || p === 'sticky') return o.getBoundingClientRect();
      o = o.parentElement;
    }
    return null;
  }
  var boven = laag(r.left + 4, r.top + 4), onder = laag(r.left + 4, r.bottom - 4);
  if (boven) window.scrollBy({ top: -(boven.bottom - r.top + 16), behavior: 'instant' });
  else if (onder) window.scrollBy({ top: r.bottom - onder.top + 16, behavior: 'instant' });
};
window.bv2Beweging = function (band, opts) {
  var rail = opts.rail || band;
  var knop = band.querySelector('[data-bv2-beweging-stop]');
  var status = band.querySelector('[data-bv2-beweging-status]');
  var mq = window.matchMedia('(prefers-reduced-motion: reduce)');
  var st = { gebruiker: false, hover: false, focus: false, rustig: mq.matches, aanraking: false };
  var laatste = null, neer = null;
  function stil() { return st.gebruiker || st.hover || st.focus || st.rustig || st.aanraking; }
  function meld() { opts.opWissel(stil()); }
  function toetsFocus(el) {
    if (!el || el === knop || !band.contains(el)) return false;
    try { return el.matches(':focus-visible'); } catch (x) { return true; }
  }
  function zetGebruiker(w) {
    st.gebruiker = w;
    if (knop) {
      knop.textContent = w ? knop.getAttribute('data-label-hervat') : knop.getAttribute('data-label-stop');
    }
    if (status && knop) status.textContent = w ? knop.getAttribute('data-status-stil') : knop.getAttribute('data-status-loopt');
    meld();
  }
  if (knop) {
    knop.hidden = false;
    knop.addEventListener('click', function () { zetGebruiker(!st.gebruiker); });
    knop.addEventListener('focus', function () { setTimeout(function () { bv2NietBedekt(knop); }, 0); });
  }
  rail.addEventListener('pointermove', function (e) {
    if (opts.hover === false || e.pointerType !== 'mouse') return; /* iteratie 30-09 (F5): `hover: false` = deze band pauzeert niet bij hover (UGC) */
    if (!laatste) { laatste = { x: e.clientX, y: e.clientY }; return; } /* eerste event: alleen vastleggen */
    if (Math.abs(e.clientX - laatste.x) < 2 && Math.abs(e.clientY - laatste.y) < 2) return;
    laatste = { x: e.clientX, y: e.clientY };
    if (!st.hover) { st.hover = true; meld(); }
  });
  rail.addEventListener('pointerleave', function () { laatste = null; if (st.hover) { st.hover = false; meld(); } });
  rail.addEventListener('pointerdown', function (e) {
    if (e.button !== undefined && e.button !== 0) { neer = null; return; }
    neer = { x: e.clientX, y: e.clientY, t: Date.now() };
  });
  rail.addEventListener('pointercancel', function () { neer = null; });
  /* verbeter 29-09 D6 + fixronde 1: tijdelijke stilstand bij VEGEN (touch/pen), alleen als `opts.tijdelijk()` op het moment
     zelf > 0 is (UGC: < 990, dus een tablet die draait wisselt mee). De klok van `tijdelijk` ms loopt pas als er geen vinger
     meer op de rail ligt (touchstart/-end/-cancel, passief: `pointercancel` vuurt al bij het BEGIN van een pan en daarna
     komen er geen pointer-events meer) en begint bij elk scroll-event van de rail opnieuw (doorrollen; ook WebKit zonder
     `scrollend`). Een tik is geen veeg: zie pointerup hieronder. Blijvend stoppen: de stopknop of een tik op de rail. */
  var vingers = 0, klok = null;
  function tijdelijk() { var t = opts.tijdelijk; return typeof t === 'function' ? t() : (t || 0); }
  function klokAls() {
    if (!st.aanraking || vingers) return;
    clearTimeout(klok);
    klok = setTimeout(function () { klok = null; if (st.aanraking && !vingers) { st.aanraking = false; meld(); } }, tijdelijk() || 4000);
  }
  if (opts.tijdelijk) {
    var tel = function (e) { vingers = [].filter.call(e.touches || [], function (t) { return rail.contains(t.target); }).length; };
    /* iteratie 30-09 (F5, Jory: "wanneer je over ugc heen hoovert moet de carrousel niet stoppen", ook mobiel; AFWIJKINGEN #205): een
       vinger die de pagina verticaal scrollt of stil op de band rust, pauzeert niet meer (was: elke touch-/pen-pointerdown). Alleen een
       echte horizontale veeg (> 8 px en meer horizontaal dan verticaal) zet de tijdelijke stilstand (D6); het hervatten (klokAls,
       `tijdelijk` ms na de laatste vinger/scroll) is ongewijzigd. Touch via touchmove (pointer-events stoppen bij het begin van een
       pan, h225), pen via pointermove. De eigen scroll van `veegOmzetten` (scrollLeft → 0) start dus geen nieuwe stilstand. */
    var begin = null;
    var veegStart = function (x, y) { begin = { x: x, y: y }; };
    var veegMisschien = function (x, y) {
      if (!begin || st.aanraking || !tijdelijk()) return;
      var dx = Math.abs(x - begin.x), dy = Math.abs(y - begin.y);
      if (dx > 8 && dx > dy) { clearTimeout(klok); st.aanraking = true; meld(); }
    };
    rail.addEventListener('touchstart', function (e) { tel(e); clearTimeout(klok); var t = e.touches && e.touches[0]; if (t) veegStart(t.clientX, t.clientY); }, { passive: true });
    rail.addEventListener('touchmove', function (e) { var t = e.touches && e.touches[0]; if (t) veegMisschien(t.clientX, t.clientY); }, { passive: true });
    rail.addEventListener('pointerdown', function (e) { if (e.pointerType === 'pen') veegStart(e.clientX, e.clientY); });
    /* review golf 1 M-1: alleen een pen die de rail raakt (buttons & 1) veegt; een zwevende pen (hover) niet, en na loslaten begint
       een nieuwe veeg pas bij een nieuwe aanraking (anders zette een zwevende pen na een eerdere vingertik de band eindeloos stil). */
    rail.addEventListener('pointermove', function (e) { if (e.pointerType === 'pen' && (e.buttons & 1)) veegMisschien(e.clientX, e.clientY); });
    var veegEind = function () { begin = null; };
    rail.addEventListener('touchend', veegEind, { passive: true }); rail.addEventListener('touchcancel', veegEind, { passive: true });
    rail.addEventListener('pointerup', veegEind); rail.addEventListener('pointercancel', veegEind);
    rail.addEventListener('touchend', function (e) { tel(e); klokAls(); }, { passive: true });
    rail.addEventListener('touchcancel', function (e) { tel(e); klokAls(); }, { passive: true });
    rail.addEventListener('pointerup', klokAls); rail.addEventListener('pointercancel', klokAls); /* pen: geen touch-events */
    rail.addEventListener('scroll', klokAls, { passive: true }); rail.addEventListener('scrollend', klokAls);
  }
  rail.addEventListener('pointerup', function (e) {
    var n = neer; neer = null;
    if (!n) return;
    var tik = Math.abs(e.clientX - n.x) < 12 && Math.abs(e.clientY - n.y) < 12 && Date.now() - n.t < 500;
    /* fixronde 1: een tik is geen veeg, dus de tijdelijke stilstand vervalt meteen, zonder melding: wat de tik doet beslist de
       rest (een kaart-knop zet de band blijvend stil en speelt zijn video, een tik op de rail zet blijvend stil of verder). */
    if (tik && st.aanraking) { st.aanraking = false; clearTimeout(klok); }
    if (e.target.closest && e.target.closest('a, button, [role="button"], video[controls]')) return;
    if (tik) zetGebruiker(!st.gebruiker);
  });
  band.addEventListener('focusin', function (e) { var b = toetsFocus(e.target); if (st.focus !== b) { st.focus = b; meld(); } });
  band.addEventListener('focusout', function () {
    setTimeout(function () { var b = toetsFocus(document.activeElement); if (st.focus !== b) { st.focus = b; meld(); } }, 0);
  });
  var mqWissel = function () { st.rustig = mq.matches; meld(); };
  if (mq.addEventListener) mq.addEventListener('change', mqWissel); else if (mq.addListener) mq.addListener(mqWissel);
  /* fixronde 1: `stop()` = dezelfde blijvende stilstand als de stopknop (label "hervatten", status "gestopt"), voor een band
     die een eigen blijvende stop heeft (UGC < 990: tik op een kaart speelt die video, J72). Nog eens = no-op. */
  /* iteratie 30-09 (D5-notitie Jory: "de autoplay moet bij de filmpjes door blijven gaan en op repeat"): `stilVoorVideo()` is de
     stilstand zonder de tijdelijke veeg-pauze. Een band die dat wil (UGC) laat zijn video's doorspelen terwijl alleen de marquee
     wacht; blijvende stops (stopknop, klik, toetsenbordfocus, minder beweging) gelden voor beide. */
  return { stil: stil, stilVoorVideo: function () { return st.gebruiker || st.hover || st.focus || st.rustig; }, stop: function () { if (!st.gebruiker) zetGebruiker(true); } };
};

/* ---------- fase 5 J49: klik-om-te-spelen zonder icoon (terugval bij "minder beweging" e.d.) ----------
 * Het vak zelf wordt de knop (role=button, tabindex 0; cursor pointer in de CSS); klik, Enter of
 * spatie maakt via `maak()` een <video controls> en speelt hem. Daarna is het vak weer een gewoon vak:
 * de bediening zit in de native controls van de video. Het schermlezerlabel komt uit de sectie-setting
 * `beweging_afspelen_sjabloon` (default "[label] afspelen", `data-label-afspelen` op de stopknop van
 * de band) met het merchant-videolabel (`data-video-label`) op [label]. Geen label = geen aria-label:
 * dan draagt de inhoud (poster-alt) de naam, geen verzonnen klanttekst in de code. */
/* ---------- BUG 30-09 (melding Jory: bij iemand anders toonde de UGC-band "geen video's"; AFWIJKINGEN #206) ----------
 * Eén gedeelde plek voor elke AUTOMATISCHE play(). Blokkeert de browser autoplay (iOS-energiebesparing, "nooit automatisch
 * afspelen" in Safari/Firefox, bedrijfsbeleid), dan wijst play() af met NotAllowedError. Vijf plekken slikten dat in: er speelde
 * dan nergens iets, de UGC schoof met stilstaande posters door en op desktop was een UGC-video zelfs met een klik niet te starten
 * (gereproduceerd: scripts/bv2_video_diagnose.mjs, sim-*-geenautoplay). Nu zet de eerste NotAllowedError één paginabrede toestand
 * (`html.bv2-geen-autoplay`) en schakelt elke band over naar klik-om-af-te-spelen (dezelfde stand als "minder beweging"; de klik
 * is een gebaar, dat mag altijd). Andere afwijzingen (AbortError: play onderbroken door pause/load) zijn normaal: genegeerd.
 * `speel()` probeert niets meer zodra de toestand gezet is (null). Een play() die de bezoeker zelf start (bv2SpeelBijKlik) loopt
 * hier niet door. */
window.bv2Autoplay = (function () {
  var geblokkeerd = false, wachtend = [];
  function blokkeer() {
    if (geblokkeerd) return;
    geblokkeerd = true;
    document.documentElement.classList.add('bv2-geen-autoplay');
    var lijst = wachtend; wachtend = [];
    lijst.forEach(function (fn) { try { fn(); } catch (x) {} });
  }
  return {
    speel: function (v) {
      if (geblokkeerd || !v) return null;
      var p = null;
      try { p = v.play(); } catch (x) { return null; }
      if (p && p.then) p.then(null, function (e) { if (e && e.name === 'NotAllowedError') blokkeer(); });
      return p;
    },
    geblokkeerd: function () { return geblokkeerd; },
    opGeblokkeerd: function (fn) { if (geblokkeerd) fn(); else wachtend.push(fn); }
  };
})();

window.bv2SpeelBijKlik = function (vak, maak) {
  var label = vak.getAttribute('data-video-label') || '';
  var bron = (vak.closest('[data-band]') || document).querySelector('[data-bv2-beweging-stop]');
  var sjabloon = (bron && bron.getAttribute('data-label-afspelen')) || '[label]';
  vak.setAttribute('role', 'button');
  vak.setAttribute('tabindex', '0');
  if (label) vak.setAttribute('aria-label', sjabloon.replace('[label]', label));
  function start(e) {
    if (vak.getAttribute('role') !== 'button') return;
    if (e && e.type === 'keydown') {
      if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
      e.preventDefault();
    }
    var v = vak.querySelector('video') || maak();
    if (!v) return;
    vak.removeAttribute('role'); vak.removeAttribute('tabindex'); vak.removeAttribute('aria-label');
    v.controls = true; v.tabIndex = 0;
    var p = v.play(); if (p && p['catch']) p['catch'](function () {});
    v.focus({ preventScroll: true });
  }
  vak.addEventListener('click', start);
  vak.addEventListener('keydown', start);
};

(function () {
  'use strict';
  var doc = document;
  var V = window.BureauV2Varianten;
  var wortel = doc.querySelector('[data-bv2-product]');
  if (!V || !wortel) return;
  /* T8 fix 1: `classList.add('js')` hier weggehaald — zinloos. Symmetry zet die klasse zelf in een
   * blokkerend head-script (theme/layout/theme.liquid r176, `no-js` -> `js`), dus hij staat er al
   * lang voordat dit `defer`-script draait, en geen enkele bv2-regel hangt er nog aan: de
   * reveal-poort is `.bv2-js` en die zet de reveal-IIFE onderaan zelf. */
  doc.body.classList.add('bv2-pagina');

  var data = JSON.parse(wortel.querySelector('[data-bv2-productdata]').textContent);
  var matrix = V.bouwMatrix(data.varianten);
  var volgorde = (data.volgorde && data.volgorde.length ? data.volgorde : V.volgorde(data));
  var luisteraars = [];
  var selectie = (function () {
    var id = Number(wortel.querySelector('form[data-bv2-form] input[name="id"]').value);
    var match = data.varianten.filter(function (v) { return v.id === id; })[0];
    return (match || data.varianten[0]).opties.slice();
  })();

  /* ---------- toast ---------- */
  var toastEl = wortel.querySelector('[data-bv2-toast]');
  var toastT = null;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('is-in');
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('is-in'); }, 3400);
  }

  /* ---------- galerij (Step 5) ---------- */
  var galerij = wortel.querySelector('[data-bv2-galerij]');
  function galerijSleutel() { return selectie.join(' + ').toLowerCase(); }
  function galerijBijwerken() {
    if (!galerij) return;
    /* fase 6 J58 (spec §3.3): de keuze zelf is puur en unit-getest (BureauV2Varianten.galerijKeuze).
     * De vaste hero-slide (data-bv2-vast) hoort alleen bij zijn eigen blad + frame (data-hero-sleutel);
     * bij elke andere kleur is de eerste match in positievolgorde het hoofdbeeld (index [0]).
     * Leeg data-hero-sleutel = hero altijd vooraan (oud gedrag). Geen match = alle niet-vaste slides
     * (vangnet, nooit alleen de hero; zie code-review fix-ronde 1, Critical 1). Verborgen slides en
     * niet-actieve slides zijn display:none, dus hun lazy <img> downloadt niets. */
    var alleSlides = Array.prototype.slice.call(galerij.querySelectorAll('[data-bv2-slide]'));
    var hero = galerij.querySelector('[data-bv2-vast]');
    var heroSleutel = hero ? (hero.getAttribute('data-hero-sleutel') || '') : '';
    var idx = V.galerijKeuze(alleSlides.map(function (el) {
      return { alt: el.getAttribute('data-alt') || '', vast: el.hasAttribute('data-bv2-vast') };
    }), galerijSleutel(), heroSleutel, (selectie[volgorde[0]] || '') + ' + ' + (selectie[volgorde[1]] || ''));
    var zichtbaar = idx.map(function (i) { return alleSlides[i]; });
    alleSlides.forEach(function (el) {
      el.hidden = zichtbaar.indexOf(el) === -1;
      el.setAttribute('aria-current', 'false');
    });
    if (zichtbaar[0]) zichtbaar[0].setAttribute('aria-current', 'true');
    galerijAltBijwerken(zichtbaar);
    galerijDuimenBijwerken(zichtbaar);
    galerij.dataset.actieveIndex = '0';
    /* mobiel J68 (J58 blijft): na een kleurwissel direct (zonder animatie) naar foto 1 van de nieuwe set. */
    if (hoofdG) { laterMarkeren(); stippenBouwen(); naarActief('auto'); }
  }
  /* fase 6 J58: alt = sjabloon (data-alt-sjabloon op de galerij, sectie-setting galerij_alt_sjabloon),
   * nooit de filtersleutel. Zelfde invulling als de Liquid: blad en frame lowercase. De hero houdt
   * zijn eigen alt (producttitel). */
  function galerijAltBijwerken(zichtbaar) {
    var sj = galerij.getAttribute('data-alt-sjabloon'); if (!sj) return;
    var vul = function (t, code, waarde) { return t.split(code).join(waarde); };
    var t = vul(sj, '[product]', galerij.getAttribute('data-product') || '');
    t = vul(t, '[blad]', String(selectie[volgorde[0]] || '').toLowerCase());
    t = vul(t, '[frame]', String(selectie[volgorde[1]] || '').toLowerCase());
    t = vul(t, '[maat]', String(selectie[data.maatIndex] || ''));
    zichtbaar.forEach(function (el) {
      if (el.hasAttribute('data-bv2-vast')) return;
      var im = el.querySelector('img'); if (im) im.alt = t;
    });
  }
  /* bevinding 1: duimen laden nu de 1200px-hoofdafbeelding — hier klein trekken (width=160,
     image_url-equivalent) i.p.v. een volle foto voor een 64x64px duim. */
  /* Keuringsronde 1: duim-URL-breedte = 2x de CSS-maat (retina), zelfde 990px-breakpoint als de
   * CSS (was een vaste 160 die noch de mobiele 62px noch de desktop 164px-nagel dekte). */
  function galerijDuimUrl(src) {
    try {
      var u = new URL(src, doc.baseURI);
      var duimCssBreedte = window.matchMedia('(min-width: 990px)').matches ? 64 : 62; /* fase 4: duimrail 64 px (was 164 onder het vlak) */
      u.searchParams.set('width', String(duimCssBreedte * 2));
      return u.toString();
    } catch (e) { return src; }
  }
  function galerijDuimenBijwerken(zichtbaar) {
    var duimenBox = galerij.querySelector('[data-bv2-galerij-duimen]');
    if (!duimenBox) return;
    duimenBox.innerHTML = '';
    zichtbaar.forEach(function (slide, i) {
      var img = slide.querySelector('img');
      var b = doc.createElement('button');
      b.type = 'button';
      b.className = 'bv2-duim bv2-hover-lift'; /* fase 3 J20: klikbaar -> hover-lift (de tegel heeft overflow:hidden, dus alleen de -2px-lift, geen ::after-schaduw; AFWIJKINGEN.md #110) */
      b.setAttribute('aria-label', 'Foto ' + (i + 1));
      b.setAttribute('aria-current', i === 0 ? 'true' : 'false');
      b.dataset.bv2GalerijIndex = String(i);
      if (img) { var t = doc.createElement('img'); t.src = galerijDuimUrl(img.currentSrc || img.src); t.alt = ''; t.loading = 'lazy'; b.appendChild(t); }
      duimenBox.appendChild(b);
    });
  }
  function galerijZichtbareSlides() {
    if (!galerij) return [];
    return Array.prototype.slice.call(galerij.querySelectorAll('[data-bv2-slide]')).filter(function (el) { return !el.hidden; });
  }
  function galerijGaNaar(index) {
    var zichtbaar = galerijZichtbareSlides();
    if (!zichtbaar.length) return;
    var n = ((index % zichtbaar.length) + zichtbaar.length) % zichtbaar.length;
    zichtbaar.forEach(function (el, i) { el.setAttribute('aria-current', String(i === n)); });
    galerij.dataset.actieveIndex = String(n);
    var duimenBox = galerij.querySelector('[data-bv2-galerij-duimen]');
    if (duimenBox) Array.prototype.slice.call(duimenBox.children).forEach(function (b, i) { b.setAttribute('aria-current', String(i === n)); });
    /* fase 4 J32: de duimrail is verticaal en scrolt intern — de actieve duim in beeld houden zonder de
       pagina te verschuiven (geen scrollIntoView: dat zou de sticky galerij/pagina meenemen). */
    if (duimenBox && duimenBox.children[n]) {
      var d = duimenBox.children[n], top = d.offsetTop, onder = top + d.offsetHeight;
      if (top < duimenBox.scrollTop) duimenBox.scrollTop = top;
      else if (onder > duimenBox.scrollTop + duimenBox.clientHeight) duimenBox.scrollTop = onder - duimenBox.clientHeight;
    }
    /* mobiel J68: stippen bijwerken; staat de swiper nog niet op deze slide (pijl), dan scrolt hij erheen. */
    if (hoofdG) {
      stippenBouwen();
      if (!mqG.matches) galerijLos();
      if (!mqG.matches && Math.round(hoofdG.scrollLeft / Math.max(1, hoofdG.clientWidth)) !== n) {
        naarActief(window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth');
      }
    }
  }
  if (galerij) {
    var vorige = galerij.querySelector('[data-bv2-galerij-vorige]');
    var volgende = galerij.querySelector('[data-bv2-galerij-volgende]');
    if (vorige) vorige.addEventListener('click', function () { galerijGaNaar(Number(galerij.dataset.actieveIndex || 0) - 1); });
    if (volgende) volgende.addEventListener('click', function () { galerijGaNaar(Number(galerij.dataset.actieveIndex || 0) + 1); });
    galerij.addEventListener('click', function (e) {
      var duim = e.target.closest('[data-bv2-galerij-index]');
      if (duim) galerijGaNaar(Number(duim.dataset.bv2GalerijIndex));
    });
  }
  /* mobiel J68 (spec §3.2): < 990 is .bv2-galerij__hoofd een native scroll-snap-swiper; de gesnapte slide
   * (IntersectionObserver, drempel 0,6) is de actieve. galerij.dataset.actieveIndex blijft de waarheid.
   * Tijdens een programmatische scroll (pijl, omloop) negeert de observer tussenliggende slides tot de
   * doelslide in beeld is of de scroll stilvalt (scrollend, vangnet 1500 ms), anders breekt een lange
   * sprong halverwege af. Desktop (>= 990): alleen de (verborgen) stippen worden gevuld, verder niets. */
  var mqG = window.matchMedia('(min-width: 990px)');
  var hoofdG = galerij && galerij.querySelector('.bv2-galerij__hoofd');
  var stippenG = galerij && galerij.querySelector('[data-bv2-galerij-stippen]');
  var doelG = null, doelT = null;
  function stippenBouwen() {
    var z = galerijZichtbareSlides(), a = Number(galerij.dataset.actieveIndex || 0), i;
    for (i = 0; i < z.length; i++) { z[i].setAttribute('role', 'group'); z[i].setAttribute('aria-label', 'Foto ' + (i + 1) + ' van ' + z.length); }
    if (!stippenG) return;
    stippenG.innerHTML = '';
    if (z.length > 9) {
      var t = doc.createElement('span'); t.className = 'bv2-galerij__teller'; t.textContent = (a + 1) + ' / ' + z.length;
      stippenG.appendChild(t); return;
    }
    for (i = 0; i < z.length; i++) {
      var s = doc.createElement('span'); s.className = 'bv2-galerij__stip' + (i === a ? ' is-actief' : '');
      stippenG.appendChild(s);
    }
  }
  /* spec §4 (beeldbytes 390): tot de eerste interactie toont de mobiele CSS alleen zichtbare slide 1 en 2
   * (slides vanaf de derde: data-bv2-later, server-side gezet), anders downloadt de lazy-load-marge meteen
   * 4 buurslides. Eerste aanraking/scroll/pijl/toets = .is-los: alle slides doen mee. */
  function laterMarkeren() {
    var los = galerij.classList.contains('is-los'), z = galerijZichtbareSlides();
    Array.prototype.forEach.call(galerij.querySelectorAll('[data-bv2-slide]'), function (s) {
      var i = z.indexOf(s);
      if (!los && i >= 2) s.setAttribute('data-bv2-later', ''); else s.removeAttribute('data-bv2-later');
    });
  }
  function galerijLos() {
    if (galerij.classList.contains('is-los')) return;
    galerij.classList.add('is-los');
    laterMarkeren();
  }
  function doelLos() {
    clearTimeout(doelT); doelT = null; doelG = null;
    if (!hoofdG || mqG.matches) return;
    var n = Math.round(hoofdG.scrollLeft / Math.max(1, hoofdG.clientWidth));
    if (String(n) !== galerij.dataset.actieveIndex) galerijGaNaar(n);
  }
  function naarActief(gedrag) {
    if (!hoofdG || mqG.matches) return;
    var a = Number(galerij.dataset.actieveIndex || 0), links = a * hoofdG.clientWidth;
    if (gedrag === 'smooth' && Math.abs(hoofdG.scrollLeft - links) > 1) {
      doelG = a; clearTimeout(doelT); doelT = setTimeout(doelLos, 1500);
    }
    hoofdG.scrollTo({ left: links, behavior: gedrag });
  }
  function galerijMqWissel() {
    if (!hoofdG) return;
    if (mqG.matches) { hoofdG.removeAttribute('tabindex'); doelG = null; clearTimeout(doelT); }
    else {
      /* fixronde 1 T4: op desktop kan elke foto actief zijn (duim), terwijl slides vanaf de derde nog
       * data-bv2-later dragen. Eerst de volle set in de layout (galerijLos), anders klemt scrollTo op 2
       * slides en landt de swiper op een lagere foto dan index/aria-current/teller zeggen. */
      hoofdG.setAttribute('tabindex', '0');
      if (Number(galerij.dataset.actieveIndex || 0) >= 2) galerijLos();
      stippenBouwen();
      naarActief('auto');
    }
  }
  if (hoofdG) {
    if ('IntersectionObserver' in window) {
      var snapIO = new IntersectionObserver(function (es) {
        if (mqG.matches) return;
        es.forEach(function (e) {
          /* keuringfix v2 #11: een slide zonder breedte (galerij even ingeklapt tijdens een kleurwissel)
           * telt als ratio 1; zo'n meldingen negeren, anders "wint" de laatste slide. */
          if (!e.isIntersecting || e.intersectionRatio < 0.6 || !e.boundingClientRect.width) return;
          var n = galerijZichtbareSlides().indexOf(e.target);
          if (n < 0) return;
          if (doelG !== null) { if (n === doelG) { clearTimeout(doelT); doelT = null; doelG = null; } return; }
          if (String(n) !== galerij.dataset.actieveIndex) galerijGaNaar(n);
        });
      }, { root: hoofdG, threshold: [0.6] });
      Array.prototype.forEach.call(galerij.querySelectorAll('[data-bv2-slide]'), function (s) { snapIO.observe(s); });
    }
    hoofdG.addEventListener('scrollend', function () { if (doelG !== null) doelLos(); });
    ['touchstart', 'pointerdown', 'scroll'].forEach(function (t) {
      hoofdG.addEventListener(t, function () { if (!mqG.matches) galerijLos(); }, { passive: true });
    });
    /* toetsenbord (spec §3.2): pijltjestoetsen op de container */
    hoofdG.addEventListener('keydown', function (e) {
      if (mqG.matches || (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight')) return;
      e.preventDefault();
      galerijGaNaar(Number(galerij.dataset.actieveIndex || 0) + (e.key === 'ArrowRight' ? 1 : -1));
    });
    if (mqG.addEventListener) mqG.addEventListener('change', galerijMqWissel); else if (mqG.addListener) mqG.addListener(galerijMqWissel);
    if (!mqG.matches) hoofdG.setAttribute('tabindex', '0');
  }

  /* ---------- render (Step 4, brief) ---------- */
  function render(variant) {
    data.opties.forEach(function (_, i) {
      var groep = wortel.querySelector('[data-bv2-optie="' + i + '"]');
      if (!groep) return;
      var uitleg = '';
      V.beschikbaarheid(data, matrix, selectie, i).forEach(function (r) {
        var b = groep.querySelector('[data-bv2-waarde="' + CSS.escape(r.waarde) + '"]');
        if (!b) return;
        b.setAttribute('aria-pressed', String(r.waarde === selectie[i]));
        b.setAttribute('aria-disabled', String(!r.bestaat));
        if (!r.bestaat) b.setAttribute('title', r.uitleg); else b.removeAttribute('title');
        if (!r.bestaat && !uitleg) uitleg = r.uitleg;
      });
      var u = wortel.querySelector('[data-bv2-uitleg="' + i + '"]'); if (u) u.textContent = uitleg;
      var lbl = groep.querySelector('[data-bv2-gekozen-label]'); if (lbl) lbl.textContent = bv2WeergaveMaat(selectie[i]);
    });
    wortel.querySelector('form[data-bv2-form] input[name="id"]').value = variant.id;
    wortel.querySelector('[data-bv2-prijs]').textContent = V.formatEuro(variant.prijs);
    var cmp = wortel.querySelector('[data-bv2-compare]'), bsp = wortel.querySelector('[data-bv2-bespaar]');
    var s = V.bespaar(variant);
    if (cmp) cmp.hidden = !s; if (bsp) bsp.hidden = !s;
    if (s) {
      if (cmp) cmp.textContent = V.formatEuro(variant.compare);
      // bevinding 8: server-side ({{ bespaar_bedrag | money }}) toont altijd ",00" — deze
      // .replace(',00','') liet de client bij hydratatie "Bespaar €65" tonen i.p.v. "Bespaar
      // €65,00" (geverifieerd: het €-teken zelf heeft in deze shop's money-format al géén
      // spatie, server en client komen daar al overeen — alleen de ",00"-afkap week af).
      if (bsp) bsp.textContent = (bsp.getAttribute('data-label') || 'Bespaar') + ' ' + V.formatEuro(s.bedrag);
    }
    bedragen(); /* iteratie 30-09 (F6): koopknop-, bestelbalk- en paneelbedrag = prijs × aantal (was: altijd de eenheidsprijs) */
    var atc = wortel.querySelector('button[data-bv2-atc]');
    if (atc) atc.disabled = !variant.beschikbaar && atc.dataset.uitverkochtBlokkeert === 'true';
    /* fixgolf 3 (review golf 2 I-3): de voorraadregel volgt variant.available (de Liquid doet dat voor de start): leverbaar = de regel
     * uit voorraadregel met de groene stip, niet leverbaar = voorraadregel_niet met een grijze stip; een lege tekst = geen regel.
     * fixgolf 4 (review golf 3 M-2): de Liquid rendert BEIDE regels (elk met zijn eigen stip, een lege setting = geen element); hier wisselt
     * alleen `hidden`. Er wordt geen tekst meer geschreven: die kwam uit een ge-escapet data-attribuut en stond dan als platte tekst op
     * de pagina, zodat een entiteit of tag uit de setting letterlijk zichtbaar werd ("1&#8209;3"). */
    var vja = wortel.querySelector('[data-bv2-voorraad="ja"]'), vnee = wortel.querySelector('[data-bv2-voorraad="nee"]');
    if (vja) vja.hidden = !variant.beschikbaar;
    if (vnee) vnee.hidden = !!variant.beschikbaar;
    galerijBijwerken();
    var url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState(history.state, '', url); /* mobiel J67: state behouden, anders verdwijnt de paneel-entry van bv2Paneel (terug-gebaar) */
    luisteraars.forEach(function (fn) { fn({ variant: variant, selectie: selectie.slice() }); });
  }

  function kies(nieuw) {
    var v = V.vindVariant(matrix, nieuw); if (!v) return false;
    selectie = nieuw.slice(); render(v); return true;
  }

  wortel.addEventListener('click', function (e) {
    var b = e.target.closest('[data-bv2-waarde]'); if (!b || !wortel.contains(b)) return;
    if (b.getAttribute('aria-disabled') === 'true') { e.preventDefault(); return; }
    var i = Number(b.closest('[data-bv2-optie]').dataset.bv2Optie);
    kiesOptie(i, b.dataset.bv2Waarde);
  });

  /* Mobiele ronde Task 5 (J69, spec §3.3): de optiegroep-<summary> is < 990 niet meer bedienbaar.
     CSS zet pointer-events:none (blokkeert muis/touch); tabindex="-1" haalt 'm daarnaast uit de
     toetsenbord-tabvolgorde (spec §3.3 vraagt dit expliciet — fix-ronde 1, controllerbesluit
     "spec bindt boven brief": de brief noemde tabindex eerst overbodig omdat pointer-events al
     de muis blokkeert, maar dekt de toetsenbord-Tab-volgorde niet). Een spatie/enter op een
     reeds-gefocuste <summary> triggert nog steeds het native <details>-toggle via een
     'click'-event, ongeacht pointer-events/tabindex (die filteren alleen pointer-hit-testing
     resp. de Tab-volgorde, niet een 'click' op een element dat al focus heeft) — de
     preventDefault hieronder stopt dat. spec §2.10: elke matchMedia-gate krijgt een
     change-listener, zodat tabindex live meekruist met bv2IsMobiel (zelfde 990-grens) zonder
     herlaad. ≥ 990: tabindex weg (weer gewoon focusbaar/tabbaar), klikgedrag ongewijzigd
     (Reviewbevinding 1). */
  /* iteratie 30-09 (F7, AFWIJKINGEN #203): Blad en Frame staan nu ook ≥ 990 naast elkaar; de optiegroepen zijn op ALLE breedtes
     altijd open en niet meer in te klappen (P1 = mobiel; het ±-teken is weg, zie de CSS). Dus overal tabindex -1 en geen toggle;
     de matchMedia-gate hierboven beschreven is daarmee vervallen (GESCHIEDENIS). */
  var summaries = wortel.querySelectorAll('[data-bv2-optie] > summary');
  summaries.forEach(function (s) {
    s.setAttribute('tabindex', '-1');
    s.addEventListener('click', function (e) { e.preventDefault(); });
  });

  /* Hiërarchie Blad -> Frame -> Maat: houdt deze keuze + alles erboven vast, past de rest aan (SPEC §4) */
  function kiesOptie(i, waarde) {
    var v = V.dichtstbijzijnde(data, matrix, selectie, i, waarde);
    return v ? kies(v.opties) : false;
  }

  /* ---------- winkelwagen ----------
     fase 5 (set-kaart, T3-restpunten): twee optionele parameters, `voegToe(id, knop)` blijft werken.
     - `aantal` (default 1) gaat als quantity mee in de POST (set-kaart: n sets = 1 regel met quantity n).
     - `opts.fout`: de eigen terugvaltekst van de aanroeper (zijn sectie-setting). Alleen als de winkel
       zelf geen reden meldt, wordt die getoond; zo is een winkelreden ("Uitverkocht") te onderscheiden
       van het netwerk-vangnet en is de setting niet langer dood.
     - `opts.opener`: het element dat de cart-drawer als opener krijgt (focus terug bij sluiten); zonder
       opts de knop zelf, zoals voorheen.
     - `opts.stil`: bij een mislukking géén toast; voor aanroepers met een eigen live region (set-kaart,
       info-popup), anders hoort een schermlezer de reden twee keer. De succes-toast blijft.
     De reden staat nog steeds in de toast (koopblok, sticky, addon-plus) én in de resolve-waarde
     { ok, reden, vanWinkel }, zodat een aanroeper met een eigen live region hem niet uit de toast hoeft
     te lezen (die kan intussen door een andere toevoeging overschreven zijn). */
  function voegToe(id, knop, aantal, opts) {
    opts = opts || {};
    var n = Math.max(1, Math.floor(Number(aantal)) || 1);
    var terugval = opts.fout || 'Dit lukte niet. Probeer het nog een keer.';
    if (knop) knop.setAttribute('aria-busy', 'true');
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: n }] })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          var winkel = res.body && res.body.description ? String(res.body.description) : '';
          if (!opts.stil) toast(winkel || terugval);
          return { ok: false, reden: winkel || terugval, vanWinkel: !!winkel };
        }
        toast('Toegevoegd aan je winkelwagen.');
        doc.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true, detail: { cart: res.body } }));
        doc.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { cart: res.body } }));
        doc.dispatchEvent(new CustomEvent('bv2:toegevoegd', { bubbles: true, detail: { id: id, opener: opts.opener || knop || null, cart: res.body } }));
        return { ok: true, reden: '', vanWinkel: false };
      })
      .catch(function () { if (!opts.stil) toast(terugval); return { ok: false, reden: terugval, vanWinkel: false }; })
      .finally(function () { if (knop) knop.removeAttribute('aria-busy'); });
  }

  /* ---------- iteratie 30-09 (F6, AFWIJKINGEN #202): aantal in de koopkaart, zoals stane-premium ----------
     Eén aantal (1..koop_max_aantal) voor de koopknop, de bestelbalk en het bestelpaneel; de bedragen op die knoppen = prijs × aantal
     (premium: data-atc-amt en data-sticky-price = eenheid × aantal); vanaf 2 staat de som-regel "2 × €199,00 · €398,00" boven de rij.
     Het verborgen quantity-veld volgt, zodat de no-JS-POST ook klopt. Zonder koopkaart (andere template) blijft het aantal 1. */
  var kk = wortel.querySelector('[data-bv2-koopkaart]'), aantal = 1, aantalGetoond = null;
  var kkMaxEl = kk && kk.querySelector('[data-bv2-koop-max]');
  var kkMax = kkMaxEl ? Math.max(1, Number(kkMaxEl.getAttribute('data-bv2-koop-max')) || 10) : 1;
  var stuksWoord = (kkMaxEl && kkMaxEl.getAttribute('data-bv2-stuks')) || 'stuks'; /* setting koop_stuks_label (fixgolf 3, I-2) */
  function variantNu() { var id = wortel.querySelector('form[data-bv2-form] input[name="id"]').value; return data.varianten.filter(function (x) { return String(x.id) === id; })[0] || null; }
  /* fixgolf 3 (review golf 2 I-1, I-2, N-2): EEN functie voor alle bedragen, aangeroepen bij een variantwissel (render) en bij elke
   * aantalwissel (stepper) — zoals stane-premium (custom-stoel-v2-basis.js render(), r319-342):
   * - koopknop, bestelbalk (ook de desktopprijs [data-bv2-sticky-prijs], was: eenheidsprijs) en bestelpaneel = prijs x aantal;
   * - de doorgestreepte was-prijs in het paneel = compare x aantal, verborgen zonder echte korting (compare <= prijs): die volgde het
   *   aantal niet (valse korting "€199,00 ~~€2.640,00~~", review I-1); samSync schrijft hem niet meer;
   * - de aantal-cue "N stuks ·" bij elke [data-bv2-aantal-cue] (balk en paneel), verborgen bij 1;
   * - het getal in de live-regio alleen bij een wijziging (N-2: anders kondigt een schermlezer het bij elke variantwissel opnieuw aan). */
  function bedragen() {
    var v = variantNu(); if (!v) return;
    var tot = v.prijs * aantal, korting = V.bespaar(v);
    doc.querySelectorAll('[data-bv2-atc-prijs], [data-bv2-sticky-atc-prijs], [data-bv2-sticky-prijs], [data-bv2-paneel-prijs]').forEach(function (el) { el.textContent = V.formatEuro(tot); });
    doc.querySelectorAll('[data-bv2-paneel-was]').forEach(function (el) { el.hidden = !korting; if (korting) el.textContent = V.formatEuro(v.compare * aantal); });
    /* de cue met een spatie ervoor en erna (in de flex-rijen van balk en paneel valt die witruimte weg; in de mobiele balkknop is de
     * spatie achter "·" de afstand tot het bedrag). De ouder krijgt .bv2-met-aantal: in de mobiele balkknop zet de CSS cue + bedrag dan
     * op een eigen regel, als echt blok; in de desktopbalk zet de CSS de cue op 990–1179 boven het bedrag (fixgolf 4, M-4). Toegankelijke
     * naam van de mobiele balkknop (fixgolf 4, N-5: een sr-only ", " in de markup scheidt label en bedrag): "In winkelwagen, €199,00"
     * bij 1 stuk, "In winkelwagen, 3 stuks · €597,00" vanaf 2. */
    doc.querySelectorAll('[data-bv2-aantal-cue]').forEach(function (el) {
      /* iteratie 30-09 (controller, na fixgolf 4 A5): de "·" in een eigen span, zodat de CSS hem kan verbergen waar de cue BOVEN het
       * bedrag staat (desktopbalk 990–1179) — daar hing hij anders aan het eind van een regel. Tekst en schermlezernaam blijven gelijk. */
      el.hidden = aantal < 2; el.textContent = '';
      if (aantal >= 2) {
        el.appendChild(doc.createTextNode(' ' + aantal + ' ' + stuksWoord + ' '));
        var scheider = doc.createElement('span'); scheider.className = 'bv2-aantal-cue__scheider'; scheider.textContent = '· '; el.appendChild(scheider);
      }
      if (el.parentNode) { if (aantal < 2) el.parentNode.classList.remove('bv2-met-aantal'); else el.parentNode.classList.add('bv2-met-aantal'); }
    });
    if (!kk) return;
    if (aantalGetoond !== aantal) { kk.querySelector('[data-bv2-koop-aantal]').textContent = String(aantal); aantalGetoond = aantal; }
    var veld = kk.querySelector('[data-bv2-koop-aantal-veld]'); if (veld) veld.value = String(aantal);
    var som = kk.querySelector('[data-bv2-koop-som]');
    if (som) {
      som.hidden = aantal < 2;
      if (aantal >= 2) { som.querySelector('[data-bv2-koop-som-l]').textContent = aantal + ' \u00d7 ' + V.formatEuro(v.prijs); som.querySelector('[data-bv2-koop-som-r]').textContent = V.formatEuro(tot); }
    }
    kk.querySelectorAll('[data-bv2-koop-stap]').forEach(function (b) { var d = Number(b.getAttribute('data-bv2-koop-stap')); b.setAttribute('aria-disabled', String(d < 0 ? aantal <= 1 : aantal >= kkMax)); });
  }
  if (kk) kk.querySelectorAll('[data-bv2-koop-stap]').forEach(function (b) {
    b.addEventListener('click', function () { aantal = Math.max(1, Math.min(kkMax, aantal + Number(b.getAttribute('data-bv2-koop-stap')))); bedragen(); });
  });

  wortel.querySelector('form[data-bv2-form]').addEventListener('submit', function (e) {
    e.preventDefault(); voegToe(this.querySelector('input[name="id"]').value, this.querySelector('[data-bv2-atc]'), aantal);
  });
  doc.addEventListener('click', function (e) {
    var b = e.target.closest('button[data-bv2-add]'); if (!b) return;
    e.preventDefault();
    if (b.getAttribute('aria-disabled') === 'true') return; /* fase 5: uitverkochte addon-keuze, geen POST */
    voegToe(b.dataset.bv2Add, b);
  });

  /* ---------- cart-drawer (overgenomen van custom-stoel-v2-basis.js:ladeOpenen, r93-133) ----------
   * De koopblok-fetch hierboven roept nooit Symmetry's eigen ProductForm-submit aan (we
   * onderscheppen zelf), dus `.js-cart-drawer.open(knop)` uit main.js wordt nooit bereikt.
   * We wachten daarom, net als stoel-v2, op 'on:cart:after-merge' op de cart-form in de
   * lade (gevuld ná on:cart:change), met een vangnet van 1200 ms; een al openstaande lade
   * wordt niet opnieuw gedispatcht (main.js laat anders een wees-keyup-listener achter). */
  doc.addEventListener('bv2:toegevoegd', function (e) {
    if (!window.theme || !theme.settings) return;
    if (theme.settings.cartType !== 'drawer' || theme.settings.afterAddToCart !== 'drawer') return;
    var lade = doc.querySelector('.js-cart-drawer');
    if (!lade) return;
    var gedaan = false, timer = null;
    function open() {
      if (gedaan) return;
      gedaan = true;
      clearTimeout(timer);
      if (lade.hasAttribute('open')) return;
      doc.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', {
        bubbles: true, cancelable: false, detail: { opener: (e.detail && e.detail.opener) || null }
      }));
    }
    var vorm = lade.querySelector('cart-form');
    if (vorm) vorm.addEventListener('on:cart:after-merge', open, { once: true });
    timer = setTimeout(open, 1200);
  });

  window.BureauV2 = {
    data: data, kies: kies, kiesOptie: kiesOptie, voegToe: voegToe,
    aantal: function () { return aantal; }, /* iteratie 30-09 (F6): het aantal van de koopkaart, voor bestelbalk en bestelpaneel */
    selectie: function () { return selectie.slice(); },
    opSelectie: function (fn) { luisteraars.push(fn); }
  };
  render(V.vindVariant(matrix, selectie));
})();

/* ---------- sticky ATC-balk + ankernav (Task 5, R-19 functioneel-eerst; Task 4 stijlt) ----------
 * Brief-code (task-5-brief.md Step 2) vrijwel 1-op-1 overgenomen, met de echte
 * bv2-sticky/-ankernav-selectors. Draait in een eigen IIFE ná bovenstaande (die
 * window.BureauV2 zet) — zelfde bestand, dus gegarandeerd ná elkaar, geen defer-race.
 *
 * De ankernav gebruikt dezelfde IntersectionObserver-sentinel-techniek als de sticky
 * ATC-balk, maar toggelt een ANDER attribuut met ANDERE betekenis: `data-vast` i.p.v.
 * `data-zichtbaar`. Sinds de flikker-fix (fase 5 J46) observeert hij een vaste 1px-sentinel
 * [data-bv2-ankernav-sentinel] vóór de plaatshouder — niet meer [data-bv2-ankernav-plek]
 * zelf, want die wisselt van hoogte zodra hij `data-vast` volgt en was dus een bewegend
 * observatiedoel. Hij is namelijk nooit verborgen — hij staat bij laden gewoon in-flow op
 * zijn designpositie (Task 4-fix: fase 1 zette 'm permanent position:fixed +
 * visibility:hidden, dezelfde "reveal"-techniek als de ATC-balk, waardoor de balk bij laden
 * onzichtbaar was in plaats van op de designpositie). `data-vast="true"` betekent hier
 * "omgeklapt naar position:fixed onder de header", niet "zichtbaar". */
(function () {
  'use strict';
  var B = window.BureauV2, V = window.BureauV2Varianten; if (!B) return;
  var st = document.querySelector('[data-bv2-sticky]'), atc = document.querySelector('button[data-bv2-atc]');
  if (st && atc && 'IntersectionObserver' in window) {
    /* mobiel J67 (spec §3.1): hoogte van de zichtbare balk als CSS-variabele op <html> (0 als hij
     * verborgen is). Stuurt < 990 body padding-bottom, scroll-padding-bottom en de toastpositie. */
    var balkH = function () {
      var h = st.dataset.zichtbaar === 'true' ? Math.round(st.getBoundingClientRect().height) : 0;
      document.documentElement.style.setProperty('--bv2-balk-h', h + 'px');
    };
    window.addEventListener('resize', function () { requestAnimationFrame(balkH); });
    var zetZichtbaar = function (weg) {
      if (st.dataset.zichtbaar === String(weg)) return;
      st.dataset.zichtbaar = String(weg); st.inert = !weg;
      document.body.classList.toggle('bv2-sticky-aan', weg);
      requestAnimationFrame(balkH); /* mobiel J67: --bv2-balk-h volgt de zichtbare balk */
    };
    new IntersectionObserver(function (es) {
      zetZichtbaar(!es[0].isIntersecting && es[0].boundingClientRect.top < 0);
    }).observe(atc);
    /* mobiel T2 (R8, gevonden bij het herschrijven van koopblok-poort zelftoets 3): de observer meldt
     * alleen een KRUISING van de viewportrand. Staat de koopknop bij laden onder de vouw (mobiel: altijd)
     * en springt de pagina in één keer voorbij hem (trustlink "#bv2-reviews" bovenin, een anker-sprong),
     * dan gaat hij van "onder, niet zichtbaar" naar "boven, niet zichtbaar" zonder kruising en bleef de
     * balk weg. Vangnet: dezelfde toets bij scroll, één keer per frame; zetZichtbaar doet niets als de
     * stand gelijk blijft. */
    var balkRaf = 0;
    window.addEventListener('scroll', function () {
      if (balkRaf) return;
      balkRaf = requestAnimationFrame(function () { balkRaf = 0; zetZichtbaar(atc.getBoundingClientRect().bottom < 0); });
    }, { passive: true });
    var sels = st.querySelectorAll('select[data-bv2-sticky-optie]');
    // Herstelronde 1 (orchestrator-review, Important-bevinding 2): index van de Blad-optie,
    // zelfde heuristiek als de Liquid-kant (custom-bureau-v2-koopblok.liquid: "on contains
    // 'blad'") — zodat de mini-swatch dezelfde optie volgt als het server-gerenderde begin.
    var bladIndex = 0;
    B.data.opties.forEach(function (naam, i) { if (/blad/i.test(naam)) bladIndex = i; });
    // Sticky-keuring ronde 1: zelfde patroon ook voor Frame (verifier: Frame-select mist het
    // swatchje dat Blad al had). frameIndex + maakSwatchSync() — de bestaande Blad-swatchSync-
    // logica is 1-op-1 verplaatst naar een kleine factory (zelfde bron/kopieerlogica, nu twee
    // keer aangeroepen i.p.v. gedupliceerd) zodat er geen ander gedrag bijkomt.
    var frameIndex = 0;
    B.data.opties.forEach(function (naam, i) { if (/frame/i.test(naam)) frameIndex = i; });
    var swatchEl = st.querySelector('[data-bv2-sticky-swatch]');
    var frameSwatchEl = st.querySelector('[data-bv2-sticky-swatch-frame]');
    function maakSwatchSync(el, index) {
      return function (waarde) {
        if (!el) return;
        // Dezelfde bron als de swatch-blocks van het koopblok: de knop voor deze waarde in de
        // hoofdkiezer draagt al óf een <img>, óf een gekleurde <span> (render()-patroon
        // hierboven) — kopieer die inhoud i.p.v. hem opnieuw op te bouwen uit losse blockdata.
        var bron = document.querySelector('[data-bv2-optie="' + index + '"] [data-bv2-waarde="' + CSS.escape(waarde) + '"]');
        var img = bron && bron.querySelector('img');
        var kleurSpan = bron && bron.querySelector('span[style*="background"]');
        el.innerHTML = '';
        if (img) {
          var kloon = img.cloneNode(true); kloon.removeAttribute('loading'); kloon.alt = '';
          el.appendChild(kloon);
        } else if (kleurSpan) {
          var s2 = document.createElement('span'); s2.setAttribute('style', kleurSpan.getAttribute('style'));
          el.appendChild(s2);
        }
      };
    }
    var swatchSync = maakSwatchSync(swatchEl, bladIndex);
    var frameSwatchSync = maakSwatchSync(frameSwatchEl, frameIndex);
    function sync(e) {
      var m = V.bouwMatrix(B.data.varianten);
      sels.forEach(function (s) {
        var i = Number(s.dataset.bv2StickyOptie); s.value = e.selectie[i];
        var grijs = {};
        V.beschikbaarheid(B.data, m, e.selectie, i).forEach(function (r) { grijs[r.waarde] = !r.bestaat; });
        // bevinding 4: label meeschrijven, niet alleen disabled — anders verloopt de
        // server-gebakken "(niet leverbaar bij deze keuze)"-tekst na de eerste klik.
        var suffix = s.dataset.nietBeschikbaar || 'niet leverbaar bij deze keuze';
        [].forEach.call(s.options, function (o) {
          var isGrijs = !!grijs[o.value];
          o.disabled = isGrijs;
          var basis = bv2WeergaveMaat(o.dataset.basis || o.value);
          o.textContent = isGrijs ? basis + ' (' + suffix + ')' : basis;
        });
      });
      /* fixgolf 3 (review golf 2 I-2): de balkprijs [data-bv2-sticky-prijs] = prijs × aantal, geschreven door bedragen() in de
       * hoofd-IIFE (render() roept die vóór deze luisteraars aan); hier niet meer de eenheidsprijs, anders overschreef sync het totaal. */
      swatchSync(e.selectie[bladIndex]);
      frameSwatchSync(e.selectie[frameIndex]);
    }
    B.opSelectie(sync);

    /* fase 5 J51: kiezer met stalen (≥ 990). Eén paneel tegelijk, geen animatie (TW-36, de
     * balk heeft een waasgeschiedenis — zie CSS-kant). Brief-code (task-6-brief.md Step 4)
     * overgenomen met één aanpassing (R8): de linker-offset van het paneel wordt berekend
     * t.o.v. `.bv2-sticky__wrap` (de positioned ancestor die de CSS ook gebruikt), niet t.o.v.
     * `st` zelf — st is de volle-breedte fixed balk (inset-inline:0), terwijl wrap gecentreerd
     * is (max-width 1440 + margin-inline:auto); tegen st zou het paneel bij een viewport >
     * 1440 px naast de trigger uitkomen.
     * Tweede aanpassing (R8, echte bug op de preview): elke `.focus()` hier krijgt
     * `{ preventScroll: true }`. Zonder die vlag scrollt de browser de pagina zelf zodra een
     * diep-in-de-paneel element focus krijgt — ook al staat de balk (position:fixed) al
     * zichtbaar in beeld — en die scroll triggert op zijn beurt de eigen "sluit bij scroll >
     * 100 px"-regel hieronder: het paneel opende en sloot zichzelf binnen één frame. Gemeten
     * (Playwright, 1440): scrollY sprong 6280 → 6614 direct na `openPaneel()`, `paneel.hidden`
     * werd `true` binnen ~150 ms. Reproduceerbaar bij élke bezoeker diep op de pagina, niet een
     * testartefact. */
    /* Eindfix 3: de keuzes zijn gewone knoppen met aria-pressed in een role=group (geen radio's: die
     * beloven radio-toetsenbordgedrag — pijl = kiezen — dat hier niet bestaat). Pijltjes verplaatsen
     * alleen de focus (gemak), Enter/spatie kiest. */
    var wrap = st.querySelector('.bv2-sticky__wrap');
    var paneel = st.querySelector('[data-bv2-sticky-paneel]');
    var triggers = [].slice.call(st.querySelectorAll('[data-bv2-sticky-trigger]'));
    var openI = -1;
    function bronKnop(i, w) { return document.querySelector('[data-bv2-optie="' + i + '"] [data-bv2-waarde="' + CSS.escape(w) + '"]'); }
    function staalKloon(i, w) {
      var bron = bronKnop(i, w), el = bron && (bron.querySelector('img') || bron.querySelector('span[style*="background"]'));
      if (!el) return null; var k = el.cloneNode(true); if (k.removeAttribute) k.removeAttribute('loading'); k.alt = ''; return k;
    }
    function sluitPaneel(terug) { if (openI < 0) return; paneel.hidden = true; triggers[openI].setAttribute('aria-expanded', 'false'); if (terug) triggers[openI].focus({ preventScroll: true }); openI = -1; }
    function openPaneel(t) {
      var i = Number(t.getAttribute('data-bv2-sticky-trigger')); sluitPaneel(false); openI = triggers.indexOf(t);
      var sel = B.selectie(), m = V.bouwMatrix(B.data.varianten), grijs = {};
      V.beschikbaarheid(B.data, m, sel, i).forEach(function (r) { grijs[r.waarde] = !r.bestaat; });
      paneel.querySelector('[data-bv2-sticky-paneel-kop]').textContent = B.data.opties[i];
      var box = paneel.querySelector('[data-bv2-sticky-paneel-keuzes]'); box.innerHTML = ''; box.setAttribute('aria-label', B.data.opties[i]);
      var waarden = [].map.call(st.querySelector('select[data-bv2-sticky-optie="' + i + '"]').options, function (o) { return o.value; });
      var metStaal = i === bladIndex || i === frameIndex;
      waarden.forEach(function (w) {
        var k = document.createElement('button'); k.type = 'button'; k.className = 'bv2-sticky__keuze' + (metStaal ? '' : ' bv2-sticky__keuze--maat');
        k.setAttribute('data-bv2-sticky-keuze', ''); k.setAttribute('data-waarde', w);
        k.setAttribute('aria-pressed', String(sel[i] === w));
        if (grijs[w]) { k.setAttribute('aria-disabled', 'true'); k.title = sels[0].dataset.nietBeschikbaar || 'niet leverbaar bij deze keuze'; }
        if (metStaal) { var s2 = document.createElement('span'); s2.className = 'bv2-sticky__staal'; var kl = staalKloon(i, w); if (kl) s2.appendChild(kl); k.appendChild(s2); }
        var n = document.createElement('span'); n.className = 'bv2-sticky__keuze-naam'; n.textContent = bv2WeergaveMaat(w); k.appendChild(n);
        k.addEventListener('click', function () { if (grijs[w]) return; B.kiesOptie(i, w); sluitPaneel(true); });
        box.appendChild(k);
      });
      var r = t.getBoundingClientRect(), wrapR = wrap.getBoundingClientRect();
      paneel.style.left = Math.round(r.left - wrapR.left) + 'px';
      paneel.hidden = false; t.setAttribute('aria-expanded', 'true'); scrollStart = scrollY; /* eindfix 3: afstand vanaf het openen, niet vanaf het eerste scroll-event */
      var gekozen = box.querySelector('[aria-pressed="true"]') || box.firstElementChild; if (gekozen) gekozen.focus({ preventScroll: true });
    }
    triggers.forEach(function (t) { t.addEventListener('click', function () { if (openI === triggers.indexOf(t)) sluitPaneel(true); else openPaneel(t); }); });
    paneel.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); sluitPaneel(true); return; }
      if (['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp'].indexOf(e.key) === -1) return;
      var ks = [].slice.call(paneel.querySelectorAll('[data-bv2-sticky-keuze]')), j = ks.indexOf(document.activeElement);
      e.preventDefault(); ks[(j + (/Right|Down/.test(e.key) ? 1 : -1) + ks.length) % ks.length].focus({ preventScroll: true });
    });
    document.addEventListener('click', function (e) { if (openI >= 0 && !e.target.closest('[data-bv2-sticky-paneel], [data-bv2-sticky-trigger]')) sluitPaneel(false); });
    var scrollStart = null;
    window.addEventListener('scroll', function () { if (openI < 0) { scrollStart = null; return; } if (scrollStart === null) scrollStart = scrollY; if (Math.abs(scrollY - scrollStart) > 100) sluitPaneel(false); }, { passive: true });
    function triggerSync(e) {
      triggers.forEach(function (t) {
        var i = Number(t.getAttribute('data-bv2-sticky-trigger')), w = e.selectie[i];
        t.querySelector('.bv2-sticky__trigger-waarde').textContent = bv2WeergaveMaat(w);
        t.setAttribute('aria-label', B.data.opties[i] + ': ' + w);
        var mini = t.querySelector('.bv2-sticky__mini'); if (mini) { mini.innerHTML = ''; var kl = staalKloon(i, w); if (kl) mini.appendChild(kl); }
      });
    }
    B.opSelectie(triggerSync);
    triggerSync({ selectie: B.selectie() }); /* startselectie, zelfde patroon als sync(v0) onderaan deze IIFE */

    /* mobiel J67 (spec §3.1): samenvattingsknop + paneel "Jouw bureau" (< 990). Zelfde bron (staalKloon,
     * V.beschikbaarheid, B.kiesOptie) als het desktop-stalenpaneel hierboven; eigen markup, gedeelde
     * staat (AFWIJKINGEN #169: de koopblok-kiezers verplaatsen naar een modaal paneel zou de inhoud boven
     * de viewport laten verspringen). Openen/sluiten via de gedeelde window.bv2Paneel (spec §2.4), die sinds
     * eindfix 2 bovenaan dit bestand staat (vóór deze IIFE); de klik zoekt hem nog steeds op (vangnet). */
    var sam = st.querySelector('[data-bv2-sticky-samenvatting]');
    var samTekst = st.querySelector('[data-bv2-sticky-sam-tekst]'), samStaal = st.querySelector('[data-bv2-sticky-sam-staal]');
    var pDlg = document.querySelector('dialog[data-bv2-paneel="bureau"]');
    var pAtc = pDlg && pDlg.querySelector('[data-bv2-paneel-atc]');
    var stickyAtc = st.querySelector('button[data-bv2-sticky-atc]');
    var pVolgorde = V.volgorde(B.data); /* Blad, Frame, Maat — zelfde volgorde als het koopblok */
    var samBlad = B.selectie()[bladIndex]; /* server-side staal hoort bij de startselectie */
    function groepNaam(i) { return i === bladIndex ? 'blad' : i === frameIndex ? 'frame' : 'maat'; }
    function groepLabel(i) {
      var l = document.querySelector('[data-bv2-optie="' + i + '"] .bv2-optie-groep__label');
      return l ? l.textContent.trim() : B.data.opties[i] + ':';
    }
    function bouwPaneel() {
      if (!pDlg) return;
      var box = pDlg.querySelector('[data-bv2-paneel-keuzes]'), sel = B.selectie(), m = V.bouwMatrix(B.data.varianten);
      box.innerHTML = '';
      var rij = document.createElement('div'); rij.className = 'bv2-paneel__rij';
      pVolgorde.forEach(function (i) {
        var g = document.createElement('div'); g.className = 'bv2-paneel__groep bv2-paneel__groep--' + groepNaam(i);
        g.setAttribute('data-bv2-paneel-groep', groepNaam(i)); g.setAttribute('data-bv2-paneel-optie', String(i)); g.setAttribute('role', 'group'); g.setAttribute('aria-label', B.data.opties[i]);
        var kop = document.createElement('p'); kop.className = 'bv2-paneel__groepkop';
        var kl1 = document.createElement('strong'); kl1.textContent = groepLabel(i);
        var kl2 = document.createElement('span'); kl2.textContent = bv2WeergaveMaat(sel[i]);
        kop.appendChild(kl1); kop.appendChild(document.createTextNode(' ')); kop.appendChild(kl2);
        g.appendChild(kop);
        var knoppen = document.createElement('div'); knoppen.className = 'bv2-paneel__knoppen'; g.appendChild(knoppen);
        var grijs = {}; V.beschikbaarheid(B.data, m, sel, i).forEach(function (r) { grijs[r.waarde] = !r.bestaat; });
        var waarden = [].map.call(st.querySelector('select[data-bv2-sticky-optie="' + i + '"]').options, function (o) { return o.value; });
        var metStaal = i === bladIndex || i === frameIndex;
        waarden.forEach(function (w) {
          var k = document.createElement('button'); k.type = 'button';
          k.className = metStaal ? 'bv2-paneel__staal' : 'bv2-paneel__maat';
          k.setAttribute('data-waarde', w); k.setAttribute('aria-pressed', String(sel[i] === w));
          if (grijs[w]) { k.setAttribute('aria-disabled', 'true'); k.title = sels[0].dataset.nietBeschikbaar || 'niet leverbaar bij deze keuze'; }
          if (metStaal) { var kl = staalKloon(i, w); if (kl) k.appendChild(kl); k.setAttribute('aria-label', w); }
          else k.textContent = bv2WeergaveMaat(w);
          /* Review Focus 1: een niet-leverbare keuze (aria-disabled) verandert niets aan de selectie */
          k.addEventListener('click', function () { if (grijs[w]) return; B.kiesOptie(i, w); });
          knoppen.appendChild(k);
        });
        if (metStaal) rij.appendChild(g);
        else { if (rij.children.length) { box.appendChild(rij); rij = document.createElement('div'); rij.className = 'bv2-paneel__rij'; } box.appendChild(g); }
      });
      if (rij.children.length) box.appendChild(rij);
    }
    function samSync(e) {
      var sel = e.selectie;
      var delen = pVolgorde.map(function (i) { return String(bv2WeergaveMaat(sel[i])).replace(/\s?cm$/, ''); });
      if (samTekst) samTekst.textContent = delen.join(' \u00b7 ');
      if (sam) sam.setAttribute('aria-label', (pDlg ? pDlg.querySelector('.bv2-paneel__titel').textContent.trim() : '') + ': ' + pVolgorde.map(function (i) { return sel[i]; }).join(', '));
      if (samStaal && sel[bladIndex] !== samBlad) { samBlad = sel[bladIndex]; samStaal.innerHTML = ''; var kl = staalKloon(bladIndex, samBlad); if (kl) samStaal.appendChild(kl); }
      /* eindfix 3: de koopblok-knop is de bron (render() zet atc.disabled vóór de luisteraars: uitverkocht +
       * uitverkocht_blokkeert). Sticky-knop (ook ≥ 990) en paneelknop volgen die stand; het label wisselt daar
       * niet, dus hier ook niet. */
      if (stickyAtc) stickyAtc.disabled = atc.disabled;
      if (pAtc) pAtc.disabled = atc.disabled;
      /* fixgolf 3 (review golf 2 I-1): de bedragen van balkknop en paneel (prijs, was-prijs, aantal-cue) schrijft alleen nog bedragen()
       * in de hoofd-IIFE, bij een variantwissel én bij elke aantalwissel. Hier stonden ze dubbel en alleen voor de variantwissel: daardoor
       * bleef de was-prijs na "−" op het oude aantal staan (valse korting). */
      if (pDlg && pDlg.open) {
        /* herbouwen (aria-pressed/-disabled volgen de nieuwe selectie); focus terug op dezelfde knop (h183) */
        var f = document.activeElement, fw = f && f.getAttribute && f.getAttribute('data-waarde'), fg = fw && f.closest('[data-bv2-paneel-groep]');
        bouwPaneel();
        var terug = fg ? pDlg.querySelector('[data-bv2-paneel-groep="' + fg.getAttribute('data-bv2-paneel-groep') + '"] [data-waarde="' + CSS.escape(fw) + '"]') : null;
        if (terug) terug.focus({ preventScroll: true });
      }
    }
    B.opSelectie(samSync);
    if (sam && pDlg) sam.addEventListener('click', function () {
      if (!window.bv2Paneel) return;
      bouwPaneel(); window.bv2Paneel(pDlg, sam);
      var eerste = pDlg.querySelector('[data-bv2-paneel-keuzes] [aria-pressed="true"]'); if (eerste) eerste.focus({ preventScroll: true });
    });
    if (pAtc) pAtc.addEventListener('click', function () {
      if (atc.disabled) return; /* eindfix 3: geblokkeerd zoals de koopblok-knop, geen POST */
      /* voegToe geeft een Promise met { ok, reden, vanWinkel }: alleen bij ok sluit het paneel; bij een
       * mislukking blijft het open en staat de reden in de toast (boven de balk). De lade krijgt de
       * samenvattingsknop als opener: de paneelknop is na het sluiten niet meer zichtbaar. */
      B.voegToe(document.querySelector('form[data-bv2-form] input[name="id"]').value, pAtc, B.aantal ? B.aantal() : 1, { opener: sam }).then(function (r) { /* iteratie 30-09 (F6): het aantal van de koopkaart */
        if (r && r.ok && pDlg.open) pDlg.close();
      });
    });
    /* Een kiezer in het open paneel loopt via render() -> history.replaceState met de nieuwe variant-URL
     * op de paneel-entry. Sluit het paneel via history.back(), dan staat de adresbalk weer op de URL van
     * vóór het openen: zet de actuele variant terug op de entry waar we landen. */
    window.addEventListener('popstate', function () {
      var id = document.querySelector('form[data-bv2-form] input[name="id"]').value, u = new URL(location.href);
      if (id && u.searchParams.get('variant') !== id) { u.searchParams.set('variant', id); history.replaceState(history.state, '', u); }
    });

    sels.forEach(function (s) {
      s.addEventListener('change', function () { B.kiesOptie(Number(s.dataset.bv2StickyOptie), s.value); });
    });
    if (stickyAtc) {
      stickyAtc.addEventListener('click', function () {
        if (atc.disabled) return; /* eindfix 3: geblokkeerd zoals de koopblok-knop, geen POST */
        B.voegToe(document.querySelector('form[data-bv2-form] input[name="id"]').value, this, B.aantal ? B.aantal() : 1); /* iteratie 30-09 (F6) */
      });
    }
    var v0 = B.data.varianten.filter(function (v) { return String(v.id) === document.querySelector('form[data-bv2-form] input[name="id"]').value; })[0];
    if (v0) sync({ variant: v0, selectie: B.selectie() });
    if (v0) samSync({ variant: v0, selectie: B.selectie() }); /* mobiel J67: pas ná de bepaling van v0 */
  }

  var nav = document.querySelector('nav[data-bv2-ankernav]');
  if (nav && 'IntersectionObserver' in window) {
    var links = [].slice.call(nav.querySelectorAll('a[href^="#"]'));
    links.forEach(function (a) { if (!document.querySelector(a.getAttribute('href'))) a.hidden = true; });
    /* videofeedback 30-09 V6/V12 (B6): de oude IntersectionObserver-scrollspy (rootMargin −40 %/−55 %, zette een leeg
       `aria-current` dat de CSS-regel [aria-current="true"] nooit raakte, dus onzichtbaar) is vervangen door de scrollspy-IIFE
       direct na deze IIFE (aria-current="location"). Twee mechanismen op hetzelfde attribuut zouden elkaar overschrijven. */

    // fase 5 J46: de plaatshouder zelf wisselt van hoogte (0 ↔ nav) zodra hij `data-vast` volgt —
    // die was dus een bewegend observatiedoel en klapte in de overgangszone heen en weer
    // (flikkeren boven de UGC-band). De sentinel is een vaste 1px-lijn vóór de plaatshouder en
    // verandert nooit van positie/hoogte, dus geen zelf-veroorzaakte oscillatie meer.
    var plek = document.querySelector('[data-bv2-ankernav-plek]');
    var sentinel = document.querySelector('[data-bv2-ankernav-sentinel]');
    if (plek && sentinel) {
      var kopHoogte = function () { var h = document.querySelector('#pageheader'); return h ? Math.round(h.getBoundingClientRect().height) : 0; };
      var zet = function (vast) {
        if (nav.dataset.vast === String(vast)) return;
        /* de hoogte meten vóór het omklappen: dan is de nav nog in-flow (incl. randen) */
        plek.style.height = vast ? nav.getBoundingClientRect().height + 'px' : '';
        nav.dataset.vast = String(vast); plek.dataset.vast = String(vast);
      };
      var maak = function () {
        var io2 = new IntersectionObserver(function (es) {
          var e = es[es.length - 1];
          zet(!e.isIntersecting && e.boundingClientRect.top < kopHoogte());
        }, { rootMargin: '-' + kopHoogte() + 'px 0px 0px 0px' });
        io2.observe(sentinel);
        return io2;
      };
      var ioVast = maak(), rt = null;
      window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { ioVast.disconnect(); ioVast = maak(); }, 150); });
      /* videofeedback 30-09 (T6, gevonden bij B6): een directe sprong van "sentinel onder het scherm" naar "sentinel boven het scherm"
         kruist geen drempel, dus de observer vuurt niet en de nav bleef statisch (= uit beeld). Gereproduceerd op de oude stand
         (t6/b0-nav-niet-vast-na-sprong.txt): 390 met "minder beweging", Trustpilot-regel → reviews: vast "false", nav op −4379.
         Vangnet: per scroll (één rAF, alleen een rect lezen) dezelfde voorwaarde als de observer (sentinel boven de header =
         niet in [kop, onderkant] en boven de kop). De sentinel beweegt nooit met `vast` mee (J46), dus geen heen-en-weer; zet() is
         idempotent. */
      var vastGepland = false;
      window.addEventListener('scroll', function () {
        if (vastGepland) return;
        vastGepland = true;
        window.requestAnimationFrame(function () { vastGepland = false; zet(sentinel.getBoundingClientRect().bottom <= kopHoogte()); });
      }, { passive: true });

      /* mobiel J76 (spec §3.1), sinds verbeter 29-09 A16 omgedraaid (zie hieronder): de richting-detectie stuurt nu de
       * header i.p.v. de ankernav. De hold na een ankertik bleef: vast tot de
       * scroll tot rust komt (min. 600 ms). Fix-ronde 1, bevinding 2: een pure tijd-hold (600 ms) was te
       * kort voor een verre ankersprong (bv. #bv2-reviews vanaf de top) — de smooth scroll liep dan nog
       * door ná vastTot en werd als "omlaag scrollen" gelezen, waardoor de nav halverwege de sprong
       * verdween. `navVastgehouden` negeert richting() volledig zolang de sprong bezig is (niet alleen de
       * eerste 600 ms); `laatsteY` wordt pas ná het loslaten herzet, zodat de sprongafstand zelf niet als
       * scrollrichting meetelt. */
      var mq = window.matchMedia('(min-width: 990px)'), laatsteY = scrollY;
      var navVastgehouden = false, navMinKlaar = false, navStilKlaar = false;
      var navMinTimer = null, navPlafondTimer = null, navStilTimer = null, navStilLuisteraar = null, navScrollendLuisteraar = null;
      /* verbeter 29-09 A16 (Jory): omlaag scrollen voorbij het vastpunt = hoofdnavigatie weg (html.bv2-kop-weg), de ankernav
         blijft vast en schuift naar top 0; omhoog (≥ 8px) = header terug. Op alle breedtes gelijk (P1) — draait J76 om (daar
         verdween < 990 juist de ankernav). Alleen deze PDP: dit bestand laadt alleen op product.bureau-v2.
         "Menu/winkelwagen open" (R3, nagelopen in de Symmetry-bron, 29-09): mobiel menu = body.reveal-mobile-nav
         (main.js theme.openMobileNav; #main-nav krijgt nooit aria-hidden); zoeken = body.show-search (PageHeader);
         winkelwagen = .js-cart-drawer[open] (<cart-drawer class="drawer … js-cart-drawer">, SideDrawer.open() zet [open]
         + aria-hidden=false; een .cart-drawer-klasse, .drawer--open of [data-cart-drawer] bestaan in dit thema niet);
         desktopmenu = .section-header--nav-open (Symmetry-dropdown) of een Stane-megamenu onder de muis
         (snippets/custom-mega-nav.liquid: opent op :hover/:focus-within; focus-within valt al onder "focus in de header"). */
      var kopMoetBlijven = function () {
        var a = document.activeElement, h = document.querySelector('.section-header');
        return scrollY < kopHoogte() || (h && a && h.contains(a)) || document.documentElement.classList.contains('bv2-paneel-open')
          || !!document.querySelector('body.reveal-mobile-nav, body.show-search, .js-cart-drawer[open], .section-header--nav-open, .section-header .cmega__item--mega:hover');
      };
      function zetKop(weg) { document.documentElement.classList.toggle('bv2-kop-weg', !!weg && !kopMoetBlijven()); }
      function richting() {
        if (navVastgehouden) return;
        var y = scrollY, d = y - laatsteY;
        if (y < kopHoogte()) { zetKop(false); laatsteY = y; return; }
        if (Math.abs(d) < 8) return;
        laatsteY = y;
        zetKop(d > 0 && nav.dataset.vast === 'true');
      }
      window.addEventListener('scroll', richting, { passive: true });
      document.addEventListener('focusin', function (e) { var h = document.querySelector('.section-header'); if (h && h.contains(e.target)) zetKop(false); });
      function navVrijgeven() {
        if (!navMinKlaar || !navStilKlaar) return;
        navVastgehouden = false;
        laatsteY = scrollY; /* de sprong telt niet mee als scrollrichting (bevinding 2) */
      }
      /* Fix-ronde 2: één opruimfunctie voor alle "tot rust"-luisteraars/timers, aangeroepen zodra de rust
       * vaststaat (idempotent via navStilKlaar) én bij een nieuwe tik (voorkomt dat een oude timer een
       * lopende nieuwe hold te vroeg lostrekt). */
      function navStilOpruimen() {
        clearTimeout(navStilTimer); navStilTimer = null;
        clearTimeout(navPlafondTimer); navPlafondTimer = null;
        if (navStilLuisteraar) { window.removeEventListener('scroll', navStilLuisteraar); navStilLuisteraar = null; }
        if (navScrollendLuisteraar) { window.removeEventListener('scrollend', navScrollendLuisteraar); navScrollendLuisteraar = null; }
      }
      function navStilKlaarZet() {
        if (navStilKlaar) return;
        navStilKlaar = true;
        navStilOpruimen();
        navVrijgeven();
      }
      /* kopBlijft === true: dezelfde hold, maar de header blijft zoals hij is (Trustpilot-regel, zie onder "spring"). */
      function navHoud(kopBlijft) {
        navVastgehouden = true; navMinKlaar = false; navStilKlaar = false;
        if (kopBlijft !== true) zetKop(true);
        clearTimeout(navMinTimer);
        navStilOpruimen(); /* ruimt ook een eventuele lopende hold van een vorige tik op */
        navMinTimer = setTimeout(function () { navMinKlaar = true; navVrijgeven(); }, 600);
        /* Fix-ronde 2, bevinding (controller-review): een ankerdoel dat al in beeld staat (of onderaan de
         * pagina) laat geen scroll zien — `scrollend` vuurt dan nooit, dus zonder vangnet bleef
         * navVastgehouden voorgoed waar en verscheen/verdween de nav de rest van de sessie niet meer.
         * Plafond van 3 s (ruim boven elke smooth-scroll-duur op deze pagina, fix-ronde 1: ± 2359px landde
         * ruim binnen 1 s) trekt de hold sowieso los, ook als geen enkel scroll/scrollend-event ooit komt. */
        navPlafondTimer = setTimeout(function () { navMinKlaar = true; navStilKlaarZet(); }, 3000);
        /* zelfstartende 150 ms-stilteklok, nu ALTIJD actief (niet meer alleen als fallback zonder
         * scrollend): dekt zowel "geen scroll-event kwam" (stilCheck() hieronder start de klok meteen,
         * vóór enig scroll-event) als het normale pad (elk scroll-event herstart hem). Race met
         * `scrollend` waar die bestaat — wie het eerst komt wint, navStilKlaarZet is idempotent. */
        var stilCheck = function () { clearTimeout(navStilTimer); navStilTimer = setTimeout(navStilKlaarZet, 150); };
        navStilLuisteraar = stilCheck;
        window.addEventListener('scroll', stilCheck, { passive: true });
        stilCheck();
        if ('onscrollend' in window) {
          navScrollendLuisteraar = navStilKlaarZet;
          window.addEventListener('scrollend', navScrollendLuisteraar);
        }
      }
      /* verbeter 29-09 A16: ankerdoel direct onder de ankernav, ook met de header weg. Oorzaak bewezen (T5b,
       * metingen/2026-09-29-bureau-v2-feedback/t5b/oorzaak-ankerlanding.txt): de enige scroll na een ankernavklik was
       * Symmetry's internalLinksSmoothScroll (document-click, main.js) → scrollTo(elTop − 100 − --theme-sticky-header-height);
       * 390: band op 145, 1440: op 170, terwijl de ankernav (header weg) al op 54/55 eindigt. Zelfde fix als de
       * Trustpilot-regel (h195): preventDefault + stopPropagation, dan zelf springen naar doel − (header als die blijft +
       * ankernav + 8) — binnen de settle-hold van navHoud (h212), zodat richting() de header tijdens de sprong niet omzet
       * (een sprong omhoog zou hem anders halverwege terugzetten en het doel onder de header verstoppen). Daarna focus op de
       * bandkop (tabindex -1, preventScroll), zoals de Trustpilot-regel: toetsenbord en schermlezer verhuizen mee, net als bij
       * een native anker (dat de themahandler na de eerste Tab doorliet). */
      function spring(e) {
        var doel = document.querySelector(this.getAttribute('href'));
        if (!doel) return;
        e.preventDefault(); e.stopPropagation();
        navHoud();
        var rustig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var boven = (document.documentElement.classList.contains('bv2-kop-weg') ? 0 : kopHoogte()) + Math.round(nav.getBoundingClientRect().height) + 8;
        /* ≥ 990 met beweging staat een nog niet onthulde band op translateY(12px) ([data-bv2-reveal]:not(.is-in)); de rect telt
           die mee, dus zonder aftrek landde de band na de onthulling 12 px te hoog, deels onder de ankernav (1440: 51 vs 55,
           t5b/reveal-offset-bewijs.txt). Aftrekken van de huidige translateY = de layoutpositie. */
        var tf = getComputedStyle(doel).transform, ty = (tf && tf !== 'none' && window.DOMMatrix) ? new DOMMatrix(tf).m42 : 0;
        window.scrollTo({ top: Math.max(0, Math.round(doel.getBoundingClientRect().top - ty + scrollY - boven)), behavior: rustig ? 'instant' : 'smooth' });
        var kop = doel.querySelector('h2') || doel;
        if (!kop.hasAttribute('tabindex')) kop.setAttribute('tabindex', '-1');
        setTimeout(function () { kop.focus({ preventScroll: true }); }, rustig ? 0 : 600);
      }
      links.forEach(function (a) { a.addEventListener('click', spring); });
      /* De Trustpilot-regel in het koopblok (#bv2-reviews, eigen IIFE verderop, J52) landt via de scroll-margin-top van de band
       * (header + 62) en staat alleen in beeld als de header er is. Zonder hold zette richting() de header halverwege die zachte
       * sprong weg (omlaag + ankernav vast): de band landde 53 px (390) / 65 px (1440) onder de ankernav (verbeter.mjs --toets
       * kopweg, gereproduceerd vóór deze regel). Dus dezelfde hold (h212), met de header zoals hij is. Deze luisteraar staat
       * eerder in het bestand dan die van de regel en loopt dus vóór diens scrollIntoView. */
      var tpRegel = document.querySelector('[data-band="koopblok"] a.stp[href="#bv2-reviews"]');
      if (tpRegel) tpRegel.addEventListener('click', function () { navHoud(true); });
      /* winkelwagen open (bv. ATC vanuit de balk terwijl de header weg is) → header terug: het winkelwagenicoon met het nieuwe
       * aantal staat erin. Symmetry's SideDrawer.open() vuurt on:cart-drawer:before-open (bubbelt, main.js/cart-drawer.js). */
      document.addEventListener('on:cart-drawer:before-open', function () { zetKop(false); });
      /* spec §2.10: elke nieuwe matchMedia-gate krijgt een change-listener. Een wissel over 990 herzet laatsteY, zodat de
       * eerstvolgende scroll niet de resize-sprong als richting leest, en zet de header terug (A16) tot die eerstvolgende
       * scroll zelf beslist. (Eindgolf 30-09: de J76-regels die `data-verborgen` weghaalden zijn weg — sinds A16 zet niets in
       * thema, toetsen of scripts dat attribuut nog; hier, in richting() en in navHoud() stond telkens een dode regel.) */
      function opMqWissel() { laatsteY = scrollY; zetKop(false); }
      if (mq.addEventListener) mq.addEventListener('change', opMqWissel);
      else if (mq.addListener) mq.addListener(opMqWissel);
      /* livegang 01-10 (opdracht A): WCAG 2.4.11 Focus Not Obscured (AA). Met Tab/Shift+Tab verdween de focus helemaal onder het
       * vaste chroom (tests/bureau-v2/focuszicht.mjs, ROOD: metingen/2026-10-01-bureau-v2-livegang/a-focus/rood.txt): de browser
       * scrolt een gefocust element alleen tot de viewportrand en weet niets van header, vaste ankernav of bestelbalk, en omhoog
       * scrollen zet de header terug (A16) over een element dat net bovenaan landde. Geen html { scroll-padding-top }: dat telt op
       * bij de scroll-margin-top van de banden (h238), en het chroom wisselt per scrollrichting en -positie (header weg/terug,
       * ankernav statisch/vast, bestelbalk aan/uit), dus een vaste waarde is op de ene plek te weinig en op de andere te veel.
       * Daarom: na een TOETSENBORDfocus (:focus-visible) wachten tot de scroll van de browser stilstaat, dan het zichtbare chroom
       * uit de toestand lezen (klasse bv2-kop-weg, data-vast, data-zichtbaar; niet uit een rect die nog in een transitie zit) en
       * het element zo nodig vrij scrollen (8 px marge), binnen de hold van navHoud(true): de header blijft dan zoals hij is en
       * de correctie telt niet als scrollrichting (h212). Een eigen ankersprong (spring) focust zijn bandkop al onder de ankernav
       * (+ 8), dus daar doet dit niets; muis, aanraking of scrollen door de gebruiker breekt een wachtende correctie af, en een
       * element dat helemaal buiten beeld staat (focus terug naar een opener met preventScroll) blijft waar het is.
       * Fixronde 1 (review, Important; 2.4.7/2.4.11): dat "buiten beeld = bewust" geldt NIET voor focus via Tab. De "Beweging
       * stoppen"-knop (.bv2-beweging-stop) is een vak van 1 px dat de browser in beeld scrolt en dat daarna bij :focus-visible tot
       * 40/44 px groeit, net buiten de rand (met beweging: y [860,904] bij vh 844, fix1/rood.txt). Komt de focus ≤ 150 ms na een
       * Tab-keydown (capture, vóór elke andere luisteraar), dan scrolt dit ook een element buiten beeld vrij. Na een eigen
       * correctie volgt één hercontrole (de scroll kan het chroom laten omklappen: bestelbalk aan/uit, ankernav vast); daarna stopt
       * het (lusbewaking). */
      var focusEl = null, focusTimer = null, focusTot = 0, focusTab = false, focusRonde = 0, laatsteTab = 0;
      var focusBuiten = 'nav[data-bv2-ankernav][data-vast="true"], .section-header, [data-bv2-sticky], dialog, .js-cart-drawer, [aria-modal="true"]';
      function focusVrij() {
        focusTimer = null;
        var el = focusEl; focusEl = null;
        if (!el || el !== document.activeElement || Date.now() > focusTot) return;
        var r = el.getBoundingClientRect();
        /* helemaal buiten beeld zonder Tab = bewust zo gefocust (focus terug naar de opener met preventScroll, paneel-sluiten):
           niet springen. Via Tab is een stop buiten beeld nooit bedoeld (fixronde 1). */
        if (r.width < 1 || r.height < 1) return;
        if (!focusTab && (r.bottom <= 0 || r.top >= window.innerHeight)) return;
        var weg = document.documentElement.classList.contains('bv2-kop-weg'), kop = document.querySelector('.section-header'), boven = 0;
        if (kop && !weg) {
          var tk = getComputedStyle(kop).transform;
          boven = kop.getBoundingClientRect().bottom - ((tk && tk !== 'none' && window.DOMMatrix) ? new DOMMatrix(tk).m42 : 0);
        }
        if (nav.dataset.vast === 'true') boven = Math.max(boven, (weg ? 0 : parseFloat(getComputedStyle(nav).top) || 0) + nav.getBoundingClientRect().height);
        var onder = window.innerHeight;
        if (st && st.dataset.zichtbaar === 'true') onder = Math.min(onder, st.getBoundingClientRect().top);
        var dy;
        if (r.top < boven) dy = r.top - boven - 8;
        else if (r.bottom > onder) dy = Math.min(r.bottom - onder + 8, r.top - boven - 8); /* nooit de bovenkant onder het chroom schuiven */
        else return;
        dy = Math.round(dy);
        if (!dy || (r.top >= boven && dy < 0)) return;
        var rustig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        navHoud(true);
        window.scrollTo({ top: Math.max(0, scrollY + dy), behavior: rustig ? 'instant' : 'smooth' });
        /* één hercontrole na deze correctie (lusbewaking: hoogstens één extra ronde per focus) */
        if (focusRonde < 1) { focusRonde++; focusEl = el; focusTot = Date.now() + 3000; focusPlan(); }
      }
      function focusPlan() { clearTimeout(focusTimer); focusTimer = setTimeout(focusVrij, 120); }
      function focusLos() { focusEl = null; clearTimeout(focusTimer); focusTimer = null; }
      document.addEventListener('focusin', function (e) {
        var el = e.target, toets = true;
        if (!el || el === document.body || !el.getBoundingClientRect) return focusLos();
        try { toets = el.matches(':focus-visible'); } catch (x) {}
        if (!toets || el.closest(focusBuiten)) return focusLos();
        focusEl = el; focusTot = Date.now() + 3000; focusTab = Date.now() - laatsteTab <= 150; focusRonde = 0; focusPlan();
      });
      /* de scroll van de browser (zacht via html { scroll-behavior: smooth } in main.css) moet eerst tot rust komen */
      window.addEventListener('scroll', function () { if (focusEl) focusPlan(); }, { passive: true });
      ['wheel', 'touchstart', 'pointerdown'].forEach(function (t) { window.addEventListener(t, focusLos, { passive: true }); });
      window.addEventListener('keydown', function (e) {
        if (e.key === 'Tab') laatsteTab = Date.now();
        else if (e.key !== 'Shift') focusLos();
      }, true);
      /* videofeedback 30-09 V6/V12 (B6): het meeschuiven van de linkrij (was een MutationObserver op aria-current) zit nu in
         zet() van de scrollspy-IIFE hieronder, met zachte scroll en "minder beweging" (was een harde scrollLeft-sprong). */
    }
  }
})();

/* videofeedback 30-09 V6/V12 (B6, AFWIJKINGEN #216): scrollspy voor de ankernav. Jory: "een subtiel balkje of streepje onder elke
 * sectie, waar je precies zit" (desktop V6, mobiel V12). Actief = de (onderste) sectie waarvan de bovenkant boven de onderrand van de
 * ankernav (+ 8 px, + 1 px afronding, + TOL 2 px subpixelzone: de eigen ankersprong landt rond Math.round(navhoogte) + 8) ligt; boven
 * de eerste sectie en voorbij de onderkant van de onderste band niets (fixgolf: onafhankelijk van de nav-volgorde). De rect van de nav wordt elke keer gemeten (hij schuift met transform als de
 * header weg/terug gaat, A16) en een nog niet onthulde band telt zonder zijn reveal-translate (h238), anders sprong de markering
 * na de onthulling nog 12 px. Eén rAF per scroll, alleen metingen (geen layout-writes).
 * Klik: de ankernav-IIFE hierboven doet bij een linkklik preventDefault + stopPropagation (h195, Symmetry's smooth-scroll) en
 * springt zelf; een bubbelende luisteraar op de nav hoort de klik dus nooit. Daarom capture op document (loopt vóór de link-
 * luisteraar en overleeft ook een herrenderde nav). De klik zet meteen de gekozen link en houdt die vast tot de sprong stilstaat
 * (settle-hold, h212): minimaal 1200 ms én 180 ms zonder scroll (of `scrollend`), plafond 4 s; anders liep de markering tijdens
 * de zachte sprong door de tussenliggende secties. Mobiel schuift de linkrij (nooit de pagina) de actieve link in beeld. Event
 * `bv2:anker-actief` (detail.id) voor latere metingen/GTM; niets hangt ervan af. */
(function () {
  var SEL = 'nav[data-bv2-ankernav]';
  var nav = document.querySelector(SEL);
  if (!nav) return;
  var minder = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var links = [], huidig = null, gepland = false;
  var houden = false, minKlaar = true, stilKlaar = true, minT = null, stilT = null, plafondT = null;
  /* fixgolf videofeedback K3: TOL = afrondingszone op de grens (de eigen ankersprong landt subpixel op 63,5–64,5 bij een grens van 64,0:
     zonder zone sprong aria-current na de settle-hold in ± 40 % van de klikken op 1024/1280/1440 terug naar de vorige sectie).
     naKlik = de geklikte link; de eerste meting na de settle-hold houdt hem actief als zijn doel binnen ± 4 px van de grens staat. */
  var TOL = 2, naKlik = null;
  function verzamel() {
    nav = document.querySelector(SEL);
    links = !nav ? [] : Array.prototype.slice.call(nav.querySelectorAll('a[href^="#"]')).map(function (a) {
      var doel = null; try { doel = document.querySelector(a.getAttribute('href')); } catch (e) { doel = null; }
      return { a: a, doel: doel };
    }).filter(function (x) { return x.doel; });
  }
  /* een link telt alleen mee als hij zichtbaar is en zijn doel nog bestaat en nog dat id draagt (merchant/editor kan beide wijzigen) */
  function geldig(x) { return !x.a.hidden && x.doel.isConnected && '#' + x.doel.id === x.a.getAttribute('href'); }
  function zet(id) {
    if (id === huidig || !nav) return;
    huidig = id;
    var act = null;
    Array.prototype.forEach.call(nav.querySelectorAll('a[href^="#"]'), function (a) {
      if (id && a.getAttribute('href') === id && !a.hidden) { a.setAttribute('aria-current', 'location'); act = a; }
      else a.removeAttribute('aria-current');
    });
    var rij = nav.querySelector('.bv2-ankernav__links'), doelLinks = null;
    if (rij && act && rij.scrollWidth > rij.clientWidth) {
      var r = act.getBoundingClientRect(), c = rij.getBoundingClientRect();
      if (r.left < c.left + 8 || r.right > c.right - 8) doelLinks = rij.scrollLeft + (r.left - c.left) - (c.width - r.width) / 2;
    }
    /* niets actief (koopblok bovenaan, of na de FAQ): de rij terug naar het begin, de ruststand zoals ontworpen. Anders bleef hij na een
       bezoek aan de FAQ naar rechts gescrold staan en zette een Tab naar "In het kort" de link tegen de rand (focusring links geknipt,
       verbeter.mjs focusring 390 E3 ankernav-link). */
    if (rij && !id && rij.scrollLeft > 0) doelLinks = 0;
    /* Element.scrollTo op de rij: horizontaal, alleen de rij (nooit scrollIntoView, dat zou de pagina meenemen) */
    if (doelLinks !== null) { if (rij.scrollTo) rij.scrollTo({ left: doelLinks, behavior: minder ? 'auto' : 'smooth' }); else rij.scrollLeft = doelLinks; }
    try { document.dispatchEvent(new CustomEvent('bv2:anker-actief', { detail: { id: id } })); } catch (e) { /* oude browsers: geen event */ }
  }
  function bovenkant(el) {
    var top = el.getBoundingClientRect().top, tf = getComputedStyle(el).transform;
    if (tf && tf !== 'none' && window.DOMMatrix) { try { top -= new DOMMatrix(tf).m42; } catch (e) { /* onleesbare matrix: rect zoals hij is */ } }
    return top;
  }
  /* fixgolf videofeedback T6-minor (regel 8): niet meer afhankelijk van de nav-volgorde (een merchant kan secties in de editor herordenen
     zonder de links mee te verplaatsen). Actief = de link met de grootste doel-top <= grens (bij gelijke top de latere link, zoals vroeger);
     voorbij de band met de grootste bodem niets (was: de band van de laatste nav-link). */
  function meet() {
    gepland = false;
    if (houden || !nav) return;
    var basis = nav.getBoundingClientRect().bottom + 8 + 1, grens = basis + TOL, id = null, besteTop = -Infinity, bodem = -Infinity, iets = false;
    if (naKlik) {
      var k = naKlik; naKlik = null;
      if (geldig(k) && Math.abs(bovenkant(k.doel) - basis) <= 4) { zet(k.a.getAttribute('href')); return; }
    }
    for (var i = 0; i < links.length; i++) {
      if (!geldig(links[i])) continue;
      iets = true;
      var t = bovenkant(links[i].doel);
      if (t <= grens && t >= besteTop) { besteTop = t; id = links[i].a.getAttribute('href'); }
      var b = (links[i].doel.closest('[data-band]') || links[i].doel).getBoundingClientRect().bottom;
      if (b > bodem) bodem = b;
    }
    if (iets && bodem < basis) id = null;
    zet(id);
  }
  function plan() { if (!gepland) { gepland = true; window.requestAnimationFrame(meet); } }
  function loslaten() {
    if (!minKlaar || !stilKlaar) return;
    houden = false;
    clearTimeout(plafondT);
    window.removeEventListener('scroll', stilte);
    window.removeEventListener('scrollend', stilKlaarZet);
    plan();
  }
  function stilKlaarZet() { stilKlaar = true; clearTimeout(stilT); loslaten(); }
  function stilte() { stilKlaar = false; clearTimeout(stilT); stilT = setTimeout(stilKlaarZet, 180); }
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest(SEL + ' a[href^="#"]');
    if (!a) return;
    var x = null;
    for (var i = 0; i < links.length; i++) if (links[i].a === a && geldig(links[i])) x = links[i];
    if (!x) return; /* geen doel: de ankernav-IIFE springt ook niet */
    zet(a.getAttribute('href'));
    naKlik = x;
    houden = true; minKlaar = false;
    clearTimeout(minT); clearTimeout(plafondT);
    minT = setTimeout(function () { minKlaar = true; loslaten(); }, 1200);
    plafondT = setTimeout(function () { minKlaar = true; stilKlaar = true; loslaten(); }, 4000);
    window.removeEventListener('scroll', stilte);
    window.addEventListener('scroll', stilte, { passive: true });
    if ('onscrollend' in window) { window.removeEventListener('scrollend', stilKlaarZet); window.addEventListener('scrollend', stilKlaarZet); }
    stilte();
  }, true);
  verzamel();
  window.addEventListener('scroll', plan, { passive: true });
  window.addEventListener('resize', function () { verzamel(); plan(); });
  document.addEventListener('shopify:section:load', function () { huidig = null; verzamel(); plan(); });
  plan();
})();

/* ---------- fase 5 J45/J54: set-kaart — stoel + bureau, aantal, één knop (spec §3.4) ----------
 * Vervangt de vier bundelkaarten (2×2) en de bundel-popup van fase 4. Bron = [data-bv2-productdata]
 * (de acht bundel-blokken); de pure logica staat in custom-bureau-v2-varianten.js (setStoelen, setBladen,
 * setBundel, setMaten, setBureauStart, setPrijs; unit-getest). Gedrag:
 *   - stoel: vier knoppen (aria-pressed, volgorde = oplopende "vanaf"); sinds verbeter 29-09 (A2), daarvóór
 *     een beeld-dropdown (listbox). Een klik kiest, de focus blijft op de gekozen knop; de badge staat op de tegel.
 *   - zitting: knoppen als de stoel er een heeft; anders blijft de rij staan met "Eén uitvoering".
 *     De laatst gekozen zitting blijft de voorkeur (Premium Schuim → Pro → Premium = weer Schuim).
 *   - bureau: blad (stalen, gekloond uit de koopblok-knoppen) + maat (op oppervlak); volgt de
 *     koopblok-selectie tot de bezoeker in de set zelf een blad of maat kiest. Een stoel- of
 *     zittingkeuze telt daarbij niet mee: die zegt niets over het bureau.
 *   - koopregel: stepper 1..set_max_aantal, setprijs × n, "los" × n, "Bespaar" (los − set) × n.
 *     1 POST /cart/add.js met { id, quantity: n }; mislukt het, dan de reden in de eigen live region.
 * Beeldwissel via bv2WisselBeeld op de twee beeldvakken, één keer opgezocht bij init: het img met de
 * data-attribuut-haak wordt bij elke wissel vervangen door een kloon, dus een per-render
 * querySelector(...).parentNode zou na de tweede wissel naar een losgekoppeld element wijzen. */
(function () {
  'use strict';
  var B = window.BureauV2, V = window.BureauV2Varianten; if (!B || !V || !V.setStoelen) return;
  var box = document.querySelector('[data-bv2-set]'); if (!box) return;
  var data = B.data, stoelen = V.setStoelen(data); if (!stoelen.length) return;
  box.hidden = false;
  var q = function (s) { return box.querySelector(s); };
  var ds = box.dataset, max = Math.max(1, Number(ds.max) || 10);
  var bladI = -1, frameI = -1;
  data.opties.forEach(function (n, k) { if (/blad/i.test(n)) bladI = k; else if (/frame/i.test(n)) frameI = k; });
  var stoelVak = q('[data-bv2-set-stoelvak]'), bureauVak = q('[data-bv2-set-bureauvak]');
  /* fase 6 S3 fixronde 1 (Important 3): loading='lazy' op het gekloonde <img> in bv2WisselBeeld
     (Task 13) is alleen een DOM-attribuut — de functie zet de bron altijd meteen en wacht op
     decode() vóórdat het element in de DOM komt (nodig: decode() op een losgekoppeld
     loading=lazy-element hangt, zie bv2WisselBeeld zelf), dus de fetch start onveranderd meteen bij
     `render()`, dat hier synchroon bij page-load draait. Spec §4 S3 wil de fetch pas als de
     set-kaart in de buurt van de viewport komt. Kleinste wijziging: de EERSTE beeldwissel
     (stoel-/bureau-vak, de zware afbeeldingen) uitstellen tot een IntersectionObserver
     (rootMargin 300px) het vak meldt; latere wissels (klik op de kaart/dropdown/staal) gaan altijd
     direct — de kaart is dan al zichtbaar (de gebruiker klikt erop) en J42's crossfade blijft
     ongewijzigd. De mini-thumbnail (32 px, ook pas zichtbaar ná scroll) ging in dezelfde gate (verbeter 29-09: weg met de dropdown). */
  var beeldenKlaar = !('IntersectionObserver' in window);
  /* verbeter 29-09 (D2): gedeeld eerste woord ("Stane ") valt weg op de knop als data-kort="true" en álle namen ermee beginnen */
  var sbWortel = q('[data-bv2-set-stoelen]');
  var voorvoegsel = (function () {
    if (!sbWortel || sbWortel.getAttribute('data-kort') !== 'true' || stoelen.length < 2) return '';
    var w = stoelen[0].stoelNaam.split(' ')[0] + ' ';
    return stoelen.every(function (s) { return s.stoelNaam.indexOf(w) === 0 && s.stoelNaam.length > w.length; }) ? w : '';
  })();
  function korteNaam(n) { return voorvoegsel ? n.slice(voorvoegsel.length) : n; }
  var atc = q('[data-bv2-set-atc]'), melding = q('[data-bv2-set-melding]'), aankondiging = q('[data-bv2-set-aankondiging]');
  /* eindfix 4: één live region (de status). `melding` = zichtbaar (niet leverbaar / fout), `aankondiging`
     = sr-only setprijs. Alleen schrijven bij een echte wissel; `vorige` start op de init-waarde, dus bij
     laden wordt er niets voorgelezen. */
  var vorige = null;
  function schrijf(el, t) { if (el && el.textContent !== t) el.textContent = t; }
  function kondigAan(t, stil) { if (t === vorige) return; var eerste = vorige === null; vorige = t; if (!eerste && !stil) schrijf(aankondiging, t); }
  /* bestaat set_standaard_stoel niet, dan de eerste stoel in blokvolgorde (spec §3.4), niet de goedkoopste */
  var eersteNaam = (data.bundels[0] && (data.bundels[0].stoelNaam || data.bundels[0].titel)) || '';
  var perNaam = function (naam) { return stoelen.filter(function (s) { return s.stoelNaam === naam; })[0]; };
  var stoel = perNaam(ds.standaardStoel) || perNaam(eersteNaam) || stoelen[0];
  /* standaardmaat genormaliseerd vergelijken, zoals setBureauStart ("140x80 cm" = "140 x 80 cm") */
  var maatUit = function (maten, m) { var h = null; maten.forEach(function (x) { if (!h && V.normMaat(x) === V.normMaat(m)) h = x; }); return h; };
  var zittingVoorkeur = ds.standaardZitting || '', keuze = null, aantal = 1, bureauAangepast = false;

  function zittingVoor(s) { return s.zittingen.indexOf(zittingVoorkeur) !== -1 ? zittingVoorkeur : (s.zittingen[0] || ''); }
  function bureauStart() { return V.setBureauStart(data, B.selectie(), stoel, ds.standaardMaat); }
  function stoelBeeld() {
    var b = V.setBundelVoor(stoel, keuze), v = null;
    if (keuze.zitting && b.stoel && b.stoel.varianten) b.stoel.varianten.forEach(function (x) { if (!v && x.zitting === keuze.zitting && x.beeld) v = x; });
    return (v && v.beeld) || stoel.beeld || '';
  }
  function bureauBeeld() {
    /* Task 8 (bundels V2): het frame komt bij een V2-stoel uit de keuze (configurator), anders uit het blok */
    var b = V.setBundelVoor(stoel, keuze), hit = null, fr = stoel.model ? keuze.frame : b.frame;
    data.varianten.forEach(function (v) {
      if (hit || !v.beeld || V.normMaat(v.opties[data.maatIndex]) !== V.normMaat(keuze.maat)) return;
      if (bladI >= 0 && v.opties[bladI] !== keuze.blad) return;
      if (frameI >= 0 && fr && v.opties[frameI] !== fr) return;
      hit = v;
    });
    return hit ? hit.beeld : (b.beeldGroot || b.beeld || '');
  }
  function knop(label, gedrukt, attr, waarde, kl) {
    var k = document.createElement('button'); k.type = 'button'; k.className = kl || 'bv2-set__keuze';
    k.setAttribute(attr, waarde); k.setAttribute('aria-pressed', String(gedrukt)); k.textContent = label; return k;
  }
  /* kop: hoogste echte besparing (%) over alle setvarianten, anders de kop zonder besparing (J63). Het
     [accent]…[/accent]-paar in de sjabloon wordt kobalt (J62, spec §2: kobalt-woord in een kop mag,
     kobalt als vlak blijft de vier koopknoppen). textContent per deel: geen innerHTML van merchant-tekst. */
  function kop() {
    var h = q('[data-bv2-set-kop]'), maxP = V.maxBespaarProcent(data, stoelen);
    var t = maxP > 0 ? (h.dataset.sjabloon || '').replace('[procent]', maxP + '%') : (h.dataset.zonder || '');
    h.textContent = '';
    V.accentDelen(t).forEach(function (d) {
      if (!d.accent) { h.appendChild(document.createTextNode(d.tekst)); return; }
      var sp = document.createElement('span'); sp.className = 'bv2-accent'; sp.textContent = d.tekst; h.appendChild(sp);
    });
  }
  /* eindfix 1 (whole-branch review): de vakbeelden kwamen als vaste width=280 zonder 2x-bron, dus wazig op
     DPR 2 (vak 139–433 css-px, gemeten op 360…1920). Nu: 1x- en 2x-bron uit de gemeten vakbreedte
     (V.beeldOpMaat, treden ≤ 1,2×), via de bestaande src2x van bv2WisselBeeld. Het vak heeft zijn maat
     al (aspect-ratio, zichtbaar) op het moment dat de IntersectionObserver hierboven de eerste wissel
     toelaat. Geen maat (verborgen) of geen width-parameter = de oorspronkelijke bron, zonder 2x. De
     mini (32 px) hield zijn eigen 80 w-bron (beeldKlein) en raakte dit niet (verbeter 29-09: de mini is weg). */
  /* mobiel J71 (spec §3.5, F6.6:241): < 990 is het vak een kleine 1:1-tegel; daar één bron op tegelmaat ×
     devicePixelRatio (tot 3), zonder srcset. Met 1x/2x-descriptoren kreeg een DPR-3-scherm het 2x-beeld.
     ≥ 990 ongewijzigd (1x + 2x), dus desktop laadt hetzelfde beeld als vóór deze ronde. */
  var mqGroot = window.matchMedia('(min-width: 990px)');
  function opMaat(vak, src) {
    var css = vak ? vak.getBoundingClientRect().width : 0;
    if (!mqGroot.matches) {
      var d = Math.min(3, Math.max(1, window.devicePixelRatio || 1)), op = V.beeldOpMaat(src, css, d);
      window.bv2WisselBeeld(vak, op || src, null);
      return;
    }
    var een = V.beeldOpMaat(src, css, 1);
    window.bv2WisselBeeld(vak, een || src, een ? V.beeldOpMaat(src, css, 2) : null);
  }
  /* fix-ronde 1 (spec §2.10): live kruising van 990 = opnieuw kiezen (enkele tegelbron ↔ 1x/2x). __bv2Doel leeg
     maken, anders slaat bv2WisselBeeld de wissel over als alleen de srcset verschilt (zelfde src). */
  function opMqWisselSet() {
    if (!beeldenKlaar) return;
    stoelVak.__bv2Doel = null; bureauVak.__bv2Doel = null;
    zetVakBeelden();
  }
  if (mqGroot.addEventListener) mqGroot.addEventListener('change', opMqWisselSet); else if (mqGroot.addListener) mqGroot.addListener(opMqWisselSet);
  function zetVakBeelden() {
    opMaat(stoelVak, stoelBeeld());
    opMaat(bureauVak, bureauBeeld());
  }
  if (!beeldenKlaar) {
    var io = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      beeldenKlaar = true; zetVakBeelden(); io.disconnect();
    }, { rootMargin: '300px' });
    io.observe(box);
  }
  function render() {
    var sb = q('[data-bv2-set-stoelen]'); sb.innerHTML = '';
    stoelen.forEach(function (s) {
      var kn = knop(korteNaam(s.stoelNaam), s === stoel, 'data-bv2-set-stoel', s.stoelNaam);
      /* iteratie 30-09 (F4, Jory: "zet bij premium nog subtiel 'bestseller badge'"; AFWIJKINGEN #201): de stoel met een bundel-label
         (template: badge "Bestseller" op de Premium-bundels, V.setStoelen → s.label) krijgt een kleine badge op de bovenrand van zijn
         knop, ook als een andere stoel gekozen is. Het label staat ook in de toegankelijke naam; de badge zelf is aria-hidden (anders
         hoor je hem dubbel). */
      var naam = s.label ? s.stoelNaam + ', ' + s.label : s.stoelNaam;
      if (naam !== korteNaam(s.stoelNaam)) kn.setAttribute('aria-label', naam);
      if (s.label) {
        var bdg = document.createElement('span'); bdg.className = 'bv2-set__knopbadge'; bdg.setAttribute('aria-hidden', 'true'); bdg.textContent = s.label;
        kn.appendChild(bdg); kn.classList.add('bv2-set__keuze--badge');
      }
      sb.appendChild(kn);
    });
    var bd = q('[data-bv2-set-badge]'); if (bd) { bd.hidden = !stoel.label; schrijf(bd, stoel.label || ''); }
    /* eerste render vóór de observer-trigger: alleen tekst/prijs, geen fetch (zie hierboven). Ná de
       eerste keer intersecten blijft beeldenKlaar true, dus elke latere klik ververst de vakken
       gewoon mee. */
    if (beeldenKlaar) zetVakBeelden();
    var zb = q('[data-bv2-set-zittingen]'); zb.innerHTML = '';
    if (stoel.zittingen.length) stoel.zittingen.forEach(function (z) { zb.appendChild(knop(z, z === keuze.zitting, 'data-bv2-set-zitting', z)); });
    else { var e = document.createElement('span'); e.className = 'bv2-set__een'; e.textContent = zb.dataset.een || ''; zb.appendChild(e); }
    var bb = q('[data-bv2-set-bladen]'); bb.innerHTML = '';
    V.setBladen(stoel).forEach(function (b) {
      var k = knop('', b === keuze.blad, 'data-bv2-set-blad', b, 'bv2-set__staal'); k.setAttribute('aria-label', b);
      /* zelfde staal als de koopblok-knop (img of gekleurde span), zoals de sticky-balk hem ook kloont */
      var bron = bladI >= 0 ? document.querySelector('[data-bv2-product] [data-bv2-optie="' + bladI + '"] [data-bv2-waarde="' + CSS.escape(b) + '"]') : null;
      var bi = bron && (bron.querySelector('img') || bron.querySelector('span[style*="background"]'));
      /* fase 6 S3 (J66): was removeAttribute('loading') (eager bij init, ook als de bron al lazy was);
         de bronknop staat altijd boven de vouw en is dus al geladen, dus een expliciete 'lazy' hier
         kost niets en houdt de kloon in de (verborgen tot geopend) set-kaart als lazy geboekt. */
      if (bi) { var kl = bi.cloneNode(true); kl.setAttribute('loading', 'lazy'); if (kl.tagName === 'IMG') kl.alt = ''; k.appendChild(kl); }
      bb.appendChild(k);
    });
    var bundel = V.setBundelVoor(stoel, keuze), setFrame = stoel.model ? keuze.frame : bundel.frame;
    q('[data-bv2-set-frame]').textContent = setFrame ? (ds.frameSjabloon || '').replace('[frame]', String(setFrame).toLowerCase()) : '';
    var mb = q('[data-bv2-set-maten]'); mb.innerHTML = '';
    var maatKort = mb.getAttribute('data-kort') === 'true';
    V.setMaten(bundel).forEach(function (m) {
      var vol = bv2WeergaveMaat(m), kn = knop(maatKort ? String(vol).replace(/\s?cm$/, '') : vol, m === keuze.maat, 'data-bv2-set-maat', m);
      if (maatKort) kn.setAttribute('aria-label', vol);
      mb.appendChild(kn);
    });
    q('[data-bv2-set-aantal]').textContent = String(aantal);
    /* aria-disabled i.p.v. disabled: de focus blijft op de knop als hij de grens bereikt */
    q('[data-bv2-set-min]').setAttribute('aria-disabled', String(aantal <= 1));
    q('[data-bv2-set-plus]').setAttribute('aria-disabled', String(aantal >= max));
    var pr = V.setPrijs(data, stoel, keuze, aantal);
    var prijs = q('[data-bv2-set-prijs]'), losregel = q('[data-bv2-set-losregel]'), los = q('[data-bv2-set-los]'), bes = q('[data-bv2-set-bespaar]');
    rijTeksten(pr);
    if (!pr) { schrijf(prijs, ''); losregel.hidden = true; bes.hidden = true; atc.disabled = true; atc.removeAttribute('data-id'); schrijf(aankondiging, ''); kondigAan('', true); schrijf(melding, ds.nietLeverbaar || ''); return; }
    schrijf(melding, ''); atc.disabled = false; atc.setAttribute('data-id', String(pr.id));
    schrijf(prijs, V.formatEuro(pr.set));
    losregel.hidden = pr.los === null; schrijf(los, pr.los === null ? '' : V.formatEuro(pr.los));
    bes.hidden = !(pr.bespaar > 0); schrijf(bes, pr.bespaar > 0 ? ds.bespaar + ' ' + V.formatEuro(pr.bespaar) : '');
    kondigAan((ds.aankondiging || '[prijs]').replace('[prijs]', V.formatEuro(pr.set)) + (pr.bespaar > 0 ? ', ' + ds.bespaar + ' ' + V.formatEuro(pr.bespaar) : ''));
  }

  function kiesStoel(naam) {
    var n = stoelen.filter(function (s) { return s.stoelNaam === naam; })[0]; if (!n) return;
    stoel = n;
    if (!bureauAangepast) {
      /* bureau volgt nog het koopblok: blad én maat samen uit dezelfde afleiding (nooit uit twee bladen) */
      var st = bureauStart(); keuze.blad = st.blad; keuze.maat = st.maat; keuze.frame = st.frame;
    } else {
      var bladen = V.setBladen(stoel); if (bladen.indexOf(keuze.blad) === -1) keuze.blad = bladen[0];
      var maten = V.setMaten(V.setBundelVoor(stoel, keuze));
      if (maten.indexOf(keuze.maat) === -1) keuze.maat = maatUit(maten, ds.standaardMaat) || maten[0];
    }
    keuze.zitting = zittingVoor(stoel); render();
  }

  /* Task 8 (bundels V2): blad of maat wisselen in de kaart = de dichtstbijzijnde echte configuratorcombinatie
     (bij een botsing wijkt het frame); de frameregel toont wat er dan in de set zit. */
  function kiesBureau(veld, waarde) { var nk = V.setBureauKies(data, keuze, veld, waarde); keuze.maat = nk.maat; keuze.blad = nk.blad; keuze.frame = nk.frame; }
  /* ---- keuzes ---- */
  box.addEventListener('click', function (e) {
    var st = e.target.closest('[data-bv2-set-stoel]'), z = e.target.closest('[data-bv2-set-zitting]'), b = e.target.closest('[data-bv2-set-blad]'), m = e.target.closest('[data-bv2-set-maat]');
    var attr;
    if (st) {
      if (st.getAttribute('aria-pressed') === 'true') return;
      kiesStoel(st.getAttribute('data-bv2-set-stoel')); /* rendert zelf */
      var terugSt = box.querySelector('[data-bv2-set-stoel][aria-pressed="true"]'); if (terugSt) terugSt.focus();
      return;
    }
    if (z) { attr = 'data-bv2-set-zitting'; keuze.zitting = zittingVoorkeur = z.getAttribute(attr); }
    else if (b) {
      attr = 'data-bv2-set-blad'; bureauAangepast = true;
      if (stoel.model) { kiesBureau('blad', b.getAttribute(attr)); }
      else {
        keuze.blad = b.getAttribute(attr);
        var ms = V.setMaten(V.setBundelVoor(stoel, keuze));
        if (ms.indexOf(keuze.maat) === -1) keuze.maat = maatUit(ms, ds.standaardMaat) || ms[0];
      }
    }
    else if (m) { attr = 'data-bv2-set-maat'; bureauAangepast = true; if (stoel.model) kiesBureau('maat', m.getAttribute(attr)); else keuze.maat = m.getAttribute(attr); }
    else return;
    render();
    /* de knoppen zijn opnieuw gebouwd: focus terug op de gekozen (h183) */
    var terug = box.querySelector('[' + attr + '][aria-pressed="true"]'); if (terug) terug.focus();
  });
  q('[data-bv2-set-min]').addEventListener('click', function () { if (aantal > 1) { aantal--; render(); } });
  q('[data-bv2-set-plus]').addEventListener('click', function () { if (aantal < max) { aantal++; render(); } });
  /* één POST-pad voor de kaartknop én de paneelknop (mobiel J71). `knopEl` krijgt aria-busy; `opener` is het
     element waar de lade de focus op terugzet. Een open set-paneel sluit alleen bij succes; bij een mislukking
     blijft het open en staat de reden in de live region, die dan in het paneel boven de voet staat. */
  function voegSetToe(knopEl, opener) {
    var id = atc.getAttribute('data-id');
    if (!id || atc.disabled || knopEl.getAttribute('aria-busy') === 'true') return;
    schrijf(melding, ''); schrijf(aankondiging, '');
    B.voegToe(id, knopEl, aantal, { fout: ds.fout, stil: true, opener: opener }).then(function (r) {
      if (!r || !r.ok) { schrijf(melding, (r && r.reden) || ds.fout || ''); return; }
      [dStoel, dBureau].forEach(function (d) { if (d && d.open) d.close(); });
    });
  }
  atc.addEventListener('click', function () { voegSetToe(atc); });
  B.opSelectie(function () {
    if (bureauAangepast) return;
    var s = bureauStart(); keuze.blad = s.blad; keuze.maat = s.maat; keuze.frame = s.frame; render();
  });
  /* ---- mobiel J71 (spec §3.5): twee rijen + twee panelen (< 990) ----
     De bestaande bediening blijft de enige bediening (één implementatie): bij openen verhuist de JS haar
     knopen het paneel in, bij sluiten (elke route: sluitknop, Escape, backdrop, terug-gebaar, resize over
     990 en succesvolle ATC, allemaal via het `close`-event van de dialog) terug achter een comment-marker
     op de exacte oude plek. De dialogs staan binnen `box`, dus de klik-delegatie hierboven blijft werken.
     In de kaart is die bediening < 990 display: none (CSS), dus het verhuizen verschuift niets (geen CLS).
     De live region (status) gaat mee: buiten een modale dialog is alles inert, dus anders zou de melding
     onzichtbaar en onhoorbaar zijn. bv2Paneel staat sinds eindfix 2 bovenaan dit bestand (vóór deze IIFE). */
  var rijStoel = q('[data-bv2-set-rij="stoel"]'), rijBureau = q('[data-bv2-set-rij="bureau"]');
  var dStoel = q('dialog[data-bv2-paneel="set-stoel"]'), dBureau = q('dialog[data-bv2-paneel="set-bureau"]');
  /* verbeter 29-09: de knoppen per stoel (i.p.v. de dropdown) + de zitting-rij; het bureau verhuist als twee delen (groep blad+frame, rij maat) */
  var DELEN = { 'set-stoel': ['[data-bv2-set-stoelen]', '.bv2-set__rij [data-bv2-set-zittingen]'], 'set-bureau': ['[data-bv2-set-item="bureau"] .bv2-set__groep', '.bv2-set__rij [data-bv2-set-maten]'] };
  function verplaats(el, doel, lijst) {
    var mark = document.createComment('bv2-set-plek'); el.parentNode.insertBefore(mark, el);
    doel.appendChild(el); lijst.push([mark, el]);
  }
  function verhuis(dlg) {
    if (dlg.__terug && dlg.__terug.length) return;
    var doel = dlg.querySelector('[data-bv2-set-paneel-inhoud]'), terug = [];
    DELEN[dlg.getAttribute('data-bv2-paneel')].forEach(function (sel) {
      var el = q('.bv2-set__blokken ' + sel); if (!el) return;
      verplaats(el.closest('.bv2-set__rij') || el, doel, terug); /* blad/maat: rij (label + knoppen) als geheel */
    });
    var st = q('[data-bv2-set-status]'); if (st && !st.closest('dialog')) verplaats(st, dlg.querySelector('[data-bv2-set-paneel-status]'), terug);
    dlg.__terug = terug;
  }
  function terugzetten(dlg) {
    (dlg.__terug || []).forEach(function (x) { if (x[0].parentNode) { x[0].parentNode.insertBefore(x[1], x[0]); x[0].parentNode.removeChild(x[0]); } });
    dlg.__terug = [];
  }
  function rijTeksten(pr) {
    if (rijStoel) {
      rijStoel.querySelector('[data-bv2-set-rijtekst]').textContent = stoel.stoelNaam + (keuze.zitting ? ' \u00b7 ' + keuze.zitting : '');
      var c = rijStoel.querySelector('[data-bv2-set-rijchip]'), sc = rijStoel.querySelector('[data-bv2-set-rijscheiding]');
      if (c) { c.hidden = !stoel.label; c.textContent = stoel.label || ''; }
      if (sc) sc.textContent = stoel.label ? ' \u00b7 ' : ''; /* fix-ronde 1: toegankelijke naam "… Schuim · Bestseller", zichtbaar ongewijzigd (sr-only) */
    }
    if (rijBureau) rijBureau.querySelector('[data-bv2-set-rijtekst]').textContent = [ds.bureauLabel || 'Bureau', keuze.blad, String(bv2WeergaveMaat(keuze.maat) || '').replace(/\s?cm$/, '')].filter(Boolean).join(' \u00b7 ');
    [dStoel, dBureau].forEach(function (d) {
      if (!d) return;
      schrijf(d.querySelector('[data-bv2-set-paneel-prijs]'), pr ? V.formatEuro(pr.set) : '');
      d.querySelector('[data-bv2-set-paneel-atc]').disabled = !pr;
    });
  }
  [[rijStoel, dStoel], [rijBureau, dBureau]].forEach(function (x) {
    var rij = x[0], dlg = x[1]; if (!rij || !dlg) return;
    rij.addEventListener('click', function () {
      if (!window.bv2Paneel) return;
      verhuis(dlg); window.bv2Paneel(dlg, rij);
      var f = dlg.querySelector('[data-bv2-set-paneel-inhoud] [aria-pressed="true"]');
      if (f) f.focus({ preventScroll: true });
    });
    dlg.addEventListener('close', function () { terugzetten(dlg); });
    var pAtc = dlg.querySelector('[data-bv2-set-paneel-atc]');
    pAtc.addEventListener('click', function () { voegSetToe(pAtc, rij); });
  });
  /* verbeter 29-09 D1: < 990 opent een tik op de tegel hetzelfde paneel als zijn rij (pointergemak; toetsenbord en
     schermlezer gebruiken de rij, dus geen extra tabstop en de tegel blijft decoratief). */
  [[stoelVak, rijStoel], [bureauVak, rijBureau]].forEach(function (x) {
    if (!x[0] || !x[1]) return;
    x[0].addEventListener('click', function () { if (!mqGroot.matches) x[1].click(); });
  });

  var s0 = bureauStart(); keuze = { blad: s0.blad, maat: s0.maat, frame: s0.frame, zitting: zittingVoor(stoel) };
  kop(); render();
})();

/* ---------- rails: ÉÉN implementatie voor samen kopen, bundels en dichtbij ----------
 * Task 10-eindreview, Important I4 (ruling F3): hier stonden drie bijna identieke
 * rail-implementaties (koopblok-`initRail` 2x aangeroepen + een eigen dichtbij-IIFE) die
 * `huidigeIndex()`/`bijwerken()`/`gaNaar()` regel voor regel dupliceerden — elke railfix moest
 * drie keer. Nu één `initRail(rail, opts)` met exact hetzelfde gedrag:
 *   - index = de kaart wiens linkerrand het dichtst bij de huidige scrollpositie ligt
 *   - pijlen krijgen `aria-disabled` op basis van scrollLeft t.o.v. de scrollbreedte
 *     (identiek aan beide oude versies; een lege rail = beide pijlen disabled)
 *   - `opts.dots` (dichtbij) krijgt `aria-current` op de actieve index
 *   - `opts.toetsen` (dichtbij) zet de pijltjestoets-bediening op de rail
 *   - `opts.kaarten` (selector) i.p.v. `rail.children` waar de rail meer bevat dan kaarten
 * Task 10, m3: de smooth scroll respecteert nu `prefers-reduced-motion` (werd alleen door de
 * slot-knop gecheckt); de CSS-pendant (`scroll-behavior`) staat in custom-bureau-v2.css.
 * Geen scroll-snap toegevoegd: de koopblok-rails hadden dat nooit, dit raakt geen touchgedrag. */
(function () {
  'use strict';

  function rustig() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function initRail(rail, opts) {
    if (!rail) return;
    opts = opts || {};
    var vorige = opts.vorige || [];
    var volgende = opts.volgende || [];
    var dots = opts.dots || [];
    var selector = opts.kaarten || null;
    var pijlenBox = opts.pijlenBox || null;

    function kaarten() {
      return selector
        ? [].slice.call(rail.querySelectorAll(selector))
        : [].slice.call(rail.children);
    }
    /* videofeedback V16: een rail met scroll-padding (dichtbij < 990: de rail loopt tot de schermrand, de eerste kaart staat
       op de paginamarge) snapt een kaart op zijn linkerrand mín die padding; zonder scroll-padding is dit 0 (addons). */
    function marge() { return parseFloat(getComputedStyle(rail).scrollPaddingLeft) || 0; }
    function huidigeIndex() {
      var links = rail.scrollLeft + marge(), beste = 0, kleinste = Infinity;
      kaarten().forEach(function (k, i) {
        var afstand = Math.abs(k.offsetLeft - rail.offsetLeft - links);
        if (afstand < kleinste) { kleinste = afstand; beste = i; }
      });
      return beste;
    }
    function bijwerken() {
      var leeg = !kaarten().length;
      var maxScroll = rail.scrollWidth - rail.clientWidth;
      var aanBegin = leeg || rail.scrollLeft <= 1;
      var aanEind = leeg || maxScroll <= 1 || rail.scrollLeft >= maxScroll - 1;
      if (pijlenBox) pijlenBox.hidden = maxScroll <= 1; /* fase 3 J12: past alles, dan geen pijltjes */
      vorige.forEach(function (b) { b.setAttribute('aria-disabled', String(aanBegin)); });
      volgende.forEach(function (b) { b.setAttribute('aria-disabled', String(aanEind)); });
      if (dots.length) {
        /* videofeedback V16 fixronde 1: als de rail aan zijn eind staat is de laatste stip actief — op tablet (twee kaarten +
           peek) ligt de eindpositie dichter bij kaart 3 dan bij kaart 4, zodat stip 4 anders nooit actief kon worden. */
        var idx = leeg ? 0 : (maxScroll > 1 && rail.scrollLeft >= maxScroll - 2 ? dots.length - 1 : huidigeIndex());
        dots.forEach(function (d, i) { d.setAttribute('aria-current', String(i === idx)); });
      }
    }
    function gaNaar(i) {
      var lijst = kaarten();
      var k = lijst[Math.max(0, Math.min(lijst.length - 1, i))];
      if (!k) return;
      rail.scrollTo({ left: k.offsetLeft - rail.offsetLeft - marge(), behavior: rustig() ? 'auto' : 'smooth' });
    }

    vorige.forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.getAttribute('aria-disabled') === 'true') return;
        gaNaar(huidigeIndex() - 1);
      });
    });
    volgende.forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.getAttribute('aria-disabled') === 'true') return;
        gaNaar(huidigeIndex() + 1);
      });
    });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { gaNaar(i); }); });
    if (opts.toetsen) {
      rail.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); gaNaar(huidigeIndex() + 1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); gaNaar(huidigeIndex() - 1); }
      });
    }
    var timer = null;
    rail.addEventListener('scroll', function () { clearTimeout(timer); timer = setTimeout(bijwerken, 80); });
    window.addEventListener('resize', bijwerken);
    if ('ResizeObserver' in window) { new ResizeObserver(function () { bijwerken(); }).observe(rail); }
    bijwerken();
  }

  var lijst = function (wortel, sel) { return [].slice.call(wortel.querySelectorAll(sel)); };

  /* koopblok: addons + bundels (Task 3, fase 2 — ontbraken volledig in fase 1;
   * fase 4 T8: de ene samen-kopen-rail werd één rail per addon-paneel) */
  var wortel = document.querySelector('[data-bv2-product]');
  if (wortel) {
    [].slice.call(wortel.querySelectorAll('[data-bv2-addon-paneel]')).forEach(function (paneel) {
      initRail(paneel.querySelector('[data-bv2-addons-rail]'), {
        vorige: lijst(paneel, '[data-bv2-addons-vorige]'),
        volgende: lijst(paneel, '[data-bv2-addons-volgende]'),
        pijlenBox: paneel.querySelector('[data-bv2-addons-pijlen]')
      });
    });
    /* fase 4 T9: de bundels zijn geen rail meer maar een 2×2-grid — geen pijlen, geen
       scroll-state, dus ook geen initRail (die zou alleen observers op een niet-scrollende
       container achterlaten). */
  }

  /* dichtbij — videofeedback 30-09 V16 (B10, AFWIJKINGEN #221): < 990 is de band weer een veegbare carrousel volgens
   * figma/dichtbij-m.png (één grote kaart + peek, stippen links, pijlen rechts eronder; Task 9/J73 had er een 2×2-raster van
   * gemaakt). ≥ 990 blijft de stille rij van vier (J50): daar geen rail-bediening, geen tabstop, geen "pijltjestoetsen"-label.
   * Nooit automatische beweging: alleen vegen, pijlen, stippen en pijltjestoetsen (de rail zelf) bewegen de rail; `gaNaar`
   * scrolt zacht behalve bij "minder beweging" (rustig()). Reactief op de 990-grens (matchMedia), zodat een draaiend toestel of
   * een smaller venster de juiste stand krijgt: initRail één keer (zodra < 990 voor het eerst geldt), tabindex/label per stand. */
  [].slice.call(document.querySelectorAll('[data-band="dichtbij"]')).forEach(function (sectie) {
    var rail = sectie.querySelector('[data-bv2-dichtbij-rail]');
    if (!rail || !window.matchMedia) return;
    var mq = window.matchMedia('(max-width: 989px)'), klaar = false;
    var titelEl = sectie.querySelector('.bv2-dichtbij__titel');
    var titel = titelEl ? titelEl.textContent.replace(/\s+/g, ' ').trim() : '';
    function stand() {
      if (mq.matches) {
        rail.setAttribute('tabindex', '0');
        rail.setAttribute('aria-label', titel + ', kaarten, met pijltjestoetsen te bedienen');
        if (!klaar) {
          klaar = true;
          initRail(rail, {
            vorige: lijst(sectie, '[data-bv2-dichtbij-prev]'),
            volgende: lijst(sectie, '[data-bv2-dichtbij-next]'),
            dots: lijst(sectie, '[data-bv2-dichtbij-dot]'),
            kaarten: '[data-bv2-dichtbij-kaart]',
            toetsen: true
          });
        }
      } else {
        rail.removeAttribute('tabindex');
        rail.removeAttribute('aria-label');
      }
    }
    if (mq.addEventListener) mq.addEventListener('change', stand); else if (mq.addListener) mq.addListener(stand);
    stand();
  });
})();

/* ---------- fase 4 J35: addon-tabs + variantchips ----------
 * Tabs volgens het WAI-ARIA tabs-patroon (pijltjestoetsen, Home/End, één tabbable tab). Chips zetten
 * prijs, compare, beeld en de data-bv2-add-variant van de kaart (fase 5: via bv2KiesAddonKeuze).
 * Eindreview: hier stond een `window.dispatchEvent(new Event('resize'))` na elke tabwissel, omdat een
 * verborgen paneel geen gemeten railbreedte heeft. Dat is niet nodig én te grof (élke rail, élke
 * resize-luisteraar op de pagina rekent mee): `initRail` zet zelf een ResizeObserver op zijn rail, en
 * die vuurt precies wanneer het paneel van `display: none` naar zichtbaar gaat. Getoetst in
 * `TOETSEN.addons` (pijltjes-stand ná de tabwissel tegen de live gemeten scrollruimte). */
(function () {
  'use strict';
  [].slice.call(document.querySelectorAll('[data-bv2-addons]')).forEach(function (box) {
    var tabs = [].slice.call(box.querySelectorAll('[data-bv2-addon-tab]'));
    function toon(tab) {
      tabs.forEach(function (t) {
        var aan = t === tab;
        t.setAttribute('aria-selected', String(aan)); t.tabIndex = aan ? 0 : -1;
        var paneel = box.querySelector('[data-bv2-addon-paneel="' + t.dataset.bv2AddonTab + '"]');
        if (paneel) paneel.hidden = !aan;
      });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { toon(t); });
      t.addEventListener('keydown', function (e) {
        var j = i;
        if (e.key === 'ArrowRight') j = (i + 1) % tabs.length; else if (e.key === 'ArrowLeft') j = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') j = 0; else if (e.key === 'End') j = tabs.length - 1; else return;
        e.preventDefault(); toon(tabs[j]); tabs[j].focus();
      });
    });
    /* fase 5 J41/J42: chips zijn variant- óf productkeuzes (data-bv2-addon-keuze); de server-img krijgt
       data-src = de gedrukte keuze, zodat een klik op de al gekozen keuze geen beeldwissel start. */
    [].forEach.call(box.querySelectorAll('[data-bv2-addon]'), function (k) {
      var chip = k.querySelector('[data-bv2-addon-keuze][aria-pressed="true"]'), img = k.querySelector('.bv2-addon__beeld img');
      if (chip && img) img.setAttribute('data-src', chip.getAttribute('data-beeld'));
    });
    box.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-bv2-addon-keuze]'); if (!chip) return;
      window.bv2KiesAddonKeuze(chip.closest('[data-bv2-addon]'), chip);
    });
    /* fix-ronde 1 (4): beelden van de keuzes voorverwarmen zodra de bezoeker naar de chips gaat
       (pointer of toetsenbord), één keer per kaart; dan loopt de beeldwissel niet achter op de prijs.
       De wissel zelf blijft pas ná decode() zichtbaar. */
    var hoge = (window.devicePixelRatio || 1) > 1;
    [].forEach.call(box.querySelectorAll('.bv2-addon__chips'), function (groep) {
      var gedaan = false;
      var warm = function () {
        if (gedaan) return; gedaan = true;
        [].forEach.call(groep.querySelectorAll('[data-bv2-addon-keuze]'), function (c) {
          var b1 = c.getAttribute('data-beeld'), b2 = c.getAttribute('data-beeld-2x');
          if (b1) new Image().src = b1;
          if (hoge && b2) new Image().src = b2;
        });
        groep.removeEventListener('pointerenter', warm); groep.removeEventListener('focusin', warm);
      };
      groep.addEventListener('pointerenter', warm); groep.addEventListener('focusin', warm);
    });
  });
})();

/* ---------- fase 5 J43: "Meer info"-popup per addon (spec §3.3) ----------
 * Eén gedeelde <dialog> voor alle kaarten; de inhoud komt uit de JSON van de kaart
 * ([data-bv2-addon-info-data], Liquid = één bron voor prijs en id). Keuze-index n in de popup =
 * data-keuze n op de kaartchip, dus een keuze in de popup loopt via bv2KiesAddonKeuze ook door op de
 * kaart (beeld, prijs, plusknop). Na het herbouwen van de keuzeknoppen gaat de focus terug op de
 * gekozen knop (h183). Toevoegen sluit de popup alleen als voegToe { ok: true } teruggeeft; bij een
 * mislukking toont de live region de reden uit dezelfde resolve-waarde (winkelreden, anders de eigen
 * setting addon_info_fout; fase 5 T5 — daarvoor werd hij uit de toast gelezen). */
(function () {
  'use strict';
  var B = window.BureauV2, V = window.BureauV2Varianten;
  var dlg = document.querySelector('dialog[data-bv2-addon-info]');
  if (!B || !V || !dlg || typeof dlg.showModal !== 'function') return;
  var el = function (s) { return dlg.querySelector(s); };
  var kaart = null, info = null, idx = 0, opener = null;
  var fotoLabel = dlg.getAttribute('data-foto-label') || 'Foto';
  var ontleder = typeof DOMParser === 'function' ? new DOMParser() : null;
  /* entiteiten uit de gestripte productomschrijving (&amp;, &nbsp;) als tekst */
  function tekst(t) { if (!t || !ontleder || t.indexOf('&') === -1) return t || ''; return ontleder.parseFromString('<p>' + t.replace(/</g, '&lt;') + '</p>', 'text/html').body.textContent; }
  /* eerste max tekens, afgekapt op een zinsgrens (anders op een woordgrens + …) */
  function zinnen(t, max) {
    t = String(t || '').replace(/\s+/g, ' ').trim(); if (t.length <= max) return t;
    var knip = t.slice(0, max), p = Math.max(knip.lastIndexOf('. '), knip.lastIndexOf('! '), knip.lastIndexOf('? '));
    return p > 80 ? knip.slice(0, p + 1) : knip.replace(/\s+\S*$/, '') + '…';
  }
  function toonGroot(u) { var g = el('[data-bv2-ai-beeld]'); if (u) g.src = u; else g.removeAttribute('src'); g.hidden = !u; }
  function render() {
    var k = info.keuzes[idx];
    el('[data-bv2-ai-titel]').textContent = info.titel;
    el('[data-bv2-ai-prijs]').textContent = V.formatEuro(k.prijs);
    var beelden = (k.beelden || []).filter(function (u, i, a) { return u && a.indexOf(u) === i; }).slice(0, 8);
    toonGroot(beelden[0] || '');
    var duimen = el('[data-bv2-ai-duimen]'); duimen.innerHTML = ''; duimen.hidden = beelden.length < 2;
    if (beelden.length > 1) beelden.forEach(function (u, i) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'bv2-ai__duim';
      b.setAttribute('data-bv2-ai-duim', ''); b.setAttribute('aria-label', fotoLabel + ' ' + (i + 1));
      b.setAttribute('aria-current', String(i === 0));
      var im = document.createElement('img'); im.src = u.replace(/width=\d+/, 'width=112'); im.alt = ''; im.width = 56; im.height = 56; im.draggable = false; b.appendChild(im);
      b.addEventListener('click', function () { toonGroot(u); [].forEach.call(duimen.children, function (c) { c.setAttribute('aria-current', String(c === b)); }); });
      duimen.appendChild(b);
    });
    var box = el('[data-bv2-ai-keuzes]'); box.innerHTML = ''; box.hidden = info.keuzes.length < 2; box.setAttribute('aria-label', info.titel);
    info.keuzes.forEach(function (x, i) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'bv2-bd__knop'; b.setAttribute('data-bv2-ai-keuze', String(i));
      b.textContent = x.label; b.setAttribute('aria-pressed', String(i === idx)); if (!x.beschikbaar) b.setAttribute('aria-disabled', 'true');
      b.addEventListener('click', function () {
        if (!x.beschikbaar || i === idx) return;
        idx = i; render();
        var chip = kaart.querySelector('[data-bv2-addon-keuze][data-keuze="' + i + '"]'); if (chip) window.bv2KiesAddonKeuze(kaart, chip);
        var nu = box.querySelector('[data-bv2-ai-keuze="' + i + '"]'); if (nu) nu.focus();
      });
      box.appendChild(b);
    });
    var bullets = (k.bullets || []).map(function (s) { return String(s).trim(); }).filter(Boolean).slice(0, 3);
    var intro = String(k.intro || '').trim() || (bullets.length ? '' : zinnen(tekst(k.omschrijving || info.omschrijving), 400)); /* S4: bij één product staat hij één keer op info */
    var ie = el('[data-bv2-ai-intro]'); ie.textContent = intro; ie.hidden = !intro;
    var ul = el('[data-bv2-ai-bullets]'); ul.innerHTML = ''; ul.hidden = !bullets.length;
    bullets.forEach(function (s) { var li = document.createElement('li'); li.textContent = s; ul.appendChild(li); });
    var atc = el('[data-bv2-ai-atc]'), kies = el('[data-bv2-ai-kies]');
    atc.hidden = !!info.kies; kies.hidden = !info.kies;
    if (info.kies) { kies.textContent = info.kies.label; kies.href = info.kies.url; }
    atc.setAttribute('data-id', String(k.id));
    if (k.beschikbaar) atc.removeAttribute('aria-disabled'); else atc.setAttribute('aria-disabled', 'true');
    el('[data-bv2-ai-fout]').hidden = true;
  }
  document.addEventListener('click', function (e) {
    var l = e.target.closest('[data-bv2-addon-info-open]'); if (!l) return;
    var k = l.closest('[data-bv2-addon]'), bron = k && k.querySelector('[data-bv2-addon-info-data]'); if (!bron) return;
    try { info = JSON.parse(bron.textContent); } catch (x) { return; }
    if (!info || !info.keuzes || !info.keuzes.length) return;
    kaart = k; opener = l;
    idx = Number(kaart.getAttribute('data-keuze') || 0); if (!info.keuzes[idx]) idx = 0;
    render();
    if (window.bv2IsMobiel && window.bv2IsMobiel() && window.bv2Paneel) { dlg.classList.add('bv2-paneel'); window.bv2Paneel(dlg, l); }
    else { dlg.classList.remove('bv2-paneel'); dlg.showModal(); }
    var eerste = el('[data-bv2-ai-keuze][aria-pressed="true"]'); if (eerste && !el('[data-bv2-ai-keuzes]').hidden) eerste.focus();
  });
  el('[data-bv2-ai-sluit]').addEventListener('click', function () { dlg.close(); });
  dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); }); /* klik op de backdrop */
  /* eindfix 1 (spec §3.0): als paneel (< 990) zet de helper de focus terug mét preventScroll; deze listener draait
     vóór die van de helper en zou zonder vlag de pagina naar de opener laten springen. Desktop-popup ongewijzigd. */
  dlg.addEventListener('close', function () { if (dlg.classList.contains('bv2-paneel')) return; if (opener && document.contains(opener)) opener.focus(); });
  el('[data-bv2-ai-atc]').addEventListener('click', function () {
    var knop = this, id = knop.getAttribute('data-id'), foutEl = el('[data-bv2-ai-fout]');
    if (!id || knop.getAttribute('aria-busy') === 'true' || knop.getAttribute('aria-disabled') === 'true') return;
    foutEl.hidden = true;
    /* fase 5 T5: eigen terugvaltekst (addon_info_fout) en "Meer info" als opener van de cart-drawer —
       de knop zelf zit in een dialoog die bij succes sluit, dus de focus zou anders naar body vallen. */
    B.voegToe(id, knop, 1, { fout: dlg.getAttribute('data-fout-tekst'), opener: opener, stil: true }).then(function (r) {
      if (r && r.ok) { dlg.close(); return; }
      foutEl.textContent = (r && r.reden) || dlg.getAttribute('data-fout-tekst');
      foutEl.hidden = false;
    });
  });
})();

/* ---------- reviews: "Lees meer"-disclosure (Task 10, Critical C1 / ruling F1) ----------
 * De reviewtekst staat ALTIJD volledig in de DOM (het `truncate: 220`-filter is weg). Deze
 * IIFE meet per kaart of die tekst binnen de ontworpen 6 regels past; alleen als hij dat niet
 * doet, wordt de kaart inklapbaar gemaakt (data-inklapbaar -> clamp + fade in de CSS) en
 * verschijnt de knop. Zonder JS staat er dus gewoon een volledige, niet-afgekapte review.
 * Hermeten bij resize en zodra de webfonts geladen zijn (regelhoogtes verschuiven daardoor);
 * een al uitgeklapte kaart wordt nooit teruggeklapt. */
(function () {
  'use strict';
  var kaarten = [].slice.call(document.querySelectorAll('[data-bv2-reviews-kaart]'));
  if (!kaarten.length) return;
  var paren = [];
  kaarten.forEach(function (kaart) {
    var wrap = kaart.querySelector('[data-bv2-review-tekst]');
    var knop = kaart.querySelector('[data-bv2-review-meer]');
    if (!wrap || !knop) return;
    var tekst = wrap.querySelector('.bv2-reviews__tekst');
    if (!tekst) return;
    paren.push({ wrap: wrap, knop: knop, tekst: tekst });
    knop.addEventListener('click', function () {
      var open = wrap.getAttribute('data-open') === 'true';
      wrap.setAttribute('data-open', String(!open));
      knop.setAttribute('aria-expanded', String(!open));
      knop.textContent = !open
        ? (knop.getAttribute('data-minder') || 'Minder')
        : (knop.getAttribute('data-meer') || 'Lees meer');
    });
  });
  if (!paren.length) return;

  function meten() {
    paren.forEach(function (p) {
      if (p.wrap.getAttribute('data-open') === 'true') return; // uitgeklapt blijft uitgeklapt
      p.wrap.setAttribute('data-inklapbaar', 'true');
      var past = p.tekst.scrollHeight <= p.tekst.clientHeight + 1;
      if (past) { p.wrap.removeAttribute('data-inklapbaar'); p.knop.hidden = true; }
      else { p.knop.hidden = false; }
    });
  }
  meten();
  if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
    document.fonts.ready.then(meten).catch(function () {});
  }
  var t = null;
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(meten, 150); });
})();

/* ---------- fase 3 J16: reviews-marquee — continu glijden op de compositor ----------
 * Zelfde mechaniek als initUgcCarrousel in custom-stoel-v2.js: per stap de laatste kaart
 * vooraan zetten en de track van -stap naar 0 animeren (netto nul, dus geen sprong). Geen
 * klonen: een schermlezer krijgt elke review precies één keer.
 * Stopt bij: buiten beeld (IntersectionObserver) en — sinds fase 5 J49 via `bv2Beweging` — hover
 * (echt pointer-delta), toetsenbordfocus in de rail, klik op de rail, de verborgen stopknop en
 * "minder beweging" (ook als die tijdens het bezoek aangaat). Geen zichtbare pauzeknop meer.
 * Grens (AFWIJKINGEN #140): staat "minder beweging" bij laden aan, dan start de marquee nooit; zet
 * de bezoeker hem tijdens het bezoek uit, dan glijdt hij pas na herladen.
 * Terugval zonder JS / zonder Element.animate / bij reduced motion: de bestaande statische
 * scroll-snap-rail — niets gaat verloren.
 * Alleen desktop: de layout (rand tot rand, fade) staat in de 990-laag en de mobiele ronde
 * beslist nog over bewegend beeld op klein scherm, dus de marquee start pas vanaf 990 px. */
(function () {
  'use strict';
  var sec = document.querySelector('[data-band="reviews"]');
  var rail = sec && sec.querySelector('[data-bv2-reviews-rail]');
  var track = rail && rail.querySelector('[data-bv2-reviews-track]');
  var groep = track && track.querySelector('[data-bv2-reviews-groep]');
  if (!groep || groep.children.length < 2) return;
  if (!window.matchMedia('(min-width: 990px)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (typeof track.animate !== 'function') return;
  /* Past alles al in de rij, dan is ronddraaien beweging zonder informatie. */
  if (groep.scrollWidth <= rail.clientWidth + 1) return;

  sec.classList.add('bv2-reviews--auto');
  /* In de marquee-stand doen pijltjestoetsen niets (de rail is `overflow: hidden`), dus het
     label mag die belofte niet meer doen. Rol blijft group + roledescription carrousel. */
  rail.setAttribute('aria-label', 'Klantreviews');

  var SNELHEID = 30; /* px/s (spec §3.6) */
  var gap = parseFloat(getComputedStyle(groep).columnGap) || 14;
  var anim = null, zichtbaar = false;
  /* fase 5 J49: hover, focus, klik, stopknop en reduced motion zitten in de gedeelde helper. */
  var beweging = window.bv2Beweging(sec, { rail: rail, opWissel: function () { bijwerken(); } });

  function magLopen() { return zichtbaar && !beweging.stil(); }
  /* Eén segment = één kaartstap. Rotatie en animatiestart-op(-stap) zitten in dezelfde taak,
     dus de compensatie is atomair: de DOM schuift +stap, de transform start op -stap. De
     eindkeyframe is 0px en de animatie vult niet (fill none), dus ná finish staat de track op
     zijn basistransform — ook daar geen sprong. De breedte komt per stap van de laatste kaart,
     dus een viewportwissel of een uitgeklapte review wordt vanzelf meegenomen. */
  function segment() {
    var laatste = groep.lastElementChild;
    var stap = laatste.getBoundingClientRect().width + gap;
    groep.insertBefore(laatste, groep.firstElementChild);
    anim = track.animate(
      [{ transform: 'translateX(' + -stap + 'px)' }, { transform: 'translateX(0px)' }],
      { duration: (stap / SNELHEID) * 1000, easing: 'linear' }
    );
    anim.onfinish = function () { anim = null; bijwerken(); };
  }
  /* Idempotente toestandsfunctie: élke trigger komt hierlangs, geen per-frame werk. */
  function bijwerken() {
    if (magLopen()) {
      if (anim === null) segment();
      else if (anim.playState === 'paused') anim.play();
    } else if (anim !== null && anim.playState === 'running') {
      anim.pause();
    }
  }

  new IntersectionObserver(function (e) {
    /* Nazorg eindreview: de laatste entry is de meest recente waarneming. Eén callback kan
       meerdere entries voor hetzelfde doel dragen (de browser batcht); `e[0]` is dan de
       óudste en kan de toestand terugzetten naar wat hij net niet meer is. */
    zichtbaar = e[e.length - 1].isIntersecting;
    bijwerken();
  }, { threshold: 0.05 }).observe(rail);

  /* Focus pauzeren doet `bv2Beweging`. Bij TOETSENBORDfocus (:focus-visible) laten we de browser zijn
     eigen, minimale scroll doen: de rail is `overflow: hidden` en dus programmatisch
     scrollbaar, zodat de kaart mét focus vanzelf helemaal in beeld komt — zonder de DOM te
     herschikken (dat maakte Tab een eindeloze rondgang, gemeten in T7).
     Bij POINTERfocus (muisklik op "Lees meer") zetten we die scroll terug: de lezer klikte op
     wat hij zag, dan hoort er niets te verschuiven. Hover pauzeert daar al. */
  rail.addEventListener('focusin', function (e) {
    var toets = false;
    try { toets = e.target.matches(':focus-visible'); } catch (x) {}
    if (!toets) {
      var was = rail.scrollLeft;
      setTimeout(function () { rail.scrollLeft = was; }, 0);
    }
    bijwerken();
  });
  /* Focus weg uit de rail: de scrollpositie terug naar 0 (de marquee rekent vanaf daar; met een
     blijvende scroll zou er aan de rechterkant een gat kunnen vallen) en weer laten lopen. */
  rail.addEventListener('focusout', function () {
    setTimeout(function () {
      if (!rail.contains(document.activeElement)) rail.scrollLeft = 0;
      bijwerken();
    }, 0);
  });

  bijwerken();
})();

/* ---------- fase 4 J25 + fase 5 J47: UGC-band — autoplay in beeld + marquee ----------
 * Fase 5 J47 (spec §3.6): direct en zonder schok.
 * - Vooruit laden: zodra de BAND binnen één schermhoogte komt (`rootMargin: 100% 0px`) — maar nooit
 *   vóór het load-event + een idle-moment (eindfix 1: hoog venster, LCP eerst) — gaan alle
 *   posters op `eager` + `decode()` (kaart krijgt `is-klaar`) en ontstaan alle <video>'s in één keer
 *   (preload none). Een wachtrij zet ze daarna ÉÉN VOOR ÉÉN, in kaartvolgorde, op hun eigen preload:
 *   `auto` voor de eerste 6 (wat bij aankomst in beeld valt), de rest `metadata`; de volgende pas als
 *   de vorige helemaal binnen is / zijn metadata heeft (of bij een fout, of na 4 s). Gemeten (metingen/…/fase5/ugc-diagnose.md):
 *   video's die tegelijk laden houden elk een demuxer-thread vast die op netwerkdata wacht; op Fast 4G
 *   stonden daardoor alle rasterthreads stil en wachtte de main thread 1,1-2 s op de commit. Een
 *   kaart speelt pas als zijn video aan de beurt was (anders zou play() hem alsnog parallel laden).
 * - Afspelen: kaart ≥ 50 % in beeld → play(), anders pause() (`kaartIO`, maakt zelf niets meer aan).
 *   De video ligt met opacity 0 óver de poster en faded in 200 ms in op `playing` (`is-speelt`, CSS);
 *   de poster blijft eronder staan, dus een haperende video geeft geen flits en geen layoutwissel.
 * - Marquee: start pas bij de eerste `playing` in de band of 1 s nadat de band in beeld kwam (wat
 *   eerst komt). Geen DOM-rotatie meer (die gaf bij elke stap een layout-shift van 5 kaarten,
 *   CLS 0,067): elke kaart-wrap krijgt een eigen, oneindige compositor-animatie over één volle cyclus
 *   (breedte = som van alle kaarten + gaps, 30 px/s) met een fase-offset, zodat elke kaart eens per
 *   cyclus buiten beeld van rechts naar links terugspringt — alleen `transform`, de layout en de
 *   DOM-volgorde (dus ook de Tab-volgorde) blijven ongemoeid.
 * - Fase 5 J49: `bv2Beweging` (hover/toetsenbordfocus, klik op de rail, verborgen stopknop, live
 *   "minder beweging") stopt marquee én video's. `magLopen()` is de enige poort voor de marquee.
 * Terugval (reduced motion, geen Element.animate, geen IntersectionObserver; verbeter 29-09: < 990 alleen nog bij
 * databesparing): statische snap-rail; de kaart zelf is de knop (`bv2SpeelBijKlik`, geen icoon-overlay) → klik,
 * Enter of spatie geeft een <video controls muted> (preload none tot de klik). Zonder JS: posters.
 * Verbeter 29-09 fixronde 1: < 990 zijn de kaarten ook in de marquee knoppen (J72); de tik speelt daar met geluid. */
(function () {
  'use strict';
  var sec = document.querySelector('[data-band="ugc"]');
  var rail = sec && sec.querySelector('[data-bv2-ugc-rail]');
  var track = rail && rail.querySelector('[data-bv2-ugc-track]');
  var groep = track && track.querySelector('[data-bv2-ugc-groep]');
  if (!groep) return;
  var kaarten = [].slice.call(groep.querySelectorAll('[data-bv2-ugc-video]'));
  var rustig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var desktop = window.matchMedia('(min-width: 990px)').matches;
  /* verbeter 29-09 A7: de marquee loopt ook < 990 (Jory: "rustig automatisch van rechts naar links"). Welke video speelt blijft per
     breedte verschillen: ≥ 990 de wachtrij + ≥ 50 %-regel (fase 5), < 990 alleen de meest zichtbare kaart (J72, data).
     Databesparing blijft mobiel de terugval (J72, spec §3.6: "geen databesparing"); desktop negeerde saveData al. */
  var saveData = navigator.connection && navigator.connection.saveData;
  var kanAuto = !rustig && (desktop || !saveData) && typeof track.animate === 'function' && 'IntersectionObserver' in window && groep.children.length >= 2;
  var mqGroot = window.matchMedia('(min-width: 990px)');

  /* De video komt NA de poster in de kaart: beide positioned, z-index auto, dus boomvolgorde = de
     video tekent erboven (opacity 0 tot `playing`, zie .bv2-ugc__kaart > video in de CSS). */
  function maakVideo(kaart, metControls) {
    var url = kaart.getAttribute('data-video-url'); if (!url) return null;
    var v = document.createElement('video');
    v.className = 'bv2-video__media';
    v.preload = 'none'; v.muted = true; v.playsInline = true; v.loop = !metControls; v.controls = !!metControls;
    v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); if (!metControls) v.setAttribute('loop', '');
    v.setAttribute('aria-label', kaart.getAttribute('data-video-label') || 'Klantvideo');
    /* Geen `poster`-attribuut (fase 5 J47): de <img> blijft onder de video staan, een tweede kopie van
       hetzelfde beeld in de video kost alleen een extra download + decode. */
    v.src = url;
    v.addEventListener('playing', function () { kaart.classList.add('is-speelt'); });
    kaart.appendChild(v);
    return v;
  }

  /* Terugval: de kaart zelf is de knop, klik → video mét controls (zelfde ervaring als fase 2/3,
     zonder icoon-overlay, J49). Alleen kaarten mét video-URL. */
  if (!kanAuto) {
    var handmatig = false, winnaar = null, ratio = [], bandZicht = false;
    kaarten.forEach(function (kaart) {
      if (!kaart.getAttribute('data-video-url')) return;
      /* mobiel J72: een tik vervangt een eventuele auto-video door een verse, niet-lussende video mét
         controls (de auto-video mag niet hergebruikt worden — anders blijft hij lussen, zie brief).
         Deze listener wordt vóór `bv2SpeelBijKlik` zijn eigen click/keydown-listener geregistreerd, dus
         hij loopt eerst: de auto-video is al weg als `bv2SpeelBijKlik` zijn `vak.querySelector('video')`
         doet, en maakt dus altijd een verse. */
      function vervangAuto(e) {
        if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
        handmatig = true; stopAuto();
        var oud = kaart.querySelector('video.bv2-ugc__auto');
        if (oud && oud.parentNode) oud.parentNode.removeChild(oud);
      }
      kaart.addEventListener('click', vervangAuto);
      kaart.addEventListener('keydown', vervangAuto);
      window.bv2SpeelBijKlik(kaart, function () { return maakVideo(kaart, true); });
    });
    /* mobiel J72 (spec §3.6): < 990, geen reduced motion, geen databesparing: alleen de kaart die het
       meest in beeld is (≥ 60 %) speelt stil, wisselt bij scrollen, pauzeert buiten beeld. Deelt de
       bestaande J49-stiltoestand (`bv2Beweging`: hover, toetsenbordfocus, tik op de rail, de verborgen
       stopknop) — elk van de vier stopt ook deze autoplay, net als op desktop. Twee matchMedia-poorten
       reageren live (spec §2 regel 10): reduced-motion en de 990px-grens (oversteken naar desktop stopt
       de autoplay meteen, ook zonder herlaad). Verbeter 29-09 A7: `saveData` staat nu boven `kanAuto`; zonder
       reduced motion en databesparing neemt < 990 de marquee-tak deze rol over (zelfde één-kaart-regel, `kiesMob`). */
    if (desktop || rustig || saveData || !('IntersectionObserver' in window)) return;
    function stopAuto() { kaarten.forEach(function (k) { var v = k.querySelector('video.bv2-ugc__auto'); if (v && !v.paused) v.pause(); }); }
    function autoVideo(k) {
      var v = k.querySelector('video.bv2-ugc__auto'); if (v) return v;
      v = maakVideo(k, false); if (!v) return null; v.classList.add('bv2-ugc__auto'); v.preload = 'auto'; return v;
    }
    var mqRustig = window.matchMedia('(prefers-reduced-motion: reduce)');
    var mq990 = window.matchMedia('(min-width: 990px)');
    var beweging = window.bv2Beweging(sec, { rail: rail, opWissel: function () { kies(); } });
    /* BUG 30-09: autoplay geblokkeerd → niets meer vanzelf; de kaarten zijn hier al afspeelknoppen (bv2SpeelBijKlik) */
    window.bv2Autoplay.opGeblokkeerd(function () { handmatig = true; stopAuto(); winnaar = null; });
    function kies() {
      if (handmatig || !bandZicht || mqRustig.matches || mq990.matches || beweging.stil()) { stopAuto(); return; }
      var best = null, bestR = 0.6;
      kaarten.forEach(function (k, i) { var r = ratio[i] || 0; if (r >= bestR && k.getAttribute('data-video-url')) { best = k; bestR = r; } });
      if (best === winnaar) return;
      stopAuto(); winnaar = best;
      if (best) { var v = autoVideo(best); if (v) window.bv2Autoplay.speel(v); }
    }
    var kIO = new IntersectionObserver(function (es) {
      es.forEach(function (e) { var i = kaarten.indexOf(e.target); if (i > -1) ratio[i] = e.isIntersecting ? e.intersectionRatio : 0; });
      kies();
    }, { threshold: [0, 0.25, 0.5, 0.6, 0.75, 1] });
    kaarten.forEach(function (k) { kIO.observe(k); });
    new IntersectionObserver(function (es) { bandZicht = es[es.length - 1].isIntersecting; if (!bandZicht) { stopAuto(); winnaar = null; } else kies(); }, { threshold: 0.3 }).observe(rail);
    var mqRustigWissel = function () { if (mqRustig.matches) { stopAuto(); winnaar = null; } else kies(); };
    if (mqRustig.addEventListener) mqRustig.addEventListener('change', mqRustigWissel); else if (mqRustig.addListener) mqRustig.addListener(mqRustigWissel);
    var mq990Wissel = function () { if (mq990.matches) { stopAuto(); winnaar = null; } else kies(); };
    if (mq990.addEventListener) mq990.addEventListener('change', mq990Wissel); else if (mq990.addListener) mq990.addListener(mq990Wissel);
    return;
  }

  sec.classList.add('bv2-ugc--auto');
  /* Geen aria-label-overschrijving hier: het label in de Liquid is merchant-copy (de bandtitel +
     ", klantvideo's") en dat blijft staan. De reviews-marquee overschrijft het wél, maar daar
     beloofde het label pijltjestoetsbediening die in de marquee-stand verdwijnt; dit label doet
     geen bedieningsbelofte, dus er is niets recht te zetten. */
  /* verbeter 29-09 A7: snelheid per breedte (≥ 990 30 px/s, < 990 de sectie-setting, default 20). De gap wordt bij elke
     opbouw opnieuw gelezen: hij verschilt per breedte (11 < 990, 24 ≥ 990), dus een eenmalig gelezen gap klopt na een
     resize over 990 niet meer met de layout (de cyclus zou dan scheve tussenruimtes krijgen). ≥ 990 blijft het 24. */
  function gapNu() { return parseFloat(getComputedStyle(groep).columnGap) || 24; }
  function snelheid() { return mqGroot.matches ? 30 : (Number(sec.getAttribute('data-snelheid-mobiel')) || 20); }
  var anims = null, stapNu = 0, zichtbaar = false, magStarten = false, startklok = null;
  /* fase 5 J49: één toestand voor marquee én video's. `opWissel` volgt élke wissel (hover, focus,
     klik, stopknop, "minder beweging"); `magLopen()` is de enige poort voor de marquee.
     verbeter 29-09 D6 (fixronde 1): < 990 pauzeert een VEEG tijdelijk (`tijdelijk`, op het moment zelf gelezen, dus ook na
     draaien); ≥ 990 ongewijzigd (klik = blijvend). Hervatten (alleen na een eigen keuze: stopknop of tik op de rail) maakt
     van een kaart met een zelf gestarte video weer een gewone kaart (`handTerug`), zodat er nooit twee video's spelen. */
  var beweging = window.bv2Beweging(sec, { rail: rail, hover: false /* iteratie 30-09 (F5): Jory — niet stoppen bij hover */, tijdelijk: function () { return mqGroot.matches ? 0 : 4000; }, opWissel: function (stil) {
    /* iteratie 30-09 (D5-notitie): een tijdelijke veeg-stilstand laat de video's doorspelen (alleen de marquee wacht); een blijvende
       stop pauzeert ze. `handTerug` alleen bij een echte hervatting na een eigen stop (niet na afloop van een veeg). */
    if (beweging.stilVoorVideo()) allesPauzeren(); else if (!stil) { handTerug(); zichtbareHervatten(); } else zichtbareHervatten();
    bijwerken();
  } });

  /* verbeter 29-09 fixronde 1 (I2/I3, controllerbesluit; J72 spec §3.6): < 990 is elke kaart weer een knop "[label] afspelen"
     (`bv2SpeelBijKlik`). Tik, klik, Enter of spatie speelt DIE video met geluid en bediening en zet de band blijvend stil
     (`beweging.stop()`: dezelfde toestand als de stopknop, geen 4 s). Eén video tegelijk: de gestarte video wint, een eerder
     gestarte op een andere kaart wordt weer een gewone kaart, en automatisch speelt er niets zolang de band stil staat (de
     zelf gestarte video's, `data-bv2-hand`, laten allesPauzeren/kiesMob met rust). ≥ 990 zijn de kaarten gewone vlakken
     (fase 5: klik = stil/verder); de knoprol wisselt live mee over 990. */
  var knopLabels = [];
  function kaartKnop(k, i, aan) {
    if (aan) { k.setAttribute('role', 'button'); k.setAttribute('tabindex', '0'); if (knopLabels[i]) k.setAttribute('aria-label', knopLabels[i]); }
    else { k.removeAttribute('role'); k.removeAttribute('tabindex'); k.removeAttribute('aria-label'); }
  }
  function maakHand(k) {
    var v = maakVideo(k, true); if (!v) return null;
    v.setAttribute('data-bv2-hand', ''); v.muted = false; v.removeAttribute('muted'); /* met geluid: de tik is de gebruikersactie */
    v.loop = true; v.setAttribute('loop', ''); /* iteratie 30-09 (D5-notitie Jory: "op repeat"): ook de getikte video herhaalt; pauzeren kan met de bediening */
    return v;
  }
  /* Een kaart met een zelf gestarte video weer een gewone kaart maken: die video weg, een verse auto-video (metadata, aan de
     beurt) en < 990 weer de knoprol. */
  function terugNaarAuto(k, i) {
    var h = k.querySelector('video[data-bv2-hand]'); if (!h) return;
    h.pause(); h.parentNode.removeChild(h);
    k.classList.remove('is-speelt');
    var v = maakVideo(k, false);
    if (v) { v.preload = 'metadata'; v.setAttribute('data-bv2-aan-de-beurt', ''); v.load(); }
    kaartKnop(k, i, geenAuto || !mqGroot.matches);
  }
  function handTerug(behalve) { kaarten.forEach(function (k, i) { if (k !== behalve) terugNaarAuto(k, i); }); }
  kaarten.forEach(function (k, i) {
    if (!k.getAttribute('data-video-url')) return;
    /* vóór `bv2SpeelBijKlik` geregistreerd, dus deze loopt eerst (zelfde volgorde als J72 `vervangAuto`): de auto-video gaat
       weg, zodat `bv2SpeelBijKlik` een verse, niet-lussende video mét bediening maakt. */
    function vervangAuto(e) {
      if ((mqGroot.matches && !geenAuto) || k.getAttribute('role') !== 'button') return; /* BUG 30-09: zonder autoplay ook ≥ 990 */
      if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
      beweging.stop();
      handTerug(k);
      var oud = k.querySelector('video');
      if (oud && !oud.hasAttribute('data-bv2-hand')) oud.parentNode.removeChild(oud);
      k.classList.add('is-speelt'); /* video en bediening meteen zichtbaar, ook als het afspelen even op zich laat wachten */
    }
    k.addEventListener('click', vervangAuto);
    k.addEventListener('keydown', vervangAuto);
    window.bv2SpeelBijKlik(k, function () { return maakHand(k); });
    knopLabels[i] = k.getAttribute('aria-label');
    if (mqGroot.matches) kaartKnop(k, i, false);
  });
  /* BUG 30-09 (AFWIJKINGEN #206): blokkeert de browser autoplay, dan speelt er vanzelf niets meer en wordt elke kaart op ÉLKE breedte
     een afspeelknop, zoals mobiel (J72): klik of tik = die video met geluid en bediening, de band staat dan stil (beweging.stop()).
     Vóór deze fix was een UGC-video op desktop in die stand onbereikbaar (een klik zette alleen de band stil of verder). De marquee
     zelf (compositor-animatie) blijft lopen. */
  var geenAuto = false;
  window.bv2Autoplay.opGeblokkeerd(function () {
    geenAuto = true;
    allesPauzeren();
    kaarten.forEach(function (k, i) { if (k.getAttribute('data-video-url') && !k.querySelector('video[data-bv2-hand]')) kaartKnop(k, i, true); });
  });

  /* J47: alles klaarzetten zodra de band binnen één schermhoogte komt (één keer). */
  var voorbereid = false;
  function voorbereiden() {
    if (voorbereid) return; voorbereid = true;
    kaarten.forEach(function (k, i) {
      var img = k.querySelector('img');
      if (img) {
        img.loading = 'eager';
        if (img.decode) img.decode().then(function () { k.classList.add('is-klaar'); }, function () {});
        else k.classList.add('is-klaar');
      }
      var v = k.querySelector('video') || maakVideo(k, false);
      if (v && v.hasAttribute('data-bv2-hand')) return; /* fixronde 1: al zelf gestart (tik vóór het klaarzetten): niet herladen */
      /* verbeter 29-09 A7: < 990 speelt er maar één tegelijk, dus daar alleen metadata vooraf (data). */
      if (v) wachtrij.push({ v: v, k: k, preload: mqGroot.matches ? (i < 6 ? 'auto' : 'metadata') : 'metadata' });
    });
    volgende();
  }
  var wachtrij = [];
  function volgende() {
    var item = wachtrij.shift(); if (!item) return;
    if (!item.k.contains(item.v)) { volgende(); return; } /* fixronde 1: door een tik vervangen vóór hij aan de beurt was */
    var v = item.v, klaar = false, klok = null;
    function door() { if (klaar) return; klaar = true; clearTimeout(klok); volgende(); }
    /* auto: pas door als de clip HELEMAAL binnen is (buffered tot het eind); `canplaythrough` komt al
       na een paar honderd ms en liet dan nog 4-5 downloads overlappen (gemeten, ugc-diagnose.md). */
    function binnen() {
      try { var b = v.buffered; if (v.duration > 0 && b.length && b.end(b.length - 1) >= v.duration - 0.05) door(); } catch (x) {}
    }
    if (item.preload === 'auto') { v.addEventListener('progress', binnen); v.addEventListener('suspend', binnen); v.addEventListener('canplaythrough', binnen); }
    else v.addEventListener('loadedmetadata', door);
    v.addEventListener('error', door);
    klok = setTimeout(door, 4000);
    v.preload = geenAuto ? 'metadata' : item.preload; /* review golf 1 M-8: zonder autoplay geen 2,4 MB vooruit */
    v.setAttribute('data-bv2-aan-de-beurt', '');
    v.load();
    /* verbeter 29-09 A7: < 990 kiest `kiesMob` (anders speelt elke kaart ≥ 50 % mee: op 390 zijn dat er twee). */
    if (!mqGroot.matches) kiesMob();
    else if (!beweging.stilVoorVideo() && inBeeld(item.k)) speel(v);
  }
  function speel(v) { if (!geenAuto) window.bv2Autoplay.speel(v); } /* BUG 30-09: via de gedeelde autoplay-toestand */
  /* "In beeld" = de laatste waarneming van `kaartIO` (≥ 50 %, zelfde rootMargin) — één bron, zodat een
     video die later aan de beurt komt precies dezelfde regel volgt als een kaart die net binnenschuift. */
  function inBeeld(k) { return k.getAttribute('data-bv2-in-beeld') === 'true'; }
  /* Eindfix 1 (review fase 5): op een hoog venster (1920 × 1080, 1440p) valt de band al bij
     DOMContentLoaded binnen de 100%-marge; dan concurreerde de wachtrij van acht video's met de
     hero/LCP. Daarom opent de poort pas ná het load-event plus een idle-moment (requestIdleCallback,
     anders setTimeout). De band-nadering blijft de trigger; wat vóór de poort binnenkomt wacht erop. */
  var dichtbij = false, poortOpen = false;
  function probeer() { if (dichtbij && poortOpen) voorbereiden(); }
  function naLaden() {
    var open = function () { poortOpen = true; probeer(); };
    if (window.requestIdleCallback) window.requestIdleCallback(open, { timeout: 2000 }); else setTimeout(open, 200);
  }
  if (document.readyState === 'complete') naLaden(); else window.addEventListener('load', naLaden);
  /* BUG 30-09 (C, AFWIJKINGEN #206): window.load wacht op álle derde partijen (Klaviyo, GTM, …): op een traag netwerk gemeten 23,5 s,
     en de UGC-video's kwamen pas daarna, ook als de bezoeker al bij de band was. De eerste scroll, tik of toets sluit de LCP-meting
     af (LCP stopt bij de eerste interactie), dus dan mag de wachtrij meteen: de poort gaat óók open bij de eerste interactie. Let op
     (review golf 1 M-10): ook een scroll zonder bezoeker telt, bv. scrollherstel bij terug/herladen (gemeten 800 ms, LCP liep tot
     968 ms) of een ankersprong; dan opent de poort iets vroeger. Onschuldig: de bezoeker staat dan al midden op de pagina. Bij een
     verse load zonder interactie opent niets vóór window.load (gemeten: 0 mp4 in 9 s). */
  var INTERACTIE = ['scroll', 'wheel', 'pointerdown', 'keydown', 'touchstart'];
  function eersteInteractie() {
    INTERACTIE.forEach(function (t) { window.removeEventListener(t, eersteInteractie, true); });
    if (!poortOpen) { poortOpen = true; probeer(); }
  }
  INTERACTIE.forEach(function (t) { window.addEventListener(t, eersteInteractie, { capture: true, passive: true }); });
  new IntersectionObserver(function (e) { if (e[e.length - 1].isIntersecting) { dichtbij = true; probeer(); } }, { rootMargin: '100% 0px' }).observe(sec);

  /* verbeter 29-09 A7 (J72, D6): < 990 speelt alleen de kaart met de hoogste zichtbaarheid (≥ 0,6), mits zijn video aan de
     beurt was; de rest pauzeert. `ratioMob` houdt per kaart de laatste IO-waarneming bij. */
  var ratioMob = [];
  function kiesMob() {
    var best = null, bestR = 0.6;
    kaarten.forEach(function (k, i) { if ((ratioMob[i] || 0) >= bestR && k.querySelector('video[data-bv2-aan-de-beurt]')) { best = k; bestR = ratioMob[i]; } });
    kaarten.forEach(function (k) { var v = k.querySelector('video'); if (!v || v.hasAttribute('data-bv2-hand')) return; if (k === best && !beweging.stilVoorVideo()) speel(v); else if (!v.paused) v.pause(); });
  }
  /* per kaart: spelen alleen ≥ 50 % in beeld; maakt zelf geen video (dat doet `voorbereiden`) en
     speelt pas als de wachtrij de video aan de beurt liet komen. Verbeter 29-09: meer drempels, want een
     marquee schuift continu en < 990 moet de meest zichtbare kaart vaker opnieuw bepaald worden. De ratio
     wordt vóór de video-check bewaard: anders blijft hij 0 voor een kaart waarvan de video pas later ontstaat. */
  var kaartIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var zicht = e.isIntersecting && e.intersectionRatio >= 0.5;
      e.target.setAttribute('data-bv2-in-beeld', String(zicht));
      ratioMob[kaarten.indexOf(e.target)] = e.isIntersecting ? e.intersectionRatio : 0;
      var v = e.target.querySelector('video');
      if (!v || v.hasAttribute('data-bv2-hand')) return; /* fixronde 1: een zelf gestarte video bestuurt de bezoeker */
      if (!mqGroot.matches) return;
      if (zicht) {
        if (!beweging.stilVoorVideo() && v.hasAttribute('data-bv2-aan-de-beurt')) speel(v);
      } else if (!v.paused) { v.pause(); }
    });
    if (!mqGroot.matches) kiesMob();
  }, { threshold: [0, 0.25, 0.5, 0.6, 0.75, 1], rootMargin: '200px 0px' });
  kaarten.forEach(function (k) { kaartIO.observe(k); });

  /* Marquee-start: eerste `playing` in de band, of 1 s nadat de band in beeld kwam. */
  function magNuStarten() { if (magStarten) return; magStarten = true; bijwerken(); }
  sec.addEventListener('playing', magNuStarten, true);
  function magLopen() { return magStarten && zichtbaar && !beweging.stil(); }

  /* Eén cyclus = alle kaarten + gaps (W). Kaart i (layoutpositie L = i·stap) loopt van −stap tot
     W − stap (ten opzichte van de groepstart) en begint op zijn eigen plek: iterationStart
     (L + stap) / W geeft op t = 0 exact transform 0. Aan het eind van zijn cyclus staat hij rechts
     buiten beeld en springt hij (transform, geen layout) naar links, net buiten de fade — dezelfde
     plek waar de oude DOM-rotatie hem neerzette. Zelfde tijdlijn en starttijd voor allemaal, dus
     pauzeren/hervatten houdt de onderlinge afstand exact.
     Verbeter 29-09 A7: ≥ 990 schuift de band (gemeten) naar rechts; Jory wil mobiel "van rechts naar links". < 990 lopen
     dezelfde twee keyframes daarom omgekeerd (van W − stap − L naar −stap − L) met iterationStart 1 − (L + stap) / W: op
     t = 0 weer exact transform 0, en een kaart springt nu links buiten beeld terug naar rechts buiten beeld. */
  function bouwMarquee() {
    var wraps = [].slice.call(groep.children);
    var stap = wraps[0].getBoundingClientRect().width + gapNu(), W = stap * wraps.length;
    var naarLinks = !mqGroot.matches;
    stapNu = stap;
    anims = wraps.map(function (w, i) {
      var L = i * stap, fase = (L + stap) / W;
      var a = { transform: 'translateX(' + (-stap - L) + 'px)' }, b = { transform: 'translateX(' + (W - stap - L) + 'px)' };
      return w.animate(
        naarLinks ? [b, a] : [a, b],
        { duration: (W / snelheid()) * 1000, iterations: Infinity, iterationStart: naarLinks ? 1 - fase : fase, easing: 'linear' }
      );
    });
  }
  /* verbeter 29-09 A7: < 990 kan de bezoeker de rail zelf vegen (overflow-x: auto). Gaat de marquee (weer) lopen, dan wordt
     die veegafstand s looptijd: alle kaarten schuiven s px verder (s / snelheid seconden) en de scroll gaat in dezelfde
     frame terug naar 0. Hetzelfde beeld, maar de cyclus klopt weer. Zonder dit dook na ver vegen elke cyclusstap een kaart
     midden in beeld op (gemeten op scrollLeft 1503: kaart van −1716 naar 146 px, lege strook tot 229 px). */
  function veegOmzetten() {
    var s = rail.scrollLeft;
    if (mqGroot.matches || anims === null || s < 1) return;
    var dt = s / snelheid() * 1000;
    anims.forEach(function (a) { a.currentTime = (a.currentTime || 0) + dt; });
    rail.scrollLeft = 0;
  }
  function bijwerken() {
    if (magLopen()) {
      if (anims === null) { bouwMarquee(); veegOmzetten(); }
      else if (anims[0].playState === 'paused') { veegOmzetten(); anims.forEach(function (a) { a.play(); }); }
    } else if (anims !== null && anims[0].playState === 'running') {
      anims.forEach(function (a) { a.pause(); });
    }
  }
  /* Een andere kaartmaat (venster door een breekpunt) = de cyclus opnieuw opbouwen. Verbeter 29-09 A7: ook bij het
     oversteken van 990 (andere snelheid, richting en gap); dan zonder stap-vergelijking (`forceer` true of een
     MediaQueryList(Event), herkenbaar aan zijn boolean `matches`). De opbouw begint op de layoutposities, dus een
     mobiele veegafstand gaat mee terug naar 0 (op ≥ 990 is de rail overflow: hidden en anders al 0). */
  function herbouw(forceer) {
    if (anims === null) return;
    var geforceerd = forceer === true || !!(forceer && typeof forceer.matches === 'boolean');
    var stap = groep.children[0].getBoundingClientRect().width + gapNu();
    if (!geforceerd && Math.abs(stap - stapNu) < 0.5) return;
    var liep = anims[0].playState === 'running';
    anims.forEach(function (a) { a.cancel(); }); anims = null;
    rail.scrollLeft = 0;
    if (liep) bijwerken();
  }
  window.addEventListener('resize', herbouw);
  /* Over 990 wisselt ook de videoregel (≥ 990 elke kaart ≥ 50 %, < 990 één): meteen opnieuw kiezen, niet wachten
     tot een kaart een IO-drempel passeert. */
  function breedteWissel(e) {
    herbouw(e);
    /* fixronde 1: ≥ 990 geen kaart-knoppen en geen zelf gestarte video's (fase 5: klik = stil/verder); < 990 weer knoppen (J72). */
    if (mqGroot.matches && !geenAuto) handTerug();
    kaarten.forEach(function (k, i) { if (k.getAttribute('data-video-url') && !k.querySelector('video[data-bv2-hand]')) kaartKnop(k, i, geenAuto || !mqGroot.matches); });
    if (beweging.stilVoorVideo()) allesPauzeren(); else zichtbareHervatten();
  }
  if (mqGroot.addEventListener) mqGroot.addEventListener('change', breedteWissel); else if (mqGroot.addListener) mqGroot.addListener(breedteWissel);
  /* fixronde 1: een zelf gestarte video (`data-bv2-hand`) laat dit met rust: een veeg, focus of "minder beweging" zet de band
     stil, niet de video die de bezoeker net met geluid startte (die heeft zijn eigen bediening). */
  function allesPauzeren() { kaarten.forEach(function (k) { var v = k.querySelector('video'); if (v && !v.paused && !v.hasAttribute('data-bv2-hand')) v.pause(); }); }
  function zichtbareHervatten() {
    if (!mqGroot.matches) { kiesMob(); return; } /* verbeter 29-09 A7: < 990 hoogstens één video */
    kaarten.forEach(function (k) {
      var v = k.querySelector('video');
      if (v && v.hasAttribute('data-bv2-aan-de-beurt') && inBeeld(k)) speel(v);
    });
  }

  new IntersectionObserver(function (e) {
    zichtbaar = e[e.length - 1].isIntersecting;
    if (zichtbaar && !startklok) startklok = setTimeout(magNuStarten, 1000);
    bijwerken();
  }, { threshold: 0.05 }).observe(rail);
  rail.addEventListener('focusin', function (e) {
    var toets = false; try { toets = e.target.matches(':focus-visible'); } catch (x) {}
    if (!toets) { var was = rail.scrollLeft; setTimeout(function () { rail.scrollLeft = was; }, 0); }
    /* fixronde 1: < 990 zijn de kaarten knoppen. In de schuivende cyclus kan een kaart met toetsenbordfocus links van het
       scroll-begin staan, waar geen scroll komt (gemeten: soms maar 20-24 % tussen de fades; J72 statisch: 53 %). Bij
       toetsenbordfocus staat de band toch stil (mechanisme 2), dus de cyclus terug naar t = 0 (elke kaart op zijn layoutplek,
       geen DOM-rotatie, h177) en de kaart volledig tussen de fades (24 px + 8). Bij hervatten wordt die scroll looptijd. */
    var kaart = toets && (geenAuto || !mqGroot.matches) && e.target.closest ? e.target.closest('[data-bv2-ugc-video]') : null; /* review golf 1 M-3: ook ≥ 990 zodra de kaarten knoppen zijn (geen autoplay) */
    if (kaart && anims !== null) {
      anims.forEach(function (a) { a.currentTime = 0; });
      var r = kaart.getBoundingClientRect(), rr = rail.getBoundingClientRect(), rand = 32;
      if (r.left < rr.left + rand) rail.scrollLeft -= rr.left + rand - r.left;
      else if (r.right > rr.right - rand) rail.scrollLeft += r.right - (rr.right - rand);
    }
    bijwerken();
  });
  /* verbeter 29-09 A7: de terugzet naar 0 alleen ≥ 990. < 990 is de scrollpositie van de bezoeker (vegen); die wordt bij
     hervatten looptijd (`veegOmzetten`) in plaats van hier weggegooid (gemeten: tik + veeg 300 + tik ernaast = sprong van 300 px). */
  rail.addEventListener('focusout', function () { setTimeout(function () { if (mqGroot.matches && !rail.contains(document.activeElement)) rail.scrollLeft = 0; bijwerken(); }, 0); });
  bijwerken();
})();

/* ---------- setup: hotspot-popovers (Task 8) ----------
 * button[aria-expanded][aria-controls] -> popover; Esc sluit + focus terug naar
 * het punt, klik buiten sluit, maar één popover tegelijk open per sectie. */
(function () {
  'use strict';
  var secties = [].slice.call(document.querySelectorAll('[data-band="setup"]'));
  secties.forEach(function (sectie) {
    var punten = [].slice.call(sectie.querySelectorAll('[data-bv2-setup-punt]'));
    if (!punten.length) return;
    /* mobiel J74 (spec §3.8/§2.10): live breedtepoort; < 990 is dit een productpaneel, geen popover. */
    var mqS = window.matchMedia('(min-width: 990px)');

    function sluiten(knop) {
      knop.setAttribute('aria-expanded', 'false');
      var popover = document.getElementById(knop.getAttribute('aria-controls'));
      if (popover) popover.hidden = true;
    }
    function alleSluiten(behalve) {
      punten.forEach(function (b) { if (b !== behalve) sluiten(b); });
    }
    function openen(knop) {
      alleSluiten(knop);
      knop.setAttribute('aria-expanded', 'true');
      var popover = document.getElementById(knop.getAttribute('aria-controls'));
      if (popover) popover.hidden = false;
    }

    punten.forEach(function (knop) {
      knop.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = knop.getAttribute('aria-expanded') === 'true';
        if (open) sluiten(knop); else openen(knop);
      });
    });

    document.addEventListener('click', function (e) {
      if (!mqS.matches) return; /* J74: < 990 sluit een klik buiten het paneel niet */
      punten.forEach(function (knop) {
        if (knop.getAttribute('aria-expanded') !== 'true') return;
        var wrap = knop.closest('[data-bv2-setup-punt-wrap]');
        if (wrap && !wrap.contains(e.target)) sluiten(knop);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (!mqS.matches) return; /* J74: < 990 sluit Escape het paneel niet */
      punten.forEach(function (knop) {
        if (knop.getAttribute('aria-expanded') === 'true') { sluiten(knop); knop.focus(); }
      });
    });

    /* mobiel J74: < 990 altijd precies één product open (standaard hotspot 1), in een vast paneel onder
       de foto (CSS); ‹ › lopen in template-volgorde; de hotspot draagt aria-pressed. De live-regio meldt
       alleen een wissel door de bezoeker (niet bij het laden). Over de 990-grens (live, change-listener):
       ≥ 990 alles dicht, aria-pressed weg, popover-rol terug; < 990 weer het laatst actieve product. */
    var live = sectie.querySelector('[data-bv2-setup-live]');
    function actief(n, melden) {
      punten.forEach(function (b, i) { b.setAttribute('aria-pressed', String(i === n)); if (i === n) openen(b); });
      sectie.setAttribute('data-actief', String(n));
      if (melden && live) {
        var pop = document.getElementById(punten[n].getAttribute('aria-controls'));
        var t = pop && pop.querySelector('.bv2-setup__popover-titel'), pr = pop && pop.querySelector('.bv2-setup__popover-huidig');
        live.textContent = (t ? t.textContent.trim() : '') + (pr ? ', ' + pr.textContent.trim() : '');
      }
    }
    function huidig() { var n = Number(sectie.getAttribute('data-actief') || 0); return n >= 0 && n < punten.length ? n : 0; }
    function rollen(rol) {
      punten.forEach(function (b) { var pop = document.getElementById(b.getAttribute('aria-controls')); if (pop) pop.setAttribute('role', rol); });
    }
    function mobielStart() {
      if (!mqS.matches) { rollen('group'); actief(huidig(), false); }
      else { punten.forEach(function (b) { b.removeAttribute('aria-pressed'); sluiten(b); }); rollen('dialog'); if (live) live.textContent = ''; }
    }
    var vor = sectie.querySelector('[data-bv2-setup-vorige]'), vol = sectie.querySelector('[data-bv2-setup-volgende]');
    if (vor) vor.addEventListener('click', function () { actief((huidig() - 1 + punten.length) % punten.length, true); });
    if (vol) vol.addEventListener('click', function () { actief((huidig() + 1) % punten.length, true); });
    /* capture op het eigen element: draait vóór de toggle-listener hierboven; stopImmediatePropagation
       voorkomt dat die toggle het net geopende product weer sluit (alleen < 990). */
    punten.forEach(function (b, i) {
      b.addEventListener('click', function (e) { if (!mqS.matches) { e.stopImmediatePropagation(); actief(i, true); } }, true);
    });
    if (mqS.addEventListener) mqS.addEventListener('change', mobielStart);
    else if (mqS.addListener) mqS.addListener(mobielStart);
    mobielStart();
  });
})();

/* ---------- slot: knop scrollt naar het koopblok + focust de eerste kiezer (Task 10) ----------
 * href="#bv2-koopblok" blijft de progressive-enhancement-basis (werkt zonder JS, ook
 * middelklik/nieuw-tabblad); hier alleen preventDefault + eigen smooth-scroll zodra het
 * doel echt bestaat, zodat een kapotte/ontbrekende ankerdoel (bv. sectie losstaand in de
 * theme-editor) terugvalt op de standaard hash-navigatie i.p.v. stil niets te doen.
 *
 * Herstelronde 1 (orchestrator-review, Important): `[data-bv2-optie="0"]` was een
 * verkeerde aanname — index 0 is de Maat/Afmeting-optie (custom-bureau-v2-koopblok.liquid
 * r32-42: mi=0/bi=1/fi=2 als default, herlezen uit de echte optienamen), maar de DOM-
 * volgorde van de kiezers is de hiërarchie Blad → Frame → Maat (r187, `volgorde()`), dus
 * dat focuste de LAATSTE kiezer i.p.v. de eerste. Fix: de eerste `[data-bv2-optie]` in
 * documentvolgorde (geen indexnummer), en daarbinnen de eerste bedienbare knop (niet
 * aria-disabled="true" — deze knoppen zijn nooit native `disabled`, dus altijd
 * focusbaar, maar "bedienbaar" bedoelt hier een knop die ook echt een variant oplevert;
 * met een fallback op de allereerste knop mocht de hele groep onverhoopt dicht staan). */
(function () {
  'use strict';
  var knoppen = [].slice.call(document.querySelectorAll('[data-bv2-slot-knop]'));
  if (!knoppen.length) return;
  knoppen.forEach(function (knop) {
    knop.addEventListener('click', function (e) {
      var doel = document.querySelector('#bv2-koopblok');
      if (!doel) return;
      e.preventDefault();
      var rustig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      doel.scrollIntoView({ behavior: rustig ? 'auto' : 'smooth', block: 'start' });
      var eersteGroep = doel.querySelector('[data-bv2-optie]');
      var eersteKiezer = null;
      if (eersteGroep) {
        var knoppenInGroep = [].slice.call(eersteGroep.querySelectorAll('button[data-bv2-waarde]'));
        eersteKiezer = knoppenInGroep.filter(function (b) { return b.getAttribute('aria-disabled') !== 'true'; })[0] || knoppenInGroep[0];
      }
      if (eersteKiezer) {
        setTimeout(function () { eersteKiezer.focus({ preventScroll: true }); }, rustig ? 0 : 450);
      }
    });
  });
})();

/* ---------- fase 5 J52: Trustpilot-regel in het koopblok → de reviewband op deze pagina ----------
 * De regel "4,7 · N reviews" is een interne link (#bv2-reviews, zelfde anker als de ankernav). Zacht
 * scrollen; bij minder beweging direct ('instant', niet 'auto': Symmetry zet scroll-behavior smooth op
 * html, h185). De landingshoogte onder header + vaste ankernav komt van scroll-margin-top op de band
 * (CSS). Daarna focus op de reviewkop (tabindex -1, preventScroll) zodat toetsenbord en schermlezer
 * meeverhuizen. De sitewide snippet-klik (findReviews) vindt op deze pagina geen doel en doet niets.
 * Fix-ronde 1: stopPropagation, want Symmetry's `internalLinksSmoothScroll` (document-click, main.js)
 * scrolde daarna alsnog zacht naar elTop − 100 − header (band op 170 i.p.v. onder de nav op 132), ook
 * bij minder beweging; en na de eerste Tab haalt het thema die handler weg, dus het gedrag hing ervan af
 * of de bezoeker al getabd had. Nu één pad: scroll-margin van de band, direct bij minder beweging. */
(function () {
  'use strict';
  var a = document.querySelector('[data-band="koopblok"] a.stp[href="#bv2-reviews"]'), doel = document.getElementById('bv2-reviews');
  if (!a || !doel) return;
  a.addEventListener('click', function (e) {
    e.preventDefault(); e.stopPropagation();
    var rustig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    doel.scrollIntoView({ behavior: rustig ? 'instant' : 'smooth', block: 'start' });
    var kop = doel.querySelector('h2') || doel;
    if (!kop.hasAttribute('tabindex')) kop.setAttribute('tabindex', '-1');
    setTimeout(function () { kop.focus({ preventScroll: true }); }, rustig ? 0 : 600);
  });
})();

/* ---------- fase 3 J14: autoplay-video's zonder geluid, in een lus, alleen in beeld ----------
 * Contract: [data-bv2-autoplay][data-video-url] met een poster-<img>, binnen een `section[data-band]`
 * waarvan het eerste kind de snippet custom-bureau-v2-beweging-stop is.
 * Banden: beeldtitel, bediening, kaart "Stabiel op elke hoogte" en de film-band. Dit is het enige
 * videomechaniek van de pagina (de oude klik-om-te-spelen-IIFE is in fase 4 T11 verwijderd).
 * - Geen <video> in de initiële DOM; hij ontstaat bij de eerste intersect (rootMargin 200px),
 *   met preload="none", zodat een bezoeker die nooit zo ver scrollt ook nooit bytes betaalt.
 * - Buiten beeld pauzeren, terug in beeld hervatten — tenzij `beweging.stil()`.
 * - Fase 5 J49: geen zichtbare pauze-/afspeelknop meer. Eén `bv2Beweging` per band (hover,
 *   toetsenbordfocus, klik op de video, verborgen stopknop, live "minder beweging"). Rail = het
 *   vak zelf; staan er ooit meerdere vakken in één band, dan is de band de rail, zodat één
 *   stopknop en één toestand alle video's van die band bedienen.
 * - prefers-reduced-motion: reduce bij laden -> nooit autoplay en geen stopknop (er beweegt niets);
 *   het vak zelf is dan de knop (`bv2SpeelBijKlik`, geen icoon-overlay): klik = video met controls,
 *   zonder loop. Zet de bezoeker "minder beweging" tijdens het bezoek UIT, dan blijft het bij die
 *   terugval tot herladen (zelfde grens als de reviews-marquee, AFWIJKINGEN #140).
 * - Fase 5 J48 (spec §3.7), alleen voor vakken met de attributen (vandaag: beeldtitel):
 *   `data-eenmalig="true"` = geen lus; na `ended` krijgt het vak `data-klaar` en blijft de video op
 *   het laatste frame staan: geen load()/currentTime-reset, en `speel()` doet dan niets meer, dus
 *   IO-terugkeer, hover-weg, tweede klik of "minder beweging" uit herstarten hem nooit. Is elk vak
 *   van de band klaar, dan verdwijnen de stopknop en zijn status (er beweegt niets meer: WCAG 2.2.2
 *   geldt alleen tijdens het spelen). `data-tempo` = defaultPlaybackRate + playbackRate, gezet bij
 *   aanmaak, `loadedmetadata` en elke `play` (sommige browsers zetten playbackRate terug bij het
 *   laden). `data-eindposter` + "minder beweging" bij laden = geen video en geen klik-om-te-spelen,
 *   alleen die eindposter in de poster-<img>. */
(function () {
  'use strict';
  var vakken = [].slice.call(document.querySelectorAll('[data-bv2-autoplay]'));
  if (!vakken.length) return;
  var rustig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var kanAuto = !rustig && 'IntersectionObserver' in window;
  var perBand = [];
  vakken.forEach(function (vak) {
    var band = vak.closest('[data-band]') || vak, g = null;
    perBand.forEach(function (x) { if (x.band === band) g = x; });
    if (!g) { g = { band: band, vakken: [], spelers: [] }; perBand.push(g); }
    g.vakken.push(vak);
  });
  perBand.forEach(function (g) {
    var beweging = null;
    if (kanAuto) {
      beweging = window.bv2Beweging(g.band, {
        rail: g.vakken.length === 1 ? g.vakken[0] : g.band,
        opWissel: function (stil) { g.spelers.forEach(function (sp) { sp.opWissel(stil); }); }
      });
    }
    g.vakken.forEach(function (vak) { g.spelers.push(speler(vak, beweging, g)); });
  });

  /* J48: alle vakken van de band klaar (eenmalig + ended) → de stopknop en zijn status weg. Heeft
   * de knop op dat moment focus, dan pas bij blur, zodat een toetsenbordgebruiker niet plots op
   * <body> belandt. */
  function bandKlaar(g) {
    if (g.vakken.some(function (x) { return x.getAttribute('data-klaar') !== 'true'; })) return;
    var knop = g.band.querySelector('[data-bv2-beweging-stop]');
    var status = g.band.querySelector('[data-bv2-beweging-status]');
    if (status) status.textContent = '';
    if (!knop || knop.hidden) return;
    var weg = function () { knop.hidden = true; };
    if (document.activeElement === knop) knop.addEventListener('blur', weg, { once: true });
    else weg();
  }

  function speler(vak, beweging, g) {
    var video = null;
    var inBeeld = false;
    var handmatig = false; /* BUG 30-09: true zodra de browser autoplay blokkeert (bv2Autoplay) */
    var eenmalig = vak.getAttribute('data-eenmalig') === 'true';
    /* verbeter 29-09 A8: tempo per breedte (data-tempo-mobiel < 990), live bij het oversteken van 990 */
    var mqTempo = window.matchMedia('(max-width: 989px)');
    var tempoVoor = function () { var m = vak.getAttribute('data-tempo-mobiel'); return (mqTempo.matches && m ? Number(m) : Number(vak.getAttribute('data-tempo'))) || 1; };
    var tempo = tempoVoor();
    /* 02-10 (Jory): brede desktopvideo (2,4:1) vanaf 990 px. Gekozen bij het aanmaken van de video (en bij
       "minder beweging" bij laden); wie daarna over 990 schuift houdt de gekozen video, `object-fit: cover`
       vangt de andere verhouding op. Zonder `data-video-url-desktop` exact het oude gedrag. */
    var breed = !!vak.getAttribute('data-video-url-desktop') && window.matchMedia('(min-width: 990px)').matches;
    var eindposter = (breed && vak.getAttribute('data-eindposter-desktop')) || vak.getAttribute('data-eindposter');
    /* fase 6 J65 (spec §3.8, controllerbesluit ná R8): alleen de beeldtitel-band krijgt de vroege-load +
       50%-gate. Bediening/kaarten/film blijven exact het oude gedrag (preload='none', één IO met
       rootMargin 200px en direct play()) — anders is 'auto' 200 px vooruit op de film (2,7 MB) een
       bytes-regressie tegen de snelheidsronde (J66) die Jory niet vroeg. */
    var isBeeldtitel = !!vak.closest('[data-band="beeldtitel"]');
    function klaar() { return vak.getAttribute('data-klaar') === 'true'; }
    function maak() {
      var url = (breed && vak.getAttribute('data-video-url-desktop')) || vak.getAttribute('data-video-url');
      if (!url) return null;
      var poster = vak.querySelector('img');
      var v = document.createElement('video');
      v.className = 'bv2-video__media';
      v.preload = isBeeldtitel ? 'auto' : 'none'; /* J65: alleen beeldtitel al klaar zodra IO-A 'm maakt */
      v.muted = true;
      v.playsInline = true;
      v.loop = kanAuto && !eenmalig;
      v.controls = !kanAuto;
      /* Attributen náást de properties: `muted`/`playsinline` als attribuut is wat iOS Safari
         leest vóór het eerste play()-verzoek, anders weigert die het autoplay-beleid. */
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      if (v.loop) v.setAttribute('loop', '');
      var zetTempo = function () { tempo = tempoVoor(); v.defaultPlaybackRate = tempo; v.playbackRate = tempo; };
      if (mqTempo.addEventListener) mqTempo.addEventListener('change', zetTempo); else if (mqTempo.addListener) mqTempo.addListener(zetTempo);
      zetTempo();
      v.addEventListener('loadedmetadata', zetTempo);
      v.addEventListener('play', zetTempo);
      if (eenmalig && kanAuto) {
        v.addEventListener('ended', function () {
          vak.setAttribute('data-klaar', 'true'); /* is-speelt blijft: anders komt de laadposter (frame 0) terug */
          bandKlaar(g);
        });
      }
      v.setAttribute('aria-label', vak.getAttribute('data-video-label') || 'Productvideo');
      if (poster) v.poster = poster.currentSrc || poster.src;
      v.src = url;
      v.addEventListener('playing', function () { vak.classList.add('is-speelt'); });
      vak.insertBefore(v, vak.firstChild);
      video = v;
      return v;
    }
    function speel() {
      if (klaar() || handmatig) return; /* J48: eenmalig en al afgelopen → blijft op het laatste frame; BUG 30-09: handmatig = alleen op klik */
      if (!video) maak();
      if (!video) return;
      window.bv2Autoplay.speel(video);
    }
    /* J48: "minder beweging" + eindposter → alleen het laatste frame, geen video en geen knop */
    if (rustig && eindposter) {
      var img = vak.querySelector('img');
      [].forEach.call(vak.querySelectorAll('picture > source'), function (s) { s.parentNode.removeChild(s); }); /* anders wint de desktopposter van <picture> */
      if (img) { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = eindposter; }
      vak.setAttribute('data-klaar', 'true'); /* eindtoestand: niets te spelen, geen klik-cursor */
      return { opWissel: function () {} };
    }
    /* terugval: geen autoplay, het vak is de knop */
    if (!kanAuto) {
      window.bv2SpeelBijKlik(vak, maak);
      return { opWissel: function () {} };
    }
    if (isBeeldtitel) {
      /* fase 6 J65: IO-A laadt vooruit (200 px) en maakt de video alvast (preload='auto', geen play());
         IO-B speelt pas als het vak zelf voor ≥ 50 % zichtbaar is. Drempel meestal 0,5; is het vak ooit
         hoger dan 2× het scherm, dan de schermvullende variant (spec §3.8-terugval). */
      var voorIO = new IntersectionObserver(function (entries) {
        if (entries[entries.length - 1].isIntersecting) { if (!video && !klaar()) maak(); voorIO.disconnect(); }
      }, { rootMargin: '200px 0px' });
      voorIO.observe(vak);
      var drempel = Math.min(0.5, (window.innerHeight / Math.max(1, vak.getBoundingClientRect().height)) * 0.9);
      new IntersectionObserver(function (entries) {
        /* Nazorg eindreview: laatste entry = meest recente waarneming (zie de marquee-IO). */
        var e = entries[entries.length - 1];
        inBeeld = e.isIntersecting && e.intersectionRatio >= drempel - 0.001;
        if (inBeeld && !beweging.stil()) speel();
        else if (video && !video.paused) video.pause();
      }, { threshold: [0, drempel] }).observe(vak);
    } else {
      /* ongewijzigd t.o.v. vóór J65: rootMargin 200px, drempel 0, direct speel()/pause(). */
      new IntersectionObserver(function (entries) {
        /* Nazorg eindreview: laatste entry = meest recente waarneming (zie de marquee-IO). */
        inBeeld = entries[entries.length - 1].isIntersecting;
        if (inBeeld && !beweging.stil()) speel();
        else if (video && !video.paused) video.pause();
      }, { rootMargin: '200px 0px' }).observe(vak);
    }
    /* fase 6 Task 4b (regressie J65, Ruling T4b): de verborgen stopknop scrollt bij focus de band
       onder de 50%-drempel van IO-B (Task 12b-diagnose); `inBeeld` is dan al `false` vóórdat de
       gebruiker "hervatten" indrukt. Ruling: de 50%-drempel geldt alleen voor de automatische
       eerste start — een gebruikersgestarte hervatting speelt zodra de band zelf nog zichtbaar is
       (intersectionRatio > 0, zoals bediening/kaarten al doen via hun soepele IO). `zichtbaarNu()`
       is een verse rect-toets tegen het scherm i.p.v. de laatste IO-snapshot. Ná het hervatten blijft
       IO-B zelf de wacht houden: scrolt de band alsnog onder 50 %, dan pauzeert de bestaande
       callback (hierboven) hem weer — ongewijzigd. */
    function zichtbaarNu() {
      var r = vak.getBoundingClientRect();
      var h = window.innerHeight || document.documentElement.clientHeight;
      return r.bottom > 0 && r.top < h;
    }
    /* BUG 30-09 (AFWIJKINGEN #206): blokkeert de browser autoplay, dan wordt dit vak klik-om-af-te-spelen, precies als de terugval
       bij "minder beweging" hierboven (bv2SpeelBijKlik: klik = video met bediening, zonder lus). De verborgen stopknop van de band
       verdwijnt (er beweegt niets meer vanzelf) en de band-toestand (hover/focus/klik) raakt de video niet meer: die bedient de
       bezoeker zelf. */
    window.bv2Autoplay.opGeblokkeerd(function () {
      handmatig = true;
      if (video) { video.pause(); video.loop = false; video.removeAttribute('loop'); }
      var knop = g.band.querySelector('[data-bv2-beweging-stop]'), status = g.band.querySelector('[data-bv2-beweging-status]');
      if (knop && document.activeElement !== knop) knop.hidden = true;
      if (status) status.textContent = '';
      window.bv2SpeelBijKlik(vak, function () { return video || maak(); });
    });
    return {
      opWissel: function (stil) {
        if (handmatig) return;
        if (stil) { if (video && !video.paused) video.pause(); }
        else if (isBeeldtitel ? zichtbaarNu() : inBeeld) speel();
      }
    };
  }
})();

/* ---------- vergelijking: tooltip-knop bij "Andere merken" (Task 9-vervolg) ----------
 * button[aria-expanded][aria-describedby] -> verborgen tekstpaneel, zelfde disclosure-
 * mechaniek als de setup-hotspots hierboven (klik toggelt, Esc + klik-buiten sluit). */
(function () {
  'use strict';
  var knoppen = [].slice.call(document.querySelectorAll('[data-bv2-tooltip]'));
  if (!knoppen.length) return;

  function paneel(knop) { return document.getElementById(knop.getAttribute('aria-describedby')); }
  function sluiten(knop) {
    knop.setAttribute('aria-expanded', 'false');
    var p = paneel(knop);
    if (p) p.hidden = true;
  }
  function openen(knop) {
    knoppen.forEach(function (b) { if (b !== knop) sluiten(b); });
    knop.setAttribute('aria-expanded', 'true');
    var p = paneel(knop);
    if (p) p.hidden = false;
  }

  knoppen.forEach(function (knop) {
    knop.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = knop.getAttribute('aria-expanded') === 'true';
      if (open) sluiten(knop); else openen(knop);
    });
  });
  document.addEventListener('click', function (e) {
    knoppen.forEach(function (knop) {
      if (knop.getAttribute('aria-expanded') !== 'true') return;
      if (!knop.parentNode.contains(e.target)) sluiten(knop);
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    knoppen.forEach(function (knop) {
      if (knop.getAttribute('aria-expanded') === 'true') { sluiten(knop); knop.focus(); }
    });
  });
})();

/* ---------- fase 3 J20: één zachte reveal per band, eenmalig; banden al in beeld bij laden slaan over ----------
 * Het script staat op `defer`, dus de hele DOM bestaat hier al (de bandsecties na de koopblok
 * ook). Eén observer voor alle banden, `unobserve` na de eerste keer: geen stagger per kaart,
 * geen herhaling bij terugscrollen (MOTION-GIDS §6 / SPEC §3.7).
 *
 * De verborgen beginstand hangt aan `.bv2-js`, die HIER wordt gezet — niet aan `.js`, want die
 * zet Symmetry zelf in een blokkerend head-script (theme.liquid r176) los van dit bestand. Zou
 * `.js` de poort zijn, dan verbergt de CSS de 13 banden vanaf de eerste paint terwijl alleen deze
 * IIFE ze weer kan tonen; een onafgevangen fout eerder in dit bestand (of een 404 op de asset)
 * zou ze dan permanent onzichtbaar maken. Nu geldt: staat `.bv2-js` er, dan draait de code die
 * hem ook weer opheft. De klasse gaat er daarom vóór de terugval-guard hieronder op, zodat ook de
 * mobiele/rustige tak langs `is-in` komt in plaats van de verborgen staat te laten hangen.
 * R-V: desktop-only (≥ 990 px), net als de reviews-marquee van T7 — mobiel volgt later. */
(function () {
  'use strict';
  /* Nazorg eindreview: een sectie die de theme-editor opnieuw rendert komt terug ZONDER
     `is-in`, terwijl `html.bv2-js` al staat — die band bleef dan op `opacity: 0` tot een
     refresh. Twee maatregelen, allebei ES5:
     1. In de editor doen we helemaal niet mee: geen `bv2-js`, dus de CSS-default (zichtbaar)
        geldt daar. Een reveal is in de editor toch zinloos en `Shopify.designMode` is de
        enige betrouwbare marker (er is geen bandscript per sectie meer, zie h169).
     2. Buiten de editor vangt `shopify:section:load` een herrenderde sectie alsnog op en zet
        `is-in` op elke reveal-band erin. Kost niets als het event nooit vuurt. */
  if (window.Shopify && window.Shopify.designMode) return;
  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target || !e.target.querySelectorAll) return;
    [].slice.call(e.target.querySelectorAll('[data-bv2-reveal]')).forEach(function (b) { b.classList.add('is-in'); });
  });
  var banden = [].slice.call(document.querySelectorAll('[data-bv2-reveal]'));
  if (!banden.length) return;
  document.documentElement.classList.add('bv2-js');
  var rustig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var desktop = window.matchMedia('(min-width: 990px)').matches;
  if (rustig || !desktop || !('IntersectionObserver' in window)) { banden.forEach(function (b) { b.classList.add('is-in'); }); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
  banden.forEach(function (b) {
    if (b.getBoundingClientRect().top < window.innerHeight) b.classList.add('is-in'); /* geen flits boven de vouw */
    else io.observe(b);
  });
})();

} /* einde eenmalige uitvoering — zie de guard bovenaan */
